/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActivityBlock = {
  __typename?: 'ActivityBlock';
  awards: Scalars['Int']['output'];
  mayor?: Maybe<Scalars['String']['output']>;
  mayorHash?: Maybe<Scalars['ID']['output']>;
  municipalityKey: Scalars['ID']['output'];
  municipalityName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<Scalars['String']['output']>;
  partyFamily?: Maybe<Scalars['String']['output']>;
  partyKey?: Maybe<Scalars['ID']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  uic: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type ActivityBlockAggregateSelection = {
  __typename?: 'ActivityBlockAggregateSelection';
  awards: IntAggregateSelection;
  count: Scalars['Int']['output'];
  mayor: StringAggregateSelection;
  mayorHash: IdAggregateSelection;
  municipalityKey: IdAggregateSelection;
  municipalityName: StringAggregateSelection;
  name: StringAggregateSelection;
  party: StringAggregateSelection;
  partyFamily: StringAggregateSelection;
  partyKey: IdAggregateSelection;
  province: StringAggregateSelection;
  uic: IdAggregateSelection;
  value: FloatAggregateSelection;
};

export type ActivityBlockEdge = {
  __typename?: 'ActivityBlockEdge';
  cursor: Scalars['String']['output'];
  node: ActivityBlock;
};

export type ActivityBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ActivityBlockSort objects to sort ActivityBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ActivityBlockSort>>;
};

/** Fields to sort ActivityBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one ActivityBlockSort object. */
export type ActivityBlockSort = {
  awards?: InputMaybe<SortDirection>;
  mayor?: InputMaybe<SortDirection>;
  mayorHash?: InputMaybe<SortDirection>;
  municipalityKey?: InputMaybe<SortDirection>;
  municipalityName?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  party?: InputMaybe<SortDirection>;
  partyFamily?: InputMaybe<SortDirection>;
  partyKey?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ActivityBlockWhere = {
  AND?: InputMaybe<Array<ActivityBlockWhere>>;
  NOT?: InputMaybe<ActivityBlockWhere>;
  OR?: InputMaybe<Array<ActivityBlockWhere>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mayor?: InputMaybe<Scalars['String']['input']>;
  mayorHash?: InputMaybe<Scalars['ID']['input']>;
  mayorHash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  mayorHash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mayorHash_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorHash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorHash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorHash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorHash_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorHash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mayorHash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mayor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mayor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayor_GT?: InputMaybe<Scalars['String']['input']>;
  mayor_GTE?: InputMaybe<Scalars['String']['input']>;
  mayor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mayor_LT?: InputMaybe<Scalars['String']['input']>;
  mayor_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityKey?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  municipalityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  municipalityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityName_GT?: InputMaybe<Scalars['String']['input']>;
  municipalityName_GTE?: InputMaybe<Scalars['String']['input']>;
  municipalityName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  municipalityName_LT?: InputMaybe<Scalars['String']['input']>;
  municipalityName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  partyFamily?: InputMaybe<Scalars['String']['input']>;
  partyFamily_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  partyFamily_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  partyFamily_GT?: InputMaybe<Scalars['String']['input']>;
  partyFamily_GTE?: InputMaybe<Scalars['String']['input']>;
  partyFamily_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partyFamily_LT?: InputMaybe<Scalars['String']['input']>;
  partyFamily_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyFamily_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyFamily_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyFamily_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyFamily_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyFamily_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  partyFamily_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  partyKey?: InputMaybe<Scalars['ID']['input']>;
  partyKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  partyKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  partyKey_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  partyKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  party_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  party_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_GT?: InputMaybe<Scalars['String']['input']>;
  party_GTE?: InputMaybe<Scalars['String']['input']>;
  party_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  party_LT?: InputMaybe<Scalars['String']['input']>;
  party_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  province_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_GT?: InputMaybe<Scalars['String']['input']>;
  province_GTE?: InputMaybe<Scalars['String']['input']>;
  province_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  province_LT?: InputMaybe<Scalars['String']['input']>;
  province_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ActivityBlocksConnection = {
  __typename?: 'ActivityBlocksConnection';
  edges: Array<ActivityBlockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityMap = {
  __typename?: 'ActivityMap';
  blocks: Array<ActivityBlock>;
  companies: Scalars['Int']['output'];
  partners: Array<ActivityPartner>;
  seedLabel?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
};

export type ActivityMapAggregateSelection = {
  __typename?: 'ActivityMapAggregateSelection';
  companies: IntAggregateSelection;
  count: Scalars['Int']['output'];
  seedLabel: StringAggregateSelection;
};

export type ActivityMapEdge = {
  __typename?: 'ActivityMapEdge';
  cursor: Scalars['String']['output'];
  node: ActivityMap;
};

export type ActivityMapOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ActivityMapSort objects to sort ActivityMaps by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ActivityMapSort>>;
};

/** Fields to sort ActivityMaps by. The order in which sorts are applied is not guaranteed when specifying many fields in one ActivityMapSort object. */
export type ActivityMapSort = {
  companies?: InputMaybe<SortDirection>;
  seedLabel?: InputMaybe<SortDirection>;
  truncated?: InputMaybe<SortDirection>;
};

export type ActivityMapWhere = {
  AND?: InputMaybe<Array<ActivityMapWhere>>;
  NOT?: InputMaybe<ActivityMapWhere>;
  OR?: InputMaybe<Array<ActivityMapWhere>>;
  companies?: InputMaybe<Scalars['Int']['input']>;
  companies_GT?: InputMaybe<Scalars['Int']['input']>;
  companies_GTE?: InputMaybe<Scalars['Int']['input']>;
  companies_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  companies_LT?: InputMaybe<Scalars['Int']['input']>;
  companies_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  seedLabel?: InputMaybe<Scalars['String']['input']>;
  seedLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  seedLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  seedLabel_GT?: InputMaybe<Scalars['String']['input']>;
  seedLabel_GTE?: InputMaybe<Scalars['String']['input']>;
  seedLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seedLabel_LT?: InputMaybe<Scalars['String']['input']>;
  seedLabel_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seedLabel_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seedLabel_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seedLabel_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seedLabel_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seedLabel_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  seedLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  truncated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  truncated_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityMapsConnection = {
  __typename?: 'ActivityMapsConnection';
  edges: Array<ActivityMapEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityPartner = {
  __typename?: 'ActivityPartner';
  name?: Maybe<Scalars['String']['output']>;
  otherName?: Maybe<Scalars['String']['output']>;
  otherUic: Scalars['ID']['output'];
  shared: Scalars['Int']['output'];
  uic: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type ActivityPartnerAggregateSelection = {
  __typename?: 'ActivityPartnerAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  otherName: StringAggregateSelection;
  otherUic: IdAggregateSelection;
  shared: IntAggregateSelection;
  uic: IdAggregateSelection;
  value: FloatAggregateSelection;
};

export type ActivityPartnerEdge = {
  __typename?: 'ActivityPartnerEdge';
  cursor: Scalars['String']['output'];
  node: ActivityPartner;
};

export type ActivityPartnerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ActivityPartnerSort objects to sort ActivityPartners by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ActivityPartnerSort>>;
};

/** Fields to sort ActivityPartners by. The order in which sorts are applied is not guaranteed when specifying many fields in one ActivityPartnerSort object. */
export type ActivityPartnerSort = {
  name?: InputMaybe<SortDirection>;
  otherName?: InputMaybe<SortDirection>;
  otherUic?: InputMaybe<SortDirection>;
  shared?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ActivityPartnerWhere = {
  AND?: InputMaybe<Array<ActivityPartnerWhere>>;
  NOT?: InputMaybe<ActivityPartnerWhere>;
  OR?: InputMaybe<Array<ActivityPartnerWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherName?: InputMaybe<Scalars['String']['input']>;
  otherName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  otherName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherName_GT?: InputMaybe<Scalars['String']['input']>;
  otherName_GTE?: InputMaybe<Scalars['String']['input']>;
  otherName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otherName_LT?: InputMaybe<Scalars['String']['input']>;
  otherName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherUic?: InputMaybe<Scalars['ID']['input']>;
  otherUic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  otherUic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  otherUic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherUic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherUic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherUic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherUic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherUic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  otherUic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  shared?: InputMaybe<Scalars['Int']['input']>;
  shared_GT?: InputMaybe<Scalars['Int']['input']>;
  shared_GTE?: InputMaybe<Scalars['Int']['input']>;
  shared_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  shared_LT?: InputMaybe<Scalars['Int']['input']>;
  shared_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shared_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shared_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ActivityPartnersConnection = {
  __typename?: 'ActivityPartnersConnection';
  edges: Array<ActivityPartnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Company.tendersWon
 * * Company.lotsWon
 * * Consortium.tendersWon
 * * Tender.winners
 * * Lot.winners
 */
export type Award = {
  __typename?: 'Award';
  awarded_amount?: Maybe<Scalars['Float']['output']>;
};

export type AwardAggregationWhereInput = {
  AND?: InputMaybe<Array<AwardAggregationWhereInput>>;
  NOT?: InputMaybe<AwardAggregationWhereInput>;
  OR?: InputMaybe<Array<AwardAggregationWhereInput>>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AwardSort = {
  awarded_amount?: InputMaybe<SortDirection>;
};

export type AwardWhere = {
  AND?: InputMaybe<Array<AwardWhere>>;
  NOT?: InputMaybe<AwardWhere>;
  OR?: InputMaybe<Array<AwardWhere>>;
  awarded_amount?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  edges: Array<CompanyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  administers: Array<Municipality>;
  administersAggregate?: Maybe<CompanyMunicipalityAdministersAggregationSelection>;
  administersConnection: CompanyAdministersConnection;
  corporateOwners: Array<Company>;
  corporateOwnersAggregate?: Maybe<CompanyCompanyCorporateOwnersAggregationSelection>;
  corporateOwnersConnection: CompanyCorporateOwnersConnection;
  legal_form?: Maybe<Scalars['String']['output']>;
  lotsWon: Array<Lot>;
  lotsWonAggregate?: Maybe<CompanyLotLotsWonAggregationSelection>;
  lotsWonConnection: CompanyLotsWonConnection;
  managers: Array<Person>;
  managersAggregate?: Maybe<CompanyPersonManagersAggregationSelection>;
  managersConnection: CompanyManagersConnection;
  memberships: Array<Consortium>;
  membershipsAggregate?: Maybe<CompanyConsortiumMembershipsAggregationSelection>;
  membershipsConnection: CompanyMembershipsConnection;
  name?: Maybe<Scalars['String']['output']>;
  owners: Array<Person>;
  ownersAggregate?: Maybe<CompanyPersonOwnersAggregationSelection>;
  ownersConnection: CompanyOwnersConnection;
  partOf: Array<Company>;
  partOfAggregate?: Maybe<CompanyCompanyPartOfAggregationSelection>;
  partOfConnection: CompanyPartOfConnection;
  portfolio?: Maybe<Scalars['String']['output']>;
  procurements: Array<Tender>;
  procurementsAggregate?: Maybe<CompanyTenderProcurementsAggregationSelection>;
  procurementsConnection: CompanyProcurementsConnection;
  public_funds?: Maybe<Scalars['Boolean']['output']>;
  seatedIn: Array<Municipality>;
  seatedInAggregate?: Maybe<CompanyMunicipalitySeatedInAggregationSelection>;
  seatedInConnection: CompanySeatedInConnection;
  sig_award_value?: Maybe<Scalars['Float']['output']>;
  sig_awards?: Maybe<Scalars['Int']['output']>;
  sig_buyers?: Maybe<Scalars['Int']['output']>;
  sig_cobidder_buyers?: Maybe<Scalars['Int']['output']>;
  sig_cobidders?: Maybe<Scalars['Int']['output']>;
  sig_computed_at?: Maybe<Scalars['String']['output']>;
  sig_direct_award?: Maybe<Scalars['Int']['output']>;
  sig_direct_award_value?: Maybe<Scalars['Float']['output']>;
  sig_flagged_awards?: Maybe<Scalars['Int']['output']>;
  sig_flagged_value?: Maybe<Scalars['Float']['output']>;
  sig_holdings_undated?: Maybe<Scalars['Int']['output']>;
  sig_mandate_awards?: Maybe<Scalars['Int']['output']>;
  sig_mandate_officials?: Maybe<Scalars['Int']['output']>;
  sig_mandate_value?: Maybe<Scalars['Float']['output']>;
  sig_party_value?: Maybe<Scalars['Float']['output']>;
  sig_restricted?: Maybe<Scalars['Int']['output']>;
  sig_shared_awards?: Maybe<Scalars['Int']['output']>;
  sig_single_bid?: Maybe<Scalars['Int']['output']>;
  sig_single_bid_value?: Maybe<Scalars['Float']['output']>;
  sig_subcontracted?: Maybe<Scalars['Int']['output']>;
  sig_top_buyer_key?: Maybe<Scalars['ID']['output']>;
  sig_top_buyer_name?: Maybe<Scalars['String']['output']>;
  sig_top_buyer_share?: Maybe<Scalars['Float']['output']>;
  sig_top_buyer_total?: Maybe<Scalars['Float']['output']>;
  sig_top_buyer_value?: Maybe<Scalars['Float']['output']>;
  sig_top_party_awards?: Maybe<Scalars['Int']['output']>;
  sig_top_party_key?: Maybe<Scalars['ID']['output']>;
  sig_top_party_name?: Maybe<Scalars['String']['output']>;
  sig_top_party_share?: Maybe<Scalars['Float']['output']>;
  sig_top_party_value?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidiaries: Array<Company>;
  subsidiariesAggregate?: Maybe<CompanyCompanySubsidiariesAggregationSelection>;
  subsidiariesConnection: CompanySubsidiariesConnection;
  subsidies: Array<Subsidy>;
  subsidiesAggregate?: Maybe<CompanySubsidySubsidiesAggregationSelection>;
  subsidiesConnection: CompanySubsidiesConnection;
  taxDebts: Array<TaxDebtRecord>;
  taxDebtsAggregate?: Maybe<CompanyTaxDebtRecordTaxDebtsAggregationSelection>;
  taxDebtsConnection: CompanyTaxDebtsConnection;
  tendersWon: Array<Tender>;
  tendersWonAggregate?: Maybe<CompanyTenderTendersWonAggregationSelection>;
  tendersWonConnection: CompanyTendersWonConnection;
  treasuryPayments: Array<TreasuryPayment>;
  treasuryPaymentsAggregate?: Maybe<CompanyTreasuryPaymentTreasuryPaymentsAggregationSelection>;
  treasuryPaymentsConnection: CompanyTreasuryPaymentsConnection;
  uic: Scalars['ID']['output'];
  units: Array<Company>;
  unitsAggregate?: Maybe<CompanyCompanyUnitsAggregationSelection>;
  unitsConnection: CompanyUnitsConnection;
};


export type CompanyAdministersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type CompanyAdministersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type CompanyAdministersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyAdministersConnectionSort>>;
  where?: InputMaybe<CompanyAdministersConnectionWhere>;
};


export type CompanyCorporateOwnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyCorporateOwnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyCorporateOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyCorporateOwnersConnectionSort>>;
  where?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
};


export type CompanyLotsWonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LotOptions>;
  where?: InputMaybe<LotWhere>;
};


export type CompanyLotsWonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LotWhere>;
};


export type CompanyLotsWonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyLotsWonConnectionSort>>;
  where?: InputMaybe<CompanyLotsWonConnectionWhere>;
};


export type CompanyManagersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type CompanyManagersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};


export type CompanyManagersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyManagersConnectionSort>>;
  where?: InputMaybe<CompanyManagersConnectionWhere>;
};


export type CompanyMembershipsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConsortiumOptions>;
  where?: InputMaybe<ConsortiumWhere>;
};


export type CompanyMembershipsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConsortiumWhere>;
};


export type CompanyMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyMembershipsConnectionSort>>;
  where?: InputMaybe<CompanyMembershipsConnectionWhere>;
};


export type CompanyOwnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type CompanyOwnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};


export type CompanyOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyOwnersConnectionSort>>;
  where?: InputMaybe<CompanyOwnersConnectionWhere>;
};


export type CompanyPartOfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyPartOfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyPartOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyPartOfConnectionSort>>;
  where?: InputMaybe<CompanyPartOfConnectionWhere>;
};


export type CompanyProcurementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type CompanyProcurementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type CompanyProcurementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyProcurementsConnectionSort>>;
  where?: InputMaybe<CompanyProcurementsConnectionWhere>;
};


export type CompanySeatedInArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type CompanySeatedInAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type CompanySeatedInConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanySeatedInConnectionSort>>;
  where?: InputMaybe<CompanySeatedInConnectionWhere>;
};


export type CompanySubsidiariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanySubsidiariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanySubsidiariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanySubsidiariesConnectionSort>>;
  where?: InputMaybe<CompanySubsidiariesConnectionWhere>;
};


export type CompanySubsidiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubsidyOptions>;
  where?: InputMaybe<SubsidyWhere>;
};


export type CompanySubsidiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubsidyWhere>;
};


export type CompanySubsidiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanySubsidiesConnectionSort>>;
  where?: InputMaybe<CompanySubsidiesConnectionWhere>;
};


export type CompanyTaxDebtsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TaxDebtRecordOptions>;
  where?: InputMaybe<TaxDebtRecordWhere>;
};


export type CompanyTaxDebtsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TaxDebtRecordWhere>;
};


export type CompanyTaxDebtsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyTaxDebtsConnectionSort>>;
  where?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
};


export type CompanyTendersWonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type CompanyTendersWonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type CompanyTendersWonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyTendersWonConnectionSort>>;
  where?: InputMaybe<CompanyTendersWonConnectionWhere>;
};


export type CompanyTreasuryPaymentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreasuryPaymentOptions>;
  where?: InputMaybe<TreasuryPaymentWhere>;
};


export type CompanyTreasuryPaymentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreasuryPaymentWhere>;
};


export type CompanyTreasuryPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyTreasuryPaymentsConnectionSort>>;
  where?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
};


export type CompanyUnitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyUnitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type CompanyUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompanyUnitsConnectionSort>>;
  where?: InputMaybe<CompanyUnitsConnectionWhere>;
};

export type CompanyAdministersAggregateInput = {
  AND?: InputMaybe<Array<CompanyAdministersAggregateInput>>;
  NOT?: InputMaybe<CompanyAdministersAggregateInput>;
  OR?: InputMaybe<Array<CompanyAdministersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyAdministersNodeAggregationWhereInput>;
};

export type CompanyAdministersConnection = {
  __typename?: 'CompanyAdministersConnection';
  edges: Array<CompanyAdministersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyAdministersConnectionSort = {
  node?: InputMaybe<MunicipalitySort>;
};

export type CompanyAdministersConnectionWhere = {
  AND?: InputMaybe<Array<CompanyAdministersConnectionWhere>>;
  NOT?: InputMaybe<CompanyAdministersConnectionWhere>;
  OR?: InputMaybe<Array<CompanyAdministersConnectionWhere>>;
  node?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MunicipalityWhere>;
};

export type CompanyAdministersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyAdministersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyAdministersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyAdministersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  spend_per_capita_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanyAdministersRelationship = {
  __typename?: 'CompanyAdministersRelationship';
  cursor: Scalars['String']['output'];
  node: Municipality;
};

export type CompanyAggregateSelection = {
  __typename?: 'CompanyAggregateSelection';
  count: Scalars['Int']['output'];
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyCompanyCorporateOwnersAggregationSelection = {
  __typename?: 'CompanyCompanyCorporateOwnersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyCompanyCorporateOwnersEdgeAggregateSelection>;
  node?: Maybe<CompanyCompanyCorporateOwnersNodeAggregateSelection>;
};

export type CompanyCompanyCorporateOwnersEdgeAggregateSelection = {
  __typename?: 'CompanyCompanyCorporateOwnersEdgeAggregateSelection';
  share_amount: FloatAggregateSelection;
  share_currency: StringAggregateSelection;
  share_percent: FloatAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type CompanyCompanyCorporateOwnersNodeAggregateSelection = {
  __typename?: 'CompanyCompanyCorporateOwnersNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyCompanyPartOfAggregationSelection = {
  __typename?: 'CompanyCompanyPartOfAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyCompanyPartOfNodeAggregateSelection>;
};

export type CompanyCompanyPartOfNodeAggregateSelection = {
  __typename?: 'CompanyCompanyPartOfNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyCompanySubsidiariesAggregationSelection = {
  __typename?: 'CompanyCompanySubsidiariesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyCompanySubsidiariesEdgeAggregateSelection>;
  node?: Maybe<CompanyCompanySubsidiariesNodeAggregateSelection>;
};

export type CompanyCompanySubsidiariesEdgeAggregateSelection = {
  __typename?: 'CompanyCompanySubsidiariesEdgeAggregateSelection';
  share_amount: FloatAggregateSelection;
  share_currency: StringAggregateSelection;
  share_percent: FloatAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type CompanyCompanySubsidiariesNodeAggregateSelection = {
  __typename?: 'CompanyCompanySubsidiariesNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyCompanyUnitsAggregationSelection = {
  __typename?: 'CompanyCompanyUnitsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyCompanyUnitsNodeAggregateSelection>;
};

export type CompanyCompanyUnitsNodeAggregateSelection = {
  __typename?: 'CompanyCompanyUnitsNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyConsortiumMembershipsAggregationSelection = {
  __typename?: 'CompanyConsortiumMembershipsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyConsortiumMembershipsEdgeAggregateSelection>;
  node?: Maybe<CompanyConsortiumMembershipsNodeAggregateSelection>;
};

export type CompanyConsortiumMembershipsEdgeAggregateSelection = {
  __typename?: 'CompanyConsortiumMembershipsEdgeAggregateSelection';
  share_percent: FloatAggregateSelection;
};

export type CompanyConsortiumMembershipsNodeAggregateSelection = {
  __typename?: 'CompanyConsortiumMembershipsNodeAggregateSelection';
  name: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyCorporateOwnersAggregateInput = {
  AND?: InputMaybe<Array<CompanyCorporateOwnersAggregateInput>>;
  NOT?: InputMaybe<CompanyCorporateOwnersAggregateInput>;
  OR?: InputMaybe<Array<CompanyCorporateOwnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OwnershipAggregationWhereInput>;
  node?: InputMaybe<CompanyCorporateOwnersNodeAggregationWhereInput>;
};

export type CompanyCorporateOwnersConnection = {
  __typename?: 'CompanyCorporateOwnersConnection';
  edges: Array<CompanyCorporateOwnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyCorporateOwnersConnectionSort = {
  edge?: InputMaybe<OwnershipSort>;
  node?: InputMaybe<CompanySort>;
};

export type CompanyCorporateOwnersConnectionWhere = {
  AND?: InputMaybe<Array<CompanyCorporateOwnersConnectionWhere>>;
  NOT?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  OR?: InputMaybe<Array<CompanyCorporateOwnersConnectionWhere>>;
  edge?: InputMaybe<OwnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OwnershipWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type CompanyCorporateOwnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyCorporateOwnersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyCorporateOwnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyCorporateOwnersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyCorporateOwnersRelationship = {
  __typename?: 'CompanyCorporateOwnersRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Ownership;
};

export type CompanyCouncillorMatch = {
  __typename?: 'CompanyCouncillorMatch';
  awards: Scalars['Int']['output'];
  councillorHash: Scalars['ID']['output'];
  councillorName?: Maybe<Scalars['String']['output']>;
  electedYear: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  municipalityKey: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  namesakes: Scalars['Int']['output'];
  personHash: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  sitting: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export type CompanyCouncillorMatchAggregateSelection = {
  __typename?: 'CompanyCouncillorMatchAggregateSelection';
  awards: IntAggregateSelection;
  councillorHash: IdAggregateSelection;
  councillorName: StringAggregateSelection;
  count: Scalars['Int']['output'];
  electedYear: IntAggregateSelection;
  kind: StringAggregateSelection;
  municipality: StringAggregateSelection;
  municipalityKey: IdAggregateSelection;
  name: StringAggregateSelection;
  namesakes: IntAggregateSelection;
  personHash: IdAggregateSelection;
  role: StringAggregateSelection;
  value: FloatAggregateSelection;
};

export type CompanyCouncillorMatchEdge = {
  __typename?: 'CompanyCouncillorMatchEdge';
  cursor: Scalars['String']['output'];
  node: CompanyCouncillorMatch;
};

/** Fields to sort CompanyCouncillorMatches by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompanyCouncillorMatchSort object. */
export type CompanyCouncillorMatchSort = {
  awards?: InputMaybe<SortDirection>;
  councillorHash?: InputMaybe<SortDirection>;
  councillorName?: InputMaybe<SortDirection>;
  electedYear?: InputMaybe<SortDirection>;
  kind?: InputMaybe<SortDirection>;
  municipality?: InputMaybe<SortDirection>;
  municipalityKey?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  namesakes?: InputMaybe<SortDirection>;
  personHash?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  sitting?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type CompanyCouncillorMatchWhere = {
  AND?: InputMaybe<Array<CompanyCouncillorMatchWhere>>;
  NOT?: InputMaybe<CompanyCouncillorMatchWhere>;
  OR?: InputMaybe<Array<CompanyCouncillorMatchWhere>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councillorHash?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorName?: InputMaybe<Scalars['String']['input']>;
  councillorName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  councillorName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  councillorName_GT?: InputMaybe<Scalars['String']['input']>;
  councillorName_GTE?: InputMaybe<Scalars['String']['input']>;
  councillorName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  councillorName_LT?: InputMaybe<Scalars['String']['input']>;
  councillorName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  councillorName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  electedYear?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GTE?: InputMaybe<Scalars['Int']['input']>;
  electedYear_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  electedYear_LT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kind_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  kind_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_GT?: InputMaybe<Scalars['String']['input']>;
  kind_GTE?: InputMaybe<Scalars['String']['input']>;
  kind_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  kind_LT?: InputMaybe<Scalars['String']['input']>;
  kind_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  municipalityKey?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipality_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  municipality_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_GT?: InputMaybe<Scalars['String']['input']>;
  municipality_GTE?: InputMaybe<Scalars['String']['input']>;
  municipality_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  municipality_LT?: InputMaybe<Scalars['String']['input']>;
  municipality_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  namesakes?: InputMaybe<Scalars['Int']['input']>;
  namesakes_GT?: InputMaybe<Scalars['Int']['input']>;
  namesakes_GTE?: InputMaybe<Scalars['Int']['input']>;
  namesakes_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  namesakes_LT?: InputMaybe<Scalars['Int']['input']>;
  namesakes_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  namesakes_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  namesakes_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  personHash?: InputMaybe<Scalars['ID']['input']>;
  personHash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  personHash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  personHash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  personHash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_GT?: InputMaybe<Scalars['String']['input']>;
  role_GTE?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  role_LT?: InputMaybe<Scalars['String']['input']>;
  role_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  roles_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roles_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roles_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sitting?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sitting_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CompanyCouncillorMatchesConnection = {
  __typename?: 'CompanyCouncillorMatchesConnection';
  edges: Array<CompanyCouncillorMatchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompanyFilter = {
  hasDebt?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubsidies?: InputMaybe<Scalars['Boolean']['input']>;
  hasTenders?: InputMaybe<Scalars['Boolean']['input']>;
  hasTreasury?: InputMaybe<Scalars['Boolean']['input']>;
  legalForms?: InputMaybe<Array<Scalars['String']['input']>>;
  minTreasury?: InputMaybe<Scalars['Float']['input']>;
  ownerHashes?: InputMaybe<Array<Scalars['ID']['input']>>;
  provinces?: InputMaybe<Array<Scalars['String']['input']>>;
  publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seatKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CompanyLotLotsWonAggregationSelection = {
  __typename?: 'CompanyLotLotsWonAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyLotLotsWonEdgeAggregateSelection>;
  node?: Maybe<CompanyLotLotsWonNodeAggregateSelection>;
};

export type CompanyLotLotsWonEdgeAggregateSelection = {
  __typename?: 'CompanyLotLotsWonEdgeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
};

export type CompanyLotLotsWonNodeAggregateSelection = {
  __typename?: 'CompanyLotLotsWonNodeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
  contract_number: StringAggregateSelection;
  currency: StringAggregateSelection;
  lot_id: StringAggregateSelection;
  lot_key: IdAggregateSelection;
  publication_date: StringAggregateSelection;
};

export type CompanyLotsWonAggregateInput = {
  AND?: InputMaybe<Array<CompanyLotsWonAggregateInput>>;
  NOT?: InputMaybe<CompanyLotsWonAggregateInput>;
  OR?: InputMaybe<Array<CompanyLotsWonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AwardAggregationWhereInput>;
  node?: InputMaybe<CompanyLotsWonNodeAggregationWhereInput>;
};

export type CompanyLotsWonConnection = {
  __typename?: 'CompanyLotsWonConnection';
  edges: Array<CompanyLotsWonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyLotsWonConnectionSort = {
  edge?: InputMaybe<AwardSort>;
  node?: InputMaybe<LotSort>;
};

export type CompanyLotsWonConnectionWhere = {
  AND?: InputMaybe<Array<CompanyLotsWonConnectionWhere>>;
  NOT?: InputMaybe<CompanyLotsWonConnectionWhere>;
  OR?: InputMaybe<Array<CompanyLotsWonConnectionWhere>>;
  edge?: InputMaybe<AwardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<AwardWhere>;
  node?: InputMaybe<LotWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LotWhere>;
};

export type CompanyLotsWonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyLotsWonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyLotsWonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyLotsWonNodeAggregationWhereInput>>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyLotsWonRelationship = {
  __typename?: 'CompanyLotsWonRelationship';
  cursor: Scalars['String']['output'];
  node: Lot;
  properties: Award;
};

export type CompanyManagersAggregateInput = {
  AND?: InputMaybe<Array<CompanyManagersAggregateInput>>;
  NOT?: InputMaybe<CompanyManagersAggregateInput>;
  OR?: InputMaybe<Array<CompanyManagersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ManagementAggregationWhereInput>;
  node?: InputMaybe<CompanyManagersNodeAggregationWhereInput>;
};

export type CompanyManagersConnection = {
  __typename?: 'CompanyManagersConnection';
  edges: Array<CompanyManagersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyManagersConnectionSort = {
  edge?: InputMaybe<ManagementSort>;
  node?: InputMaybe<PersonSort>;
};

export type CompanyManagersConnectionWhere = {
  AND?: InputMaybe<Array<CompanyManagersConnectionWhere>>;
  NOT?: InputMaybe<CompanyManagersConnectionWhere>;
  OR?: InputMaybe<Array<CompanyManagersConnectionWhere>>;
  edge?: InputMaybe<ManagementWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ManagementWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type CompanyManagersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyManagersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyManagersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyManagersNodeAggregationWhereInput>>;
  company_links_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  person_hash_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyManagersRelationship = {
  __typename?: 'CompanyManagersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: Management;
};

export type CompanyMembershipsAggregateInput = {
  AND?: InputMaybe<Array<CompanyMembershipsAggregateInput>>;
  NOT?: InputMaybe<CompanyMembershipsAggregateInput>;
  OR?: InputMaybe<Array<CompanyMembershipsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<PartnershipAggregationWhereInput>;
  node?: InputMaybe<CompanyMembershipsNodeAggregationWhereInput>;
};

export type CompanyMembershipsConnection = {
  __typename?: 'CompanyMembershipsConnection';
  edges: Array<CompanyMembershipsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyMembershipsConnectionSort = {
  edge?: InputMaybe<PartnershipSort>;
  node?: InputMaybe<ConsortiumSort>;
};

export type CompanyMembershipsConnectionWhere = {
  AND?: InputMaybe<Array<CompanyMembershipsConnectionWhere>>;
  NOT?: InputMaybe<CompanyMembershipsConnectionWhere>;
  OR?: InputMaybe<Array<CompanyMembershipsConnectionWhere>>;
  edge?: InputMaybe<PartnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PartnershipWhere>;
  node?: InputMaybe<ConsortiumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ConsortiumWhere>;
};

export type CompanyMembershipsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyMembershipsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyMembershipsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyMembershipsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyMembershipsRelationship = {
  __typename?: 'CompanyMembershipsRelationship';
  cursor: Scalars['String']['output'];
  node: Consortium;
  properties: Partnership;
};

export type CompanyMunicipalityAdministersAggregationSelection = {
  __typename?: 'CompanyMunicipalityAdministersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyMunicipalityAdministersNodeAggregateSelection>;
};

export type CompanyMunicipalityAdministersNodeAggregateSelection = {
  __typename?: 'CompanyMunicipalityAdministersNodeAggregateSelection';
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type CompanyMunicipalitySeatedInAggregationSelection = {
  __typename?: 'CompanyMunicipalitySeatedInAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyMunicipalitySeatedInNodeAggregateSelection>;
};

export type CompanyMunicipalitySeatedInNodeAggregateSelection = {
  __typename?: 'CompanyMunicipalitySeatedInNodeAggregateSelection';
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type CompanyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CompanySort objects to sort Companies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CompanySort>>;
};

export type CompanyOwnersAggregateInput = {
  AND?: InputMaybe<Array<CompanyOwnersAggregateInput>>;
  NOT?: InputMaybe<CompanyOwnersAggregateInput>;
  OR?: InputMaybe<Array<CompanyOwnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OwnershipAggregationWhereInput>;
  node?: InputMaybe<CompanyOwnersNodeAggregationWhereInput>;
};

export type CompanyOwnersConnection = {
  __typename?: 'CompanyOwnersConnection';
  edges: Array<CompanyOwnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyOwnersConnectionSort = {
  edge?: InputMaybe<OwnershipSort>;
  node?: InputMaybe<PersonSort>;
};

export type CompanyOwnersConnectionWhere = {
  AND?: InputMaybe<Array<CompanyOwnersConnectionWhere>>;
  NOT?: InputMaybe<CompanyOwnersConnectionWhere>;
  OR?: InputMaybe<Array<CompanyOwnersConnectionWhere>>;
  edge?: InputMaybe<OwnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OwnershipWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type CompanyOwnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyOwnersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyOwnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyOwnersNodeAggregationWhereInput>>;
  company_links_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  person_hash_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyOwnersRelationship = {
  __typename?: 'CompanyOwnersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: Ownership;
};

export type CompanyPartOfAggregateInput = {
  AND?: InputMaybe<Array<CompanyPartOfAggregateInput>>;
  NOT?: InputMaybe<CompanyPartOfAggregateInput>;
  OR?: InputMaybe<Array<CompanyPartOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyPartOfNodeAggregationWhereInput>;
};

export type CompanyPartOfConnection = {
  __typename?: 'CompanyPartOfConnection';
  edges: Array<CompanyPartOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyPartOfConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type CompanyPartOfConnectionWhere = {
  AND?: InputMaybe<Array<CompanyPartOfConnectionWhere>>;
  NOT?: InputMaybe<CompanyPartOfConnectionWhere>;
  OR?: InputMaybe<Array<CompanyPartOfConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type CompanyPartOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyPartOfNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyPartOfNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyPartOfNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyPartOfRelationship = {
  __typename?: 'CompanyPartOfRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompanyPersonManagersAggregationSelection = {
  __typename?: 'CompanyPersonManagersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyPersonManagersEdgeAggregateSelection>;
  node?: Maybe<CompanyPersonManagersNodeAggregateSelection>;
};

export type CompanyPersonManagersEdgeAggregateSelection = {
  __typename?: 'CompanyPersonManagersEdgeAggregateSelection';
  role: StringAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type CompanyPersonManagersNodeAggregateSelection = {
  __typename?: 'CompanyPersonManagersNodeAggregateSelection';
  company_links: IntAggregateSelection;
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

export type CompanyPersonOwnersAggregationSelection = {
  __typename?: 'CompanyPersonOwnersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyPersonOwnersEdgeAggregateSelection>;
  node?: Maybe<CompanyPersonOwnersNodeAggregateSelection>;
};

export type CompanyPersonOwnersEdgeAggregateSelection = {
  __typename?: 'CompanyPersonOwnersEdgeAggregateSelection';
  share_amount: FloatAggregateSelection;
  share_currency: StringAggregateSelection;
  share_percent: FloatAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type CompanyPersonOwnersNodeAggregateSelection = {
  __typename?: 'CompanyPersonOwnersNodeAggregateSelection';
  company_links: IntAggregateSelection;
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

export type CompanyProcurementsAggregateInput = {
  AND?: InputMaybe<Array<CompanyProcurementsAggregateInput>>;
  NOT?: InputMaybe<CompanyProcurementsAggregateInput>;
  OR?: InputMaybe<Array<CompanyProcurementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyProcurementsNodeAggregationWhereInput>;
};

export type CompanyProcurementsConnection = {
  __typename?: 'CompanyProcurementsConnection';
  edges: Array<CompanyProcurementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyProcurementsConnectionSort = {
  node?: InputMaybe<TenderSort>;
};

export type CompanyProcurementsConnectionWhere = {
  AND?: InputMaybe<Array<CompanyProcurementsConnectionWhere>>;
  NOT?: InputMaybe<CompanyProcurementsConnectionWhere>;
  OR?: InputMaybe<Array<CompanyProcurementsConnectionWhere>>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type CompanyProcurementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyProcurementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyProcurementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyProcurementsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProcurementsRelationship = {
  __typename?: 'CompanyProcurementsRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type CompanySeatedInAggregateInput = {
  AND?: InputMaybe<Array<CompanySeatedInAggregateInput>>;
  NOT?: InputMaybe<CompanySeatedInAggregateInput>;
  OR?: InputMaybe<Array<CompanySeatedInAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanySeatedInNodeAggregationWhereInput>;
};

export type CompanySeatedInConnection = {
  __typename?: 'CompanySeatedInConnection';
  edges: Array<CompanySeatedInRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanySeatedInConnectionSort = {
  node?: InputMaybe<MunicipalitySort>;
};

export type CompanySeatedInConnectionWhere = {
  AND?: InputMaybe<Array<CompanySeatedInConnectionWhere>>;
  NOT?: InputMaybe<CompanySeatedInConnectionWhere>;
  OR?: InputMaybe<Array<CompanySeatedInConnectionWhere>>;
  node?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MunicipalityWhere>;
};

export type CompanySeatedInNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanySeatedInNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanySeatedInNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanySeatedInNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  spend_per_capita_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanySeatedInRelationship = {
  __typename?: 'CompanySeatedInRelationship';
  cursor: Scalars['String']['output'];
  node: Municipality;
};

/** Fields to sort Companies by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompanySort object. */
export type CompanySort = {
  legal_form?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  portfolio?: InputMaybe<SortDirection>;
  public_funds?: InputMaybe<SortDirection>;
  sig_award_value?: InputMaybe<SortDirection>;
  sig_awards?: InputMaybe<SortDirection>;
  sig_buyers?: InputMaybe<SortDirection>;
  sig_cobidder_buyers?: InputMaybe<SortDirection>;
  sig_cobidders?: InputMaybe<SortDirection>;
  sig_computed_at?: InputMaybe<SortDirection>;
  sig_direct_award?: InputMaybe<SortDirection>;
  sig_direct_award_value?: InputMaybe<SortDirection>;
  sig_flagged_awards?: InputMaybe<SortDirection>;
  sig_flagged_value?: InputMaybe<SortDirection>;
  sig_holdings_undated?: InputMaybe<SortDirection>;
  sig_mandate_awards?: InputMaybe<SortDirection>;
  sig_mandate_officials?: InputMaybe<SortDirection>;
  sig_mandate_value?: InputMaybe<SortDirection>;
  sig_party_value?: InputMaybe<SortDirection>;
  sig_restricted?: InputMaybe<SortDirection>;
  sig_shared_awards?: InputMaybe<SortDirection>;
  sig_single_bid?: InputMaybe<SortDirection>;
  sig_single_bid_value?: InputMaybe<SortDirection>;
  sig_subcontracted?: InputMaybe<SortDirection>;
  sig_top_buyer_key?: InputMaybe<SortDirection>;
  sig_top_buyer_name?: InputMaybe<SortDirection>;
  sig_top_buyer_share?: InputMaybe<SortDirection>;
  sig_top_buyer_total?: InputMaybe<SortDirection>;
  sig_top_buyer_value?: InputMaybe<SortDirection>;
  sig_top_party_awards?: InputMaybe<SortDirection>;
  sig_top_party_key?: InputMaybe<SortDirection>;
  sig_top_party_name?: InputMaybe<SortDirection>;
  sig_top_party_share?: InputMaybe<SortDirection>;
  sig_top_party_value?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
};

export type CompanyStat = {
  __typename?: 'CompanyStat';
  count?: Maybe<Scalars['Int']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  uic: Scalars['ID']['output'];
};

export type CompanyStatAggregateSelection = {
  __typename?: 'CompanyStatAggregateSelection';
  count: IntAggregateSelection;
  debt: FloatAggregateSelection;
  name: StringAggregateSelection;
  total: FloatAggregateSelection;
  uic: IdAggregateSelection;
};

export type CompanyStatEdge = {
  __typename?: 'CompanyStatEdge';
  cursor: Scalars['String']['output'];
  node: CompanyStat;
};

export type CompanyStatOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CompanyStatSort objects to sort CompanyStats by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CompanyStatSort>>;
};

/** Fields to sort CompanyStats by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompanyStatSort object. */
export type CompanyStatSort = {
  count?: InputMaybe<SortDirection>;
  debt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  total?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
};

export type CompanyStatWhere = {
  AND?: InputMaybe<Array<CompanyStatWhere>>;
  NOT?: InputMaybe<CompanyStatWhere>;
  OR?: InputMaybe<Array<CompanyStatWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  debt?: InputMaybe<Scalars['Float']['input']>;
  debt_GT?: InputMaybe<Scalars['Float']['input']>;
  debt_GTE?: InputMaybe<Scalars['Float']['input']>;
  debt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  debt_LT?: InputMaybe<Scalars['Float']['input']>;
  debt_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  total_GT?: InputMaybe<Scalars['Float']['input']>;
  total_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  total_LT?: InputMaybe<Scalars['Float']['input']>;
  total_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  total_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  total_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyStatsConnection = {
  __typename?: 'CompanyStatsConnection';
  edges: Array<CompanyStatEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanySubsidiariesAggregateInput = {
  AND?: InputMaybe<Array<CompanySubsidiariesAggregateInput>>;
  NOT?: InputMaybe<CompanySubsidiariesAggregateInput>;
  OR?: InputMaybe<Array<CompanySubsidiariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OwnershipAggregationWhereInput>;
  node?: InputMaybe<CompanySubsidiariesNodeAggregationWhereInput>;
};

export type CompanySubsidiariesConnection = {
  __typename?: 'CompanySubsidiariesConnection';
  edges: Array<CompanySubsidiariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanySubsidiariesConnectionSort = {
  edge?: InputMaybe<OwnershipSort>;
  node?: InputMaybe<CompanySort>;
};

export type CompanySubsidiariesConnectionWhere = {
  AND?: InputMaybe<Array<CompanySubsidiariesConnectionWhere>>;
  NOT?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  OR?: InputMaybe<Array<CompanySubsidiariesConnectionWhere>>;
  edge?: InputMaybe<OwnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OwnershipWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type CompanySubsidiariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanySubsidiariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanySubsidiariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanySubsidiariesNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanySubsidiariesRelationship = {
  __typename?: 'CompanySubsidiariesRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Ownership;
};

export type CompanySubsidiesAggregateInput = {
  AND?: InputMaybe<Array<CompanySubsidiesAggregateInput>>;
  NOT?: InputMaybe<CompanySubsidiesAggregateInput>;
  OR?: InputMaybe<Array<CompanySubsidiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanySubsidiesNodeAggregationWhereInput>;
};

export type CompanySubsidiesConnection = {
  __typename?: 'CompanySubsidiesConnection';
  edges: Array<CompanySubsidiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanySubsidiesConnectionSort = {
  node?: InputMaybe<SubsidySort>;
};

export type CompanySubsidiesConnectionWhere = {
  AND?: InputMaybe<Array<CompanySubsidiesConnectionWhere>>;
  NOT?: InputMaybe<CompanySubsidiesConnectionWhere>;
  OR?: InputMaybe<Array<CompanySubsidiesConnectionWhere>>;
  node?: InputMaybe<SubsidyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubsidyWhere>;
};

export type CompanySubsidiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanySubsidiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanySubsidiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanySubsidiesNodeAggregationWhereInput>>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_months_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_months_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_months_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_months_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duration_months_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duration_months_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duration_months_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duration_months_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duration_months_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_months_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  measure_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  measure_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  measure_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  measure_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  measure_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  measure_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  measure_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  measure_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  measure_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  measure_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  measure_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  measure_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  measure_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  measure_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  measure_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  measure_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  measure_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  measure_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  measure_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  measure_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  measure_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  paid_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  paid_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  paid_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  paid_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  paid_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  paid_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  project_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  project_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  project_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  project_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  project_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  project_title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  project_title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  project_title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  project_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  project_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  project_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  project_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  project_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  project_title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  project_title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  project_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  project_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  project_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  project_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  project_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  project_title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subsidy_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  total_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  total_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  total_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  total_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  total_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  total_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  total_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  total_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  total_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  total_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  total_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  total_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  total_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  total_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanySubsidiesRelationship = {
  __typename?: 'CompanySubsidiesRelationship';
  cursor: Scalars['String']['output'];
  node: Subsidy;
};

export type CompanySubsidySubsidiesAggregationSelection = {
  __typename?: 'CompanySubsidySubsidiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanySubsidySubsidiesNodeAggregateSelection>;
};

export type CompanySubsidySubsidiesNodeAggregateSelection = {
  __typename?: 'CompanySubsidySubsidiesNodeAggregateSelection';
  amount: FloatAggregateSelection;
  description: StringAggregateSelection;
  duration_months: IntAggregateSelection;
  end_date: StringAggregateSelection;
  measure: StringAggregateSelection;
  paid_amount: FloatAggregateSelection;
  project_title: StringAggregateSelection;
  source: StringAggregateSelection;
  start_date: StringAggregateSelection;
  status: StringAggregateSelection;
  subsidy_id: IdAggregateSelection;
  total_value: FloatAggregateSelection;
  year: IntAggregateSelection;
};

export type CompanyTaxDebtRecordTaxDebtsAggregationSelection = {
  __typename?: 'CompanyTaxDebtRecordTaxDebtsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyTaxDebtRecordTaxDebtsNodeAggregateSelection>;
};

export type CompanyTaxDebtRecordTaxDebtsNodeAggregateSelection = {
  __typename?: 'CompanyTaxDebtRecordTaxDebtsNodeAggregateSelection';
  amount: FloatAggregateSelection;
  as_of: StringAggregateSelection;
  date: StringAggregateSelection;
  debt_type: StringAggregateSelection;
  record_id: IdAggregateSelection;
  source: StringAggregateSelection;
  territory: StringAggregateSelection;
};

export type CompanyTaxDebtsAggregateInput = {
  AND?: InputMaybe<Array<CompanyTaxDebtsAggregateInput>>;
  NOT?: InputMaybe<CompanyTaxDebtsAggregateInput>;
  OR?: InputMaybe<Array<CompanyTaxDebtsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyTaxDebtsNodeAggregationWhereInput>;
};

export type CompanyTaxDebtsConnection = {
  __typename?: 'CompanyTaxDebtsConnection';
  edges: Array<CompanyTaxDebtsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyTaxDebtsConnectionSort = {
  node?: InputMaybe<TaxDebtRecordSort>;
};

export type CompanyTaxDebtsConnectionWhere = {
  AND?: InputMaybe<Array<CompanyTaxDebtsConnectionWhere>>;
  NOT?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  OR?: InputMaybe<Array<CompanyTaxDebtsConnectionWhere>>;
  node?: InputMaybe<TaxDebtRecordWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TaxDebtRecordWhere>;
};

export type CompanyTaxDebtsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyTaxDebtsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyTaxDebtsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyTaxDebtsNodeAggregationWhereInput>>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  debt_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  debt_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  debt_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  debt_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  debt_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  debt_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  debt_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  debt_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  debt_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  debt_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  debt_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  debt_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  debt_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  debt_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  debt_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  debt_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  debt_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  debt_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  debt_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  debt_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  debt_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  record_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  territory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  territory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  territory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  territory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  territory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  territory_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  territory_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  territory_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  territory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  territory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  territory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  territory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  territory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  territory_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  territory_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  territory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  territory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  territory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  territory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  territory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  territory_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTaxDebtsRelationship = {
  __typename?: 'CompanyTaxDebtsRelationship';
  cursor: Scalars['String']['output'];
  node: TaxDebtRecord;
};

export type CompanyTenderProcurementsAggregationSelection = {
  __typename?: 'CompanyTenderProcurementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyTenderProcurementsNodeAggregateSelection>;
};

export type CompanyTenderProcurementsNodeAggregateSelection = {
  __typename?: 'CompanyTenderProcurementsNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type CompanyTenderTendersWonAggregationSelection = {
  __typename?: 'CompanyTenderTendersWonAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CompanyTenderTendersWonEdgeAggregateSelection>;
  node?: Maybe<CompanyTenderTendersWonNodeAggregateSelection>;
};

export type CompanyTenderTendersWonEdgeAggregateSelection = {
  __typename?: 'CompanyTenderTendersWonEdgeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
};

export type CompanyTenderTendersWonNodeAggregateSelection = {
  __typename?: 'CompanyTenderTendersWonNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type CompanyTendersWonAggregateInput = {
  AND?: InputMaybe<Array<CompanyTendersWonAggregateInput>>;
  NOT?: InputMaybe<CompanyTendersWonAggregateInput>;
  OR?: InputMaybe<Array<CompanyTendersWonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AwardAggregationWhereInput>;
  node?: InputMaybe<CompanyTendersWonNodeAggregationWhereInput>;
};

export type CompanyTendersWonConnection = {
  __typename?: 'CompanyTendersWonConnection';
  edges: Array<CompanyTendersWonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyTendersWonConnectionSort = {
  edge?: InputMaybe<AwardSort>;
  node?: InputMaybe<TenderSort>;
};

export type CompanyTendersWonConnectionWhere = {
  AND?: InputMaybe<Array<CompanyTendersWonConnectionWhere>>;
  NOT?: InputMaybe<CompanyTendersWonConnectionWhere>;
  OR?: InputMaybe<Array<CompanyTendersWonConnectionWhere>>;
  edge?: InputMaybe<AwardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<AwardWhere>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type CompanyTendersWonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyTendersWonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyTendersWonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyTendersWonNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTendersWonRelationship = {
  __typename?: 'CompanyTendersWonRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
  properties: Award;
};

export type CompanyTreasuryPaymentTreasuryPaymentsAggregationSelection = {
  __typename?: 'CompanyTreasuryPaymentTreasuryPaymentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CompanyTreasuryPaymentTreasuryPaymentsNodeAggregateSelection>;
};

export type CompanyTreasuryPaymentTreasuryPaymentsNodeAggregateSelection = {
  __typename?: 'CompanyTreasuryPaymentTreasuryPaymentsNodeAggregateSelection';
  amount: FloatAggregateSelection;
  amount_bgn: FloatAggregateSelection;
  amount_eur: FloatAggregateSelection;
  as_of: StringAggregateSelection;
  first_date: StringAggregateSelection;
  last_date: StringAggregateSelection;
  match_type: StringAggregateSelection;
  payment_count: IntAggregateSelection;
  payment_id: IdAggregateSelection;
  source: StringAggregateSelection;
};

export type CompanyTreasuryPaymentsAggregateInput = {
  AND?: InputMaybe<Array<CompanyTreasuryPaymentsAggregateInput>>;
  NOT?: InputMaybe<CompanyTreasuryPaymentsAggregateInput>;
  OR?: InputMaybe<Array<CompanyTreasuryPaymentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyTreasuryPaymentsNodeAggregationWhereInput>;
};

export type CompanyTreasuryPaymentsConnection = {
  __typename?: 'CompanyTreasuryPaymentsConnection';
  edges: Array<CompanyTreasuryPaymentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyTreasuryPaymentsConnectionSort = {
  node?: InputMaybe<TreasuryPaymentSort>;
};

export type CompanyTreasuryPaymentsConnectionWhere = {
  AND?: InputMaybe<Array<CompanyTreasuryPaymentsConnectionWhere>>;
  NOT?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  OR?: InputMaybe<Array<CompanyTreasuryPaymentsConnectionWhere>>;
  node?: InputMaybe<TreasuryPaymentWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TreasuryPaymentWhere>;
};

export type CompanyTreasuryPaymentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyTreasuryPaymentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyTreasuryPaymentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyTreasuryPaymentsNodeAggregationWhereInput>>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_eur_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_eur_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_eur_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_eur_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  amount_eur_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  first_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  first_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  first_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  first_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  first_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  first_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  first_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  first_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  first_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  first_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  first_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  first_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  first_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  first_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  first_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  first_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  first_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  first_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  first_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  first_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  first_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  last_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  last_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  last_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  last_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  last_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  last_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  match_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  match_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  match_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  match_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  match_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  match_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  match_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  match_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  match_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  match_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  match_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  match_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  match_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  match_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  match_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  match_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  match_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  match_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  match_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  match_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  match_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payment_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payment_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payment_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payment_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payment_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  payment_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTreasuryPaymentsRelationship = {
  __typename?: 'CompanyTreasuryPaymentsRelationship';
  cursor: Scalars['String']['output'];
  node: TreasuryPayment;
};

export type CompanyUnitsAggregateInput = {
  AND?: InputMaybe<Array<CompanyUnitsAggregateInput>>;
  NOT?: InputMaybe<CompanyUnitsAggregateInput>;
  OR?: InputMaybe<Array<CompanyUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CompanyUnitsNodeAggregationWhereInput>;
};

export type CompanyUnitsConnection = {
  __typename?: 'CompanyUnitsConnection';
  edges: Array<CompanyUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyUnitsConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type CompanyUnitsConnectionWhere = {
  AND?: InputMaybe<Array<CompanyUnitsConnectionWhere>>;
  NOT?: InputMaybe<CompanyUnitsConnectionWhere>;
  OR?: InputMaybe<Array<CompanyUnitsConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type CompanyUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompanyUnitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompanyUnitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompanyUnitsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyUnitsRelationship = {
  __typename?: 'CompanyUnitsRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompanyWhere = {
  AND?: InputMaybe<Array<CompanyWhere>>;
  NOT?: InputMaybe<CompanyWhere>;
  OR?: InputMaybe<Array<CompanyWhere>>;
  /** @deprecated Use `administers_SOME` instead. */
  administers?: InputMaybe<MunicipalityWhere>;
  administersAggregate?: InputMaybe<CompanyAdministersAggregateInput>;
  /** @deprecated Use `administersConnection_SOME` instead. */
  administersConnection?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** Return Companies where all of the related CompanyAdministersConnections match this filter */
  administersConnection_ALL?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** Return Companies where none of the related CompanyAdministersConnections match this filter */
  administersConnection_NONE?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** @deprecated Use `administersConnection_NONE` instead. */
  administersConnection_NOT?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** Return Companies where one of the related CompanyAdministersConnections match this filter */
  administersConnection_SINGLE?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** Return Companies where some of the related CompanyAdministersConnections match this filter */
  administersConnection_SOME?: InputMaybe<CompanyAdministersConnectionWhere>;
  /** Return Companies where all of the related Municipalities match this filter */
  administers_ALL?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where none of the related Municipalities match this filter */
  administers_NONE?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `administers_NONE` instead. */
  administers_NOT?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where one of the related Municipalities match this filter */
  administers_SINGLE?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where some of the related Municipalities match this filter */
  administers_SOME?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `corporateOwners_SOME` instead. */
  corporateOwners?: InputMaybe<CompanyWhere>;
  corporateOwnersAggregate?: InputMaybe<CompanyCorporateOwnersAggregateInput>;
  /** @deprecated Use `corporateOwnersConnection_SOME` instead. */
  corporateOwnersConnection?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** Return Companies where all of the related CompanyCorporateOwnersConnections match this filter */
  corporateOwnersConnection_ALL?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** Return Companies where none of the related CompanyCorporateOwnersConnections match this filter */
  corporateOwnersConnection_NONE?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** @deprecated Use `corporateOwnersConnection_NONE` instead. */
  corporateOwnersConnection_NOT?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** Return Companies where one of the related CompanyCorporateOwnersConnections match this filter */
  corporateOwnersConnection_SINGLE?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** Return Companies where some of the related CompanyCorporateOwnersConnections match this filter */
  corporateOwnersConnection_SOME?: InputMaybe<CompanyCorporateOwnersConnectionWhere>;
  /** Return Companies where all of the related Companies match this filter */
  corporateOwners_ALL?: InputMaybe<CompanyWhere>;
  /** Return Companies where none of the related Companies match this filter */
  corporateOwners_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `corporateOwners_NONE` instead. */
  corporateOwners_NOT?: InputMaybe<CompanyWhere>;
  /** Return Companies where one of the related Companies match this filter */
  corporateOwners_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Companies where some of the related Companies match this filter */
  corporateOwners_SOME?: InputMaybe<CompanyWhere>;
  legal_form?: InputMaybe<Scalars['String']['input']>;
  legal_form_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legal_form_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legal_form_GT?: InputMaybe<Scalars['String']['input']>;
  legal_form_GTE?: InputMaybe<Scalars['String']['input']>;
  legal_form_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legal_form_LT?: InputMaybe<Scalars['String']['input']>;
  legal_form_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_form_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_form_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_form_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_form_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_form_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  legal_form_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `lotsWon_SOME` instead. */
  lotsWon?: InputMaybe<LotWhere>;
  lotsWonAggregate?: InputMaybe<CompanyLotsWonAggregateInput>;
  /** @deprecated Use `lotsWonConnection_SOME` instead. */
  lotsWonConnection?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** Return Companies where all of the related CompanyLotsWonConnections match this filter */
  lotsWonConnection_ALL?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** Return Companies where none of the related CompanyLotsWonConnections match this filter */
  lotsWonConnection_NONE?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** @deprecated Use `lotsWonConnection_NONE` instead. */
  lotsWonConnection_NOT?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** Return Companies where one of the related CompanyLotsWonConnections match this filter */
  lotsWonConnection_SINGLE?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** Return Companies where some of the related CompanyLotsWonConnections match this filter */
  lotsWonConnection_SOME?: InputMaybe<CompanyLotsWonConnectionWhere>;
  /** Return Companies where all of the related Lots match this filter */
  lotsWon_ALL?: InputMaybe<LotWhere>;
  /** Return Companies where none of the related Lots match this filter */
  lotsWon_NONE?: InputMaybe<LotWhere>;
  /** @deprecated Use `lotsWon_NONE` instead. */
  lotsWon_NOT?: InputMaybe<LotWhere>;
  /** Return Companies where one of the related Lots match this filter */
  lotsWon_SINGLE?: InputMaybe<LotWhere>;
  /** Return Companies where some of the related Lots match this filter */
  lotsWon_SOME?: InputMaybe<LotWhere>;
  /** @deprecated Use `managers_SOME` instead. */
  managers?: InputMaybe<PersonWhere>;
  managersAggregate?: InputMaybe<CompanyManagersAggregateInput>;
  /** @deprecated Use `managersConnection_SOME` instead. */
  managersConnection?: InputMaybe<CompanyManagersConnectionWhere>;
  /** Return Companies where all of the related CompanyManagersConnections match this filter */
  managersConnection_ALL?: InputMaybe<CompanyManagersConnectionWhere>;
  /** Return Companies where none of the related CompanyManagersConnections match this filter */
  managersConnection_NONE?: InputMaybe<CompanyManagersConnectionWhere>;
  /** @deprecated Use `managersConnection_NONE` instead. */
  managersConnection_NOT?: InputMaybe<CompanyManagersConnectionWhere>;
  /** Return Companies where one of the related CompanyManagersConnections match this filter */
  managersConnection_SINGLE?: InputMaybe<CompanyManagersConnectionWhere>;
  /** Return Companies where some of the related CompanyManagersConnections match this filter */
  managersConnection_SOME?: InputMaybe<CompanyManagersConnectionWhere>;
  /** Return Companies where all of the related People match this filter */
  managers_ALL?: InputMaybe<PersonWhere>;
  /** Return Companies where none of the related People match this filter */
  managers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `managers_NONE` instead. */
  managers_NOT?: InputMaybe<PersonWhere>;
  /** Return Companies where one of the related People match this filter */
  managers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Companies where some of the related People match this filter */
  managers_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `memberships_SOME` instead. */
  memberships?: InputMaybe<ConsortiumWhere>;
  membershipsAggregate?: InputMaybe<CompanyMembershipsAggregateInput>;
  /** @deprecated Use `membershipsConnection_SOME` instead. */
  membershipsConnection?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** Return Companies where all of the related CompanyMembershipsConnections match this filter */
  membershipsConnection_ALL?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** Return Companies where none of the related CompanyMembershipsConnections match this filter */
  membershipsConnection_NONE?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** @deprecated Use `membershipsConnection_NONE` instead. */
  membershipsConnection_NOT?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** Return Companies where one of the related CompanyMembershipsConnections match this filter */
  membershipsConnection_SINGLE?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** Return Companies where some of the related CompanyMembershipsConnections match this filter */
  membershipsConnection_SOME?: InputMaybe<CompanyMembershipsConnectionWhere>;
  /** Return Companies where all of the related Consortiums match this filter */
  memberships_ALL?: InputMaybe<ConsortiumWhere>;
  /** Return Companies where none of the related Consortiums match this filter */
  memberships_NONE?: InputMaybe<ConsortiumWhere>;
  /** @deprecated Use `memberships_NONE` instead. */
  memberships_NOT?: InputMaybe<ConsortiumWhere>;
  /** Return Companies where one of the related Consortiums match this filter */
  memberships_SINGLE?: InputMaybe<ConsortiumWhere>;
  /** Return Companies where some of the related Consortiums match this filter */
  memberships_SOME?: InputMaybe<ConsortiumWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `owners_SOME` instead. */
  owners?: InputMaybe<PersonWhere>;
  ownersAggregate?: InputMaybe<CompanyOwnersAggregateInput>;
  /** @deprecated Use `ownersConnection_SOME` instead. */
  ownersConnection?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** Return Companies where all of the related CompanyOwnersConnections match this filter */
  ownersConnection_ALL?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** Return Companies where none of the related CompanyOwnersConnections match this filter */
  ownersConnection_NONE?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** @deprecated Use `ownersConnection_NONE` instead. */
  ownersConnection_NOT?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** Return Companies where one of the related CompanyOwnersConnections match this filter */
  ownersConnection_SINGLE?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** Return Companies where some of the related CompanyOwnersConnections match this filter */
  ownersConnection_SOME?: InputMaybe<CompanyOwnersConnectionWhere>;
  /** Return Companies where all of the related People match this filter */
  owners_ALL?: InputMaybe<PersonWhere>;
  /** Return Companies where none of the related People match this filter */
  owners_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `owners_NONE` instead. */
  owners_NOT?: InputMaybe<PersonWhere>;
  /** Return Companies where one of the related People match this filter */
  owners_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Companies where some of the related People match this filter */
  owners_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `partOf_SOME` instead. */
  partOf?: InputMaybe<CompanyWhere>;
  partOfAggregate?: InputMaybe<CompanyPartOfAggregateInput>;
  /** @deprecated Use `partOfConnection_SOME` instead. */
  partOfConnection?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** Return Companies where all of the related CompanyPartOfConnections match this filter */
  partOfConnection_ALL?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** Return Companies where none of the related CompanyPartOfConnections match this filter */
  partOfConnection_NONE?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** @deprecated Use `partOfConnection_NONE` instead. */
  partOfConnection_NOT?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** Return Companies where one of the related CompanyPartOfConnections match this filter */
  partOfConnection_SINGLE?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** Return Companies where some of the related CompanyPartOfConnections match this filter */
  partOfConnection_SOME?: InputMaybe<CompanyPartOfConnectionWhere>;
  /** Return Companies where all of the related Companies match this filter */
  partOf_ALL?: InputMaybe<CompanyWhere>;
  /** Return Companies where none of the related Companies match this filter */
  partOf_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `partOf_NONE` instead. */
  partOf_NOT?: InputMaybe<CompanyWhere>;
  /** Return Companies where one of the related Companies match this filter */
  partOf_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Companies where some of the related Companies match this filter */
  partOf_SOME?: InputMaybe<CompanyWhere>;
  portfolio?: InputMaybe<Scalars['String']['input']>;
  portfolio_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  portfolio_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_GT?: InputMaybe<Scalars['String']['input']>;
  portfolio_GTE?: InputMaybe<Scalars['String']['input']>;
  portfolio_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  portfolio_LT?: InputMaybe<Scalars['String']['input']>;
  portfolio_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `procurements_SOME` instead. */
  procurements?: InputMaybe<TenderWhere>;
  procurementsAggregate?: InputMaybe<CompanyProcurementsAggregateInput>;
  /** @deprecated Use `procurementsConnection_SOME` instead. */
  procurementsConnection?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** Return Companies where all of the related CompanyProcurementsConnections match this filter */
  procurementsConnection_ALL?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** Return Companies where none of the related CompanyProcurementsConnections match this filter */
  procurementsConnection_NONE?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** @deprecated Use `procurementsConnection_NONE` instead. */
  procurementsConnection_NOT?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** Return Companies where one of the related CompanyProcurementsConnections match this filter */
  procurementsConnection_SINGLE?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** Return Companies where some of the related CompanyProcurementsConnections match this filter */
  procurementsConnection_SOME?: InputMaybe<CompanyProcurementsConnectionWhere>;
  /** Return Companies where all of the related Tenders match this filter */
  procurements_ALL?: InputMaybe<TenderWhere>;
  /** Return Companies where none of the related Tenders match this filter */
  procurements_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `procurements_NONE` instead. */
  procurements_NOT?: InputMaybe<TenderWhere>;
  /** Return Companies where one of the related Tenders match this filter */
  procurements_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Companies where some of the related Tenders match this filter */
  procurements_SOME?: InputMaybe<TenderWhere>;
  public_funds?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  public_funds_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `seatedIn_SOME` instead. */
  seatedIn?: InputMaybe<MunicipalityWhere>;
  seatedInAggregate?: InputMaybe<CompanySeatedInAggregateInput>;
  /** @deprecated Use `seatedInConnection_SOME` instead. */
  seatedInConnection?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** Return Companies where all of the related CompanySeatedInConnections match this filter */
  seatedInConnection_ALL?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** Return Companies where none of the related CompanySeatedInConnections match this filter */
  seatedInConnection_NONE?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** @deprecated Use `seatedInConnection_NONE` instead. */
  seatedInConnection_NOT?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** Return Companies where one of the related CompanySeatedInConnections match this filter */
  seatedInConnection_SINGLE?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** Return Companies where some of the related CompanySeatedInConnections match this filter */
  seatedInConnection_SOME?: InputMaybe<CompanySeatedInConnectionWhere>;
  /** Return Companies where all of the related Municipalities match this filter */
  seatedIn_ALL?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where none of the related Municipalities match this filter */
  seatedIn_NONE?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `seatedIn_NONE` instead. */
  seatedIn_NOT?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where one of the related Municipalities match this filter */
  seatedIn_SINGLE?: InputMaybe<MunicipalityWhere>;
  /** Return Companies where some of the related Municipalities match this filter */
  seatedIn_SOME?: InputMaybe<MunicipalityWhere>;
  sig_award_value?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_award_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_award_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_awards?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_awards_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_buyers?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_buyers_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_buyers_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_cobidder_buyers?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_cobidder_buyers_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_cobidder_buyers_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_cobidders?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_cobidders_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_cobidders_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_computed_at?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_GT?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_GTE?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sig_computed_at_LT?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_computed_at_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_computed_at_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_computed_at_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_computed_at_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_computed_at_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_computed_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_direct_award?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_direct_award_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_direct_award_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_direct_award_value?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_direct_award_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_direct_award_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_flagged_awards?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_flagged_awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_flagged_awards_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_flagged_value?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_flagged_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_flagged_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_holdings_undated?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_holdings_undated_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_holdings_undated_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_mandate_awards?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_awards_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_mandate_officials?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_officials_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_officials_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_mandate_value?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_mandate_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_party_value?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_party_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_party_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_restricted?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_restricted_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_restricted_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_shared_awards?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_shared_awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_shared_awards_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_single_bid?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_single_bid_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_single_bid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_single_bid_value?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_single_bid_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_single_bid_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_subcontracted?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_subcontracted_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_subcontracted_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_top_buyer_key?: InputMaybe<Scalars['ID']['input']>;
  sig_top_buyer_key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  sig_top_buyer_key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_buyer_key_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_key_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_buyer_key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_buyer_name?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_GT?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sig_top_buyer_name_LT?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_buyer_share?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_share_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_share_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_buyer_total?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_total_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_total_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_buyer_value?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_buyer_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_party_awards?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_awards_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sig_top_party_key?: InputMaybe<Scalars['ID']['input']>;
  sig_top_party_key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  sig_top_party_key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_party_key_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_key_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_party_key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sig_top_party_name?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_GT?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_GTE?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sig_top_party_name_LT?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sig_top_party_share?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_share_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_share_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_party_value?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sig_top_party_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_GT?: InputMaybe<Scalars['String']['input']>;
  status_GTE?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_LT?: InputMaybe<Scalars['String']['input']>;
  status_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `subsidiaries_SOME` instead. */
  subsidiaries?: InputMaybe<CompanyWhere>;
  subsidiariesAggregate?: InputMaybe<CompanySubsidiariesAggregateInput>;
  /** @deprecated Use `subsidiariesConnection_SOME` instead. */
  subsidiariesConnection?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** Return Companies where all of the related CompanySubsidiariesConnections match this filter */
  subsidiariesConnection_ALL?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** Return Companies where none of the related CompanySubsidiariesConnections match this filter */
  subsidiariesConnection_NONE?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** @deprecated Use `subsidiariesConnection_NONE` instead. */
  subsidiariesConnection_NOT?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** Return Companies where one of the related CompanySubsidiariesConnections match this filter */
  subsidiariesConnection_SINGLE?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** Return Companies where some of the related CompanySubsidiariesConnections match this filter */
  subsidiariesConnection_SOME?: InputMaybe<CompanySubsidiariesConnectionWhere>;
  /** Return Companies where all of the related Companies match this filter */
  subsidiaries_ALL?: InputMaybe<CompanyWhere>;
  /** Return Companies where none of the related Companies match this filter */
  subsidiaries_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `subsidiaries_NONE` instead. */
  subsidiaries_NOT?: InputMaybe<CompanyWhere>;
  /** Return Companies where one of the related Companies match this filter */
  subsidiaries_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Companies where some of the related Companies match this filter */
  subsidiaries_SOME?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `subsidies_SOME` instead. */
  subsidies?: InputMaybe<SubsidyWhere>;
  subsidiesAggregate?: InputMaybe<CompanySubsidiesAggregateInput>;
  /** @deprecated Use `subsidiesConnection_SOME` instead. */
  subsidiesConnection?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** Return Companies where all of the related CompanySubsidiesConnections match this filter */
  subsidiesConnection_ALL?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** Return Companies where none of the related CompanySubsidiesConnections match this filter */
  subsidiesConnection_NONE?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** @deprecated Use `subsidiesConnection_NONE` instead. */
  subsidiesConnection_NOT?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** Return Companies where one of the related CompanySubsidiesConnections match this filter */
  subsidiesConnection_SINGLE?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** Return Companies where some of the related CompanySubsidiesConnections match this filter */
  subsidiesConnection_SOME?: InputMaybe<CompanySubsidiesConnectionWhere>;
  /** Return Companies where all of the related Subsidies match this filter */
  subsidies_ALL?: InputMaybe<SubsidyWhere>;
  /** Return Companies where none of the related Subsidies match this filter */
  subsidies_NONE?: InputMaybe<SubsidyWhere>;
  /** @deprecated Use `subsidies_NONE` instead. */
  subsidies_NOT?: InputMaybe<SubsidyWhere>;
  /** Return Companies where one of the related Subsidies match this filter */
  subsidies_SINGLE?: InputMaybe<SubsidyWhere>;
  /** Return Companies where some of the related Subsidies match this filter */
  subsidies_SOME?: InputMaybe<SubsidyWhere>;
  /** @deprecated Use `taxDebts_SOME` instead. */
  taxDebts?: InputMaybe<TaxDebtRecordWhere>;
  taxDebtsAggregate?: InputMaybe<CompanyTaxDebtsAggregateInput>;
  /** @deprecated Use `taxDebtsConnection_SOME` instead. */
  taxDebtsConnection?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** Return Companies where all of the related CompanyTaxDebtsConnections match this filter */
  taxDebtsConnection_ALL?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** Return Companies where none of the related CompanyTaxDebtsConnections match this filter */
  taxDebtsConnection_NONE?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** @deprecated Use `taxDebtsConnection_NONE` instead. */
  taxDebtsConnection_NOT?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** Return Companies where one of the related CompanyTaxDebtsConnections match this filter */
  taxDebtsConnection_SINGLE?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** Return Companies where some of the related CompanyTaxDebtsConnections match this filter */
  taxDebtsConnection_SOME?: InputMaybe<CompanyTaxDebtsConnectionWhere>;
  /** Return Companies where all of the related TaxDebtRecords match this filter */
  taxDebts_ALL?: InputMaybe<TaxDebtRecordWhere>;
  /** Return Companies where none of the related TaxDebtRecords match this filter */
  taxDebts_NONE?: InputMaybe<TaxDebtRecordWhere>;
  /** @deprecated Use `taxDebts_NONE` instead. */
  taxDebts_NOT?: InputMaybe<TaxDebtRecordWhere>;
  /** Return Companies where one of the related TaxDebtRecords match this filter */
  taxDebts_SINGLE?: InputMaybe<TaxDebtRecordWhere>;
  /** Return Companies where some of the related TaxDebtRecords match this filter */
  taxDebts_SOME?: InputMaybe<TaxDebtRecordWhere>;
  /** @deprecated Use `tendersWon_SOME` instead. */
  tendersWon?: InputMaybe<TenderWhere>;
  tendersWonAggregate?: InputMaybe<CompanyTendersWonAggregateInput>;
  /** @deprecated Use `tendersWonConnection_SOME` instead. */
  tendersWonConnection?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** Return Companies where all of the related CompanyTendersWonConnections match this filter */
  tendersWonConnection_ALL?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** Return Companies where none of the related CompanyTendersWonConnections match this filter */
  tendersWonConnection_NONE?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** @deprecated Use `tendersWonConnection_NONE` instead. */
  tendersWonConnection_NOT?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** Return Companies where one of the related CompanyTendersWonConnections match this filter */
  tendersWonConnection_SINGLE?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** Return Companies where some of the related CompanyTendersWonConnections match this filter */
  tendersWonConnection_SOME?: InputMaybe<CompanyTendersWonConnectionWhere>;
  /** Return Companies where all of the related Tenders match this filter */
  tendersWon_ALL?: InputMaybe<TenderWhere>;
  /** Return Companies where none of the related Tenders match this filter */
  tendersWon_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `tendersWon_NONE` instead. */
  tendersWon_NOT?: InputMaybe<TenderWhere>;
  /** Return Companies where one of the related Tenders match this filter */
  tendersWon_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Companies where some of the related Tenders match this filter */
  tendersWon_SOME?: InputMaybe<TenderWhere>;
  /** @deprecated Use `treasuryPayments_SOME` instead. */
  treasuryPayments?: InputMaybe<TreasuryPaymentWhere>;
  treasuryPaymentsAggregate?: InputMaybe<CompanyTreasuryPaymentsAggregateInput>;
  /** @deprecated Use `treasuryPaymentsConnection_SOME` instead. */
  treasuryPaymentsConnection?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** Return Companies where all of the related CompanyTreasuryPaymentsConnections match this filter */
  treasuryPaymentsConnection_ALL?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** Return Companies where none of the related CompanyTreasuryPaymentsConnections match this filter */
  treasuryPaymentsConnection_NONE?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** @deprecated Use `treasuryPaymentsConnection_NONE` instead. */
  treasuryPaymentsConnection_NOT?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** Return Companies where one of the related CompanyTreasuryPaymentsConnections match this filter */
  treasuryPaymentsConnection_SINGLE?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** Return Companies where some of the related CompanyTreasuryPaymentsConnections match this filter */
  treasuryPaymentsConnection_SOME?: InputMaybe<CompanyTreasuryPaymentsConnectionWhere>;
  /** Return Companies where all of the related TreasuryPayments match this filter */
  treasuryPayments_ALL?: InputMaybe<TreasuryPaymentWhere>;
  /** Return Companies where none of the related TreasuryPayments match this filter */
  treasuryPayments_NONE?: InputMaybe<TreasuryPaymentWhere>;
  /** @deprecated Use `treasuryPayments_NONE` instead. */
  treasuryPayments_NOT?: InputMaybe<TreasuryPaymentWhere>;
  /** Return Companies where one of the related TreasuryPayments match this filter */
  treasuryPayments_SINGLE?: InputMaybe<TreasuryPaymentWhere>;
  /** Return Companies where some of the related TreasuryPayments match this filter */
  treasuryPayments_SOME?: InputMaybe<TreasuryPaymentWhere>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `units_SOME` instead. */
  units?: InputMaybe<CompanyWhere>;
  unitsAggregate?: InputMaybe<CompanyUnitsAggregateInput>;
  /** @deprecated Use `unitsConnection_SOME` instead. */
  unitsConnection?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** Return Companies where all of the related CompanyUnitsConnections match this filter */
  unitsConnection_ALL?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** Return Companies where none of the related CompanyUnitsConnections match this filter */
  unitsConnection_NONE?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** @deprecated Use `unitsConnection_NONE` instead. */
  unitsConnection_NOT?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** Return Companies where one of the related CompanyUnitsConnections match this filter */
  unitsConnection_SINGLE?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** Return Companies where some of the related CompanyUnitsConnections match this filter */
  unitsConnection_SOME?: InputMaybe<CompanyUnitsConnectionWhere>;
  /** Return Companies where all of the related Companies match this filter */
  units_ALL?: InputMaybe<CompanyWhere>;
  /** Return Companies where none of the related Companies match this filter */
  units_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `units_NONE` instead. */
  units_NOT?: InputMaybe<CompanyWhere>;
  /** Return Companies where one of the related Companies match this filter */
  units_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Companies where some of the related Companies match this filter */
  units_SOME?: InputMaybe<CompanyWhere>;
};

export type Consortium = {
  __typename?: 'Consortium';
  name?: Maybe<Scalars['String']['output']>;
  partners: Array<Company>;
  partnersAggregate?: Maybe<ConsortiumCompanyPartnersAggregationSelection>;
  partnersConnection: ConsortiumPartnersConnection;
  tendersWon: Array<Tender>;
  tendersWonAggregate?: Maybe<ConsortiumTenderTendersWonAggregationSelection>;
  tendersWonConnection: ConsortiumTendersWonConnection;
  uic: Scalars['ID']['output'];
};


export type ConsortiumPartnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type ConsortiumPartnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type ConsortiumPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ConsortiumPartnersConnectionSort>>;
  where?: InputMaybe<ConsortiumPartnersConnectionWhere>;
};


export type ConsortiumTendersWonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type ConsortiumTendersWonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type ConsortiumTendersWonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ConsortiumTendersWonConnectionSort>>;
  where?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
};

export type ConsortiumAggregateSelection = {
  __typename?: 'ConsortiumAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type ConsortiumCompanyPartnersAggregationSelection = {
  __typename?: 'ConsortiumCompanyPartnersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ConsortiumCompanyPartnersEdgeAggregateSelection>;
  node?: Maybe<ConsortiumCompanyPartnersNodeAggregateSelection>;
};

export type ConsortiumCompanyPartnersEdgeAggregateSelection = {
  __typename?: 'ConsortiumCompanyPartnersEdgeAggregateSelection';
  share_percent: FloatAggregateSelection;
};

export type ConsortiumCompanyPartnersNodeAggregateSelection = {
  __typename?: 'ConsortiumCompanyPartnersNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type ConsortiumEdge = {
  __typename?: 'ConsortiumEdge';
  cursor: Scalars['String']['output'];
  node: Consortium;
};

export type ConsortiumOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ConsortiumSort objects to sort Consortiums by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ConsortiumSort>>;
};

export type ConsortiumPartnersAggregateInput = {
  AND?: InputMaybe<Array<ConsortiumPartnersAggregateInput>>;
  NOT?: InputMaybe<ConsortiumPartnersAggregateInput>;
  OR?: InputMaybe<Array<ConsortiumPartnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<PartnershipAggregationWhereInput>;
  node?: InputMaybe<ConsortiumPartnersNodeAggregationWhereInput>;
};

export type ConsortiumPartnersConnection = {
  __typename?: 'ConsortiumPartnersConnection';
  edges: Array<ConsortiumPartnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConsortiumPartnersConnectionSort = {
  edge?: InputMaybe<PartnershipSort>;
  node?: InputMaybe<CompanySort>;
};

export type ConsortiumPartnersConnectionWhere = {
  AND?: InputMaybe<Array<ConsortiumPartnersConnectionWhere>>;
  NOT?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  OR?: InputMaybe<Array<ConsortiumPartnersConnectionWhere>>;
  edge?: InputMaybe<PartnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PartnershipWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type ConsortiumPartnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ConsortiumPartnersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ConsortiumPartnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ConsortiumPartnersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type ConsortiumPartnersRelationship = {
  __typename?: 'ConsortiumPartnersRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Partnership;
};

/** Fields to sort Consortiums by. The order in which sorts are applied is not guaranteed when specifying many fields in one ConsortiumSort object. */
export type ConsortiumSort = {
  name?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
};

export type ConsortiumTenderTendersWonAggregationSelection = {
  __typename?: 'ConsortiumTenderTendersWonAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ConsortiumTenderTendersWonEdgeAggregateSelection>;
  node?: Maybe<ConsortiumTenderTendersWonNodeAggregateSelection>;
};

export type ConsortiumTenderTendersWonEdgeAggregateSelection = {
  __typename?: 'ConsortiumTenderTendersWonEdgeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
};

export type ConsortiumTenderTendersWonNodeAggregateSelection = {
  __typename?: 'ConsortiumTenderTendersWonNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type ConsortiumTendersWonAggregateInput = {
  AND?: InputMaybe<Array<ConsortiumTendersWonAggregateInput>>;
  NOT?: InputMaybe<ConsortiumTendersWonAggregateInput>;
  OR?: InputMaybe<Array<ConsortiumTendersWonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AwardAggregationWhereInput>;
  node?: InputMaybe<ConsortiumTendersWonNodeAggregationWhereInput>;
};

export type ConsortiumTendersWonConnection = {
  __typename?: 'ConsortiumTendersWonConnection';
  edges: Array<ConsortiumTendersWonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConsortiumTendersWonConnectionSort = {
  edge?: InputMaybe<AwardSort>;
  node?: InputMaybe<TenderSort>;
};

export type ConsortiumTendersWonConnectionWhere = {
  AND?: InputMaybe<Array<ConsortiumTendersWonConnectionWhere>>;
  NOT?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  OR?: InputMaybe<Array<ConsortiumTendersWonConnectionWhere>>;
  edge?: InputMaybe<AwardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<AwardWhere>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type ConsortiumTendersWonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ConsortiumTendersWonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ConsortiumTendersWonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ConsortiumTendersWonNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsortiumTendersWonRelationship = {
  __typename?: 'ConsortiumTendersWonRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
  properties: Award;
};

export type ConsortiumWhere = {
  AND?: InputMaybe<Array<ConsortiumWhere>>;
  NOT?: InputMaybe<ConsortiumWhere>;
  OR?: InputMaybe<Array<ConsortiumWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `partners_SOME` instead. */
  partners?: InputMaybe<CompanyWhere>;
  partnersAggregate?: InputMaybe<ConsortiumPartnersAggregateInput>;
  /** @deprecated Use `partnersConnection_SOME` instead. */
  partnersConnection?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** Return Consortiums where all of the related ConsortiumPartnersConnections match this filter */
  partnersConnection_ALL?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** Return Consortiums where none of the related ConsortiumPartnersConnections match this filter */
  partnersConnection_NONE?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** @deprecated Use `partnersConnection_NONE` instead. */
  partnersConnection_NOT?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** Return Consortiums where one of the related ConsortiumPartnersConnections match this filter */
  partnersConnection_SINGLE?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** Return Consortiums where some of the related ConsortiumPartnersConnections match this filter */
  partnersConnection_SOME?: InputMaybe<ConsortiumPartnersConnectionWhere>;
  /** Return Consortiums where all of the related Companies match this filter */
  partners_ALL?: InputMaybe<CompanyWhere>;
  /** Return Consortiums where none of the related Companies match this filter */
  partners_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `partners_NONE` instead. */
  partners_NOT?: InputMaybe<CompanyWhere>;
  /** Return Consortiums where one of the related Companies match this filter */
  partners_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Consortiums where some of the related Companies match this filter */
  partners_SOME?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `tendersWon_SOME` instead. */
  tendersWon?: InputMaybe<TenderWhere>;
  tendersWonAggregate?: InputMaybe<ConsortiumTendersWonAggregateInput>;
  /** @deprecated Use `tendersWonConnection_SOME` instead. */
  tendersWonConnection?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** Return Consortiums where all of the related ConsortiumTendersWonConnections match this filter */
  tendersWonConnection_ALL?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** Return Consortiums where none of the related ConsortiumTendersWonConnections match this filter */
  tendersWonConnection_NONE?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** @deprecated Use `tendersWonConnection_NONE` instead. */
  tendersWonConnection_NOT?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** Return Consortiums where one of the related ConsortiumTendersWonConnections match this filter */
  tendersWonConnection_SINGLE?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** Return Consortiums where some of the related ConsortiumTendersWonConnections match this filter */
  tendersWonConnection_SOME?: InputMaybe<ConsortiumTendersWonConnectionWhere>;
  /** Return Consortiums where all of the related Tenders match this filter */
  tendersWon_ALL?: InputMaybe<TenderWhere>;
  /** Return Consortiums where none of the related Tenders match this filter */
  tendersWon_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `tendersWon_NONE` instead. */
  tendersWon_NOT?: InputMaybe<TenderWhere>;
  /** Return Consortiums where one of the related Tenders match this filter */
  tendersWon_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Consortiums where some of the related Tenders match this filter */
  tendersWon_SOME?: InputMaybe<TenderWhere>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ConsortiumsConnection = {
  __typename?: 'ConsortiumsConnection';
  edges: Array<ConsortiumEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CouncilInterestLead = {
  __typename?: 'CouncilInterestLead';
  awards: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  councillorHash: Scalars['ID']['output'];
  councillorName?: Maybe<Scalars['String']['output']>;
  electedYear?: Maybe<Scalars['Int']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  municipalityKey: Scalars['ID']['output'];
  municipalityName?: Maybe<Scalars['String']['output']>;
  namesakes: Scalars['Int']['output'];
  roles: Array<Scalars['String']['output']>;
  sitting: Scalars['Boolean']['output'];
  uic: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type CouncilInterestLeadAggregateSelection = {
  __typename?: 'CouncilInterestLeadAggregateSelection';
  awards: IntAggregateSelection;
  companyName: StringAggregateSelection;
  councillorHash: IdAggregateSelection;
  councillorName: StringAggregateSelection;
  count: Scalars['Int']['output'];
  electedYear: IntAggregateSelection;
  legalForm: StringAggregateSelection;
  municipalityKey: IdAggregateSelection;
  municipalityName: StringAggregateSelection;
  namesakes: IntAggregateSelection;
  uic: IdAggregateSelection;
  value: FloatAggregateSelection;
};

export type CouncilInterestLeadEdge = {
  __typename?: 'CouncilInterestLeadEdge';
  cursor: Scalars['String']['output'];
  node: CouncilInterestLead;
};

/** Fields to sort CouncilInterestLeads by. The order in which sorts are applied is not guaranteed when specifying many fields in one CouncilInterestLeadSort object. */
export type CouncilInterestLeadSort = {
  awards?: InputMaybe<SortDirection>;
  companyName?: InputMaybe<SortDirection>;
  councillorHash?: InputMaybe<SortDirection>;
  councillorName?: InputMaybe<SortDirection>;
  electedYear?: InputMaybe<SortDirection>;
  legalForm?: InputMaybe<SortDirection>;
  municipalityKey?: InputMaybe<SortDirection>;
  municipalityName?: InputMaybe<SortDirection>;
  namesakes?: InputMaybe<SortDirection>;
  sitting?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type CouncilInterestLeadWhere = {
  AND?: InputMaybe<Array<CouncilInterestLeadWhere>>;
  NOT?: InputMaybe<CouncilInterestLeadWhere>;
  OR?: InputMaybe<Array<CouncilInterestLeadWhere>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  companyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  companyName_GT?: InputMaybe<Scalars['String']['input']>;
  companyName_GTE?: InputMaybe<Scalars['String']['input']>;
  companyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName_LT?: InputMaybe<Scalars['String']['input']>;
  companyName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companyName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companyName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companyName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companyName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companyName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  companyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  councillorHash?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorHash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorHash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councillorName?: InputMaybe<Scalars['String']['input']>;
  councillorName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  councillorName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  councillorName_GT?: InputMaybe<Scalars['String']['input']>;
  councillorName_GTE?: InputMaybe<Scalars['String']['input']>;
  councillorName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  councillorName_LT?: InputMaybe<Scalars['String']['input']>;
  councillorName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councillorName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  councillorName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  electedYear?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GTE?: InputMaybe<Scalars['Int']['input']>;
  electedYear_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  electedYear_LT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legalForm?: InputMaybe<Scalars['String']['input']>;
  legalForm_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legalForm_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalForm_GT?: InputMaybe<Scalars['String']['input']>;
  legalForm_GTE?: InputMaybe<Scalars['String']['input']>;
  legalForm_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalForm_LT?: InputMaybe<Scalars['String']['input']>;
  legalForm_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legalForm_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legalForm_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legalForm_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legalForm_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legalForm_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalForm_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityKey?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityName?: InputMaybe<Scalars['String']['input']>;
  municipalityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  municipalityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityName_GT?: InputMaybe<Scalars['String']['input']>;
  municipalityName_GTE?: InputMaybe<Scalars['String']['input']>;
  municipalityName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  municipalityName_LT?: InputMaybe<Scalars['String']['input']>;
  municipalityName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipalityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  namesakes?: InputMaybe<Scalars['Int']['input']>;
  namesakes_GT?: InputMaybe<Scalars['Int']['input']>;
  namesakes_GTE?: InputMaybe<Scalars['Int']['input']>;
  namesakes_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  namesakes_LT?: InputMaybe<Scalars['Int']['input']>;
  namesakes_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  namesakes_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  namesakes_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  roles_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roles_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roles_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sitting?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sitting_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CouncilInterestLeadsConnection = {
  __typename?: 'CouncilInterestLeadsConnection';
  edges: Array<CouncilInterestLeadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataIssue = {
  __typename?: 'DataIssue';
  firstSeen?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  recordId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DataIssueAggregateSelection = {
  __typename?: 'DataIssueAggregateSelection';
  count: Scalars['Int']['output'];
  firstSeen: StringAggregateSelection;
  lastSeen: StringAggregateSelection;
  reason: StringAggregateSelection;
  recordId: StringAggregateSelection;
  source: StringAggregateSelection;
  value: StringAggregateSelection;
};

export type DataIssueEdge = {
  __typename?: 'DataIssueEdge';
  cursor: Scalars['String']['output'];
  node: DataIssue;
};

/** Fields to sort DataIssues by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataIssueSort object. */
export type DataIssueSort = {
  firstSeen?: InputMaybe<SortDirection>;
  lastSeen?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  recordId?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type DataIssueWhere = {
  AND?: InputMaybe<Array<DataIssueWhere>>;
  NOT?: InputMaybe<DataIssueWhere>;
  OR?: InputMaybe<Array<DataIssueWhere>>;
  firstSeen?: InputMaybe<Scalars['String']['input']>;
  firstSeen_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstSeen_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstSeen_GT?: InputMaybe<Scalars['String']['input']>;
  firstSeen_GTE?: InputMaybe<Scalars['String']['input']>;
  firstSeen_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstSeen_LT?: InputMaybe<Scalars['String']['input']>;
  firstSeen_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstSeen_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstSeen_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstSeen_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstSeen_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstSeen_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstSeen_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastSeen?: InputMaybe<Scalars['String']['input']>;
  lastSeen_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastSeen_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastSeen_GT?: InputMaybe<Scalars['String']['input']>;
  lastSeen_GTE?: InputMaybe<Scalars['String']['input']>;
  lastSeen_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastSeen_LT?: InputMaybe<Scalars['String']['input']>;
  lastSeen_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSeen_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSeen_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSeen_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSeen_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSeen_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastSeen_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_GT?: InputMaybe<Scalars['String']['input']>;
  reason_GTE?: InputMaybe<Scalars['String']['input']>;
  reason_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  reason_LT?: InputMaybe<Scalars['String']['input']>;
  reason_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  recordId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordId_GT?: InputMaybe<Scalars['String']['input']>;
  recordId_GTE?: InputMaybe<Scalars['String']['input']>;
  recordId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordId_LT?: InputMaybe<Scalars['String']['input']>;
  recordId_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_GT?: InputMaybe<Scalars['String']['input']>;
  value_GTE?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_LT?: InputMaybe<Scalars['String']['input']>;
  value_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DataIssuesConnection = {
  __typename?: 'DataIssuesConnection';
  edges: Array<DataIssueEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FacetGroup = {
  __typename?: 'FacetGroup';
  key: Scalars['String']['output'];
  values: Array<FacetValue>;
};

export type FacetGroupAggregateSelection = {
  __typename?: 'FacetGroupAggregateSelection';
  count: Scalars['Int']['output'];
  key: StringAggregateSelection;
};

export type FacetGroupEdge = {
  __typename?: 'FacetGroupEdge';
  cursor: Scalars['String']['output'];
  node: FacetGroup;
};

export type FacetGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FacetGroupSort objects to sort FacetGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FacetGroupSort>>;
};

/** Fields to sort FacetGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one FacetGroupSort object. */
export type FacetGroupSort = {
  key?: InputMaybe<SortDirection>;
};

export type FacetGroupWhere = {
  AND?: InputMaybe<Array<FacetGroupWhere>>;
  NOT?: InputMaybe<FacetGroupWhere>;
  OR?: InputMaybe<Array<FacetGroupWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_GT?: InputMaybe<Scalars['String']['input']>;
  key_GTE?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_LT?: InputMaybe<Scalars['String']['input']>;
  key_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FacetGroupsConnection = {
  __typename?: 'FacetGroupsConnection';
  edges: Array<FacetGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FacetValue = {
  __typename?: 'FacetValue';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type FacetValueAggregateSelection = {
  __typename?: 'FacetValueAggregateSelection';
  count: IntAggregateSelection;
  value: StringAggregateSelection;
};

export type FacetValueEdge = {
  __typename?: 'FacetValueEdge';
  cursor: Scalars['String']['output'];
  node: FacetValue;
};

export type FacetValueOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FacetValueSort objects to sort FacetValues by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FacetValueSort>>;
};

/** Fields to sort FacetValues by. The order in which sorts are applied is not guaranteed when specifying many fields in one FacetValueSort object. */
export type FacetValueSort = {
  count?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type FacetValueWhere = {
  AND?: InputMaybe<Array<FacetValueWhere>>;
  NOT?: InputMaybe<FacetValueWhere>;
  OR?: InputMaybe<Array<FacetValueWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_GT?: InputMaybe<Scalars['String']['input']>;
  value_GTE?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  value_LT?: InputMaybe<Scalars['String']['input']>;
  value_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FacetValuesConnection = {
  __typename?: 'FacetValuesConnection';
  edges: Array<FacetValueEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FloatAggregateSelection = {
  __typename?: 'FloatAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type Government = {
  __typename?: 'Government';
  end_date?: Maybe<Scalars['String']['output']>;
  formedBy: Array<Party>;
  formedByAggregate?: Maybe<GovernmentPartyFormedByAggregationSelection>;
  formedByConnection: GovernmentFormedByConnection;
  gov_id: Scalars['ID']['output'];
  is_caretaker?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pm_name?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Scalars['String']['output']>>;
  start_date?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};


export type GovernmentFormedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type GovernmentFormedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type GovernmentFormedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GovernmentFormedByConnectionSort>>;
  where?: InputMaybe<GovernmentFormedByConnectionWhere>;
};

export type GovernmentAggregateSelection = {
  __typename?: 'GovernmentAggregateSelection';
  count: Scalars['Int']['output'];
  end_date: StringAggregateSelection;
  gov_id: IdAggregateSelection;
  name: StringAggregateSelection;
  pm_name: StringAggregateSelection;
  start_date: StringAggregateSelection;
};

export type GovernmentEdge = {
  __typename?: 'GovernmentEdge';
  cursor: Scalars['String']['output'];
  node: Government;
};

export type GovernmentFormedByAggregateInput = {
  AND?: InputMaybe<Array<GovernmentFormedByAggregateInput>>;
  NOT?: InputMaybe<GovernmentFormedByAggregateInput>;
  OR?: InputMaybe<Array<GovernmentFormedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GovernmentFormedByNodeAggregationWhereInput>;
};

export type GovernmentFormedByConnection = {
  __typename?: 'GovernmentFormedByConnection';
  edges: Array<GovernmentFormedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GovernmentFormedByConnectionSort = {
  node?: InputMaybe<PartySort>;
};

export type GovernmentFormedByConnectionWhere = {
  AND?: InputMaybe<Array<GovernmentFormedByConnectionWhere>>;
  NOT?: InputMaybe<GovernmentFormedByConnectionWhere>;
  OR?: InputMaybe<Array<GovernmentFormedByConnectionWhere>>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type GovernmentFormedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GovernmentFormedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GovernmentFormedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GovernmentFormedByNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GovernmentFormedByRelationship = {
  __typename?: 'GovernmentFormedByRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
};

export type GovernmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GovernmentSort objects to sort Governments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GovernmentSort>>;
};

export type GovernmentPartyFormedByAggregationSelection = {
  __typename?: 'GovernmentPartyFormedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GovernmentPartyFormedByNodeAggregateSelection>;
};

export type GovernmentPartyFormedByNodeAggregateSelection = {
  __typename?: 'GovernmentPartyFormedByNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

/** Fields to sort Governments by. The order in which sorts are applied is not guaranteed when specifying many fields in one GovernmentSort object. */
export type GovernmentSort = {
  end_date?: InputMaybe<SortDirection>;
  gov_id?: InputMaybe<SortDirection>;
  is_caretaker?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pm_name?: InputMaybe<SortDirection>;
  start_date?: InputMaybe<SortDirection>;
  verified?: InputMaybe<SortDirection>;
};

export type GovernmentWhere = {
  AND?: InputMaybe<Array<GovernmentWhere>>;
  NOT?: InputMaybe<GovernmentWhere>;
  OR?: InputMaybe<Array<GovernmentWhere>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  end_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  end_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_date_GT?: InputMaybe<Scalars['String']['input']>;
  end_date_GTE?: InputMaybe<Scalars['String']['input']>;
  end_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date_LT?: InputMaybe<Scalars['String']['input']>;
  end_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `formedBy_SOME` instead. */
  formedBy?: InputMaybe<PartyWhere>;
  formedByAggregate?: InputMaybe<GovernmentFormedByAggregateInput>;
  /** @deprecated Use `formedByConnection_SOME` instead. */
  formedByConnection?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** Return Governments where all of the related GovernmentFormedByConnections match this filter */
  formedByConnection_ALL?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** Return Governments where none of the related GovernmentFormedByConnections match this filter */
  formedByConnection_NONE?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** @deprecated Use `formedByConnection_NONE` instead. */
  formedByConnection_NOT?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** Return Governments where one of the related GovernmentFormedByConnections match this filter */
  formedByConnection_SINGLE?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** Return Governments where some of the related GovernmentFormedByConnections match this filter */
  formedByConnection_SOME?: InputMaybe<GovernmentFormedByConnectionWhere>;
  /** Return Governments where all of the related Parties match this filter */
  formedBy_ALL?: InputMaybe<PartyWhere>;
  /** Return Governments where none of the related Parties match this filter */
  formedBy_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `formedBy_NONE` instead. */
  formedBy_NOT?: InputMaybe<PartyWhere>;
  /** Return Governments where one of the related Parties match this filter */
  formedBy_SINGLE?: InputMaybe<PartyWhere>;
  /** Return Governments where some of the related Parties match this filter */
  formedBy_SOME?: InputMaybe<PartyWhere>;
  gov_id?: InputMaybe<Scalars['ID']['input']>;
  gov_id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  gov_id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  gov_id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gov_id_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gov_id_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gov_id_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gov_id_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gov_id_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  gov_id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  is_caretaker?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_caretaker_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pm_name?: InputMaybe<Scalars['String']['input']>;
  pm_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pm_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pm_name_GT?: InputMaybe<Scalars['String']['input']>;
  pm_name_GTE?: InputMaybe<Scalars['String']['input']>;
  pm_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pm_name_LT?: InputMaybe<Scalars['String']['input']>;
  pm_name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pm_name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pm_name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pm_name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pm_name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pm_name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pm_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  sources_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sources_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sources_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  start_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date_GT?: InputMaybe<Scalars['String']['input']>;
  start_date_GTE?: InputMaybe<Scalars['String']['input']>;
  start_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date_LT?: InputMaybe<Scalars['String']['input']>;
  start_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  verified_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GovernmentsConnection = {
  __typename?: 'GovernmentsConnection';
  edges: Array<GovernmentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelection = {
  __typename?: 'IDAggregateSelection';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export type Lot = {
  __typename?: 'Lot';
  awarded_amount?: Maybe<Scalars['Float']['output']>;
  contract_number?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['String']['output']>;
  lot_key: Scalars['ID']['output'];
  publication_date?: Maybe<Scalars['String']['output']>;
  tender: Array<Tender>;
  tenderAggregate?: Maybe<LotTenderTenderAggregationSelection>;
  tenderConnection: LotTenderConnection;
  winners: Array<Company>;
  winnersAggregate?: Maybe<LotCompanyWinnersAggregationSelection>;
  winnersConnection: LotWinnersConnection;
};


export type LotTenderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type LotTenderAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type LotTenderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LotTenderConnectionSort>>;
  where?: InputMaybe<LotTenderConnectionWhere>;
};


export type LotWinnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type LotWinnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type LotWinnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LotWinnersConnectionSort>>;
  where?: InputMaybe<LotWinnersConnectionWhere>;
};

export type LotAggregateSelection = {
  __typename?: 'LotAggregateSelection';
  awarded_amount: FloatAggregateSelection;
  contract_number: StringAggregateSelection;
  count: Scalars['Int']['output'];
  currency: StringAggregateSelection;
  lot_id: StringAggregateSelection;
  lot_key: IdAggregateSelection;
  publication_date: StringAggregateSelection;
};

export type LotCompanyWinnersAggregationSelection = {
  __typename?: 'LotCompanyWinnersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LotCompanyWinnersEdgeAggregateSelection>;
  node?: Maybe<LotCompanyWinnersNodeAggregateSelection>;
};

export type LotCompanyWinnersEdgeAggregateSelection = {
  __typename?: 'LotCompanyWinnersEdgeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
};

export type LotCompanyWinnersNodeAggregateSelection = {
  __typename?: 'LotCompanyWinnersNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type LotEdge = {
  __typename?: 'LotEdge';
  cursor: Scalars['String']['output'];
  node: Lot;
};

export type LotOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LotSort objects to sort Lots by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LotSort>>;
};

/** Fields to sort Lots by. The order in which sorts are applied is not guaranteed when specifying many fields in one LotSort object. */
export type LotSort = {
  awarded_amount?: InputMaybe<SortDirection>;
  contract_number?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  lot_id?: InputMaybe<SortDirection>;
  lot_key?: InputMaybe<SortDirection>;
  publication_date?: InputMaybe<SortDirection>;
};

export type LotTenderAggregateInput = {
  AND?: InputMaybe<Array<LotTenderAggregateInput>>;
  NOT?: InputMaybe<LotTenderAggregateInput>;
  OR?: InputMaybe<Array<LotTenderAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LotTenderNodeAggregationWhereInput>;
};

export type LotTenderConnection = {
  __typename?: 'LotTenderConnection';
  edges: Array<LotTenderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LotTenderConnectionSort = {
  node?: InputMaybe<TenderSort>;
};

export type LotTenderConnectionWhere = {
  AND?: InputMaybe<Array<LotTenderConnectionWhere>>;
  NOT?: InputMaybe<LotTenderConnectionWhere>;
  OR?: InputMaybe<Array<LotTenderConnectionWhere>>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type LotTenderNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LotTenderNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LotTenderNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LotTenderNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LotTenderRelationship = {
  __typename?: 'LotTenderRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type LotTenderTenderAggregationSelection = {
  __typename?: 'LotTenderTenderAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LotTenderTenderNodeAggregateSelection>;
};

export type LotTenderTenderNodeAggregateSelection = {
  __typename?: 'LotTenderTenderNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type LotWhere = {
  AND?: InputMaybe<Array<LotWhere>>;
  NOT?: InputMaybe<LotWhere>;
  OR?: InputMaybe<Array<LotWhere>>;
  awarded_amount?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contract_number?: InputMaybe<Scalars['String']['input']>;
  contract_number_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contract_number_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contract_number_GT?: InputMaybe<Scalars['String']['input']>;
  contract_number_GTE?: InputMaybe<Scalars['String']['input']>;
  contract_number_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contract_number_LT?: InputMaybe<Scalars['String']['input']>;
  contract_number_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_number_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_number_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_number_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_number_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_number_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contract_number_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_GT?: InputMaybe<Scalars['String']['input']>;
  currency_GTE?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_LT?: InputMaybe<Scalars['String']['input']>;
  currency_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['String']['input']>;
  lot_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lot_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lot_id_GT?: InputMaybe<Scalars['String']['input']>;
  lot_id_GTE?: InputMaybe<Scalars['String']['input']>;
  lot_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lot_id_LT?: InputMaybe<Scalars['String']['input']>;
  lot_id_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_id_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_id_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lot_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lot_key?: InputMaybe<Scalars['ID']['input']>;
  lot_key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  lot_key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lot_key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lot_key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  publication_date?: InputMaybe<Scalars['String']['input']>;
  publication_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  publication_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  publication_date_GT?: InputMaybe<Scalars['String']['input']>;
  publication_date_GTE?: InputMaybe<Scalars['String']['input']>;
  publication_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publication_date_LT?: InputMaybe<Scalars['String']['input']>;
  publication_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publication_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `tender_SOME` instead. */
  tender?: InputMaybe<TenderWhere>;
  tenderAggregate?: InputMaybe<LotTenderAggregateInput>;
  /** @deprecated Use `tenderConnection_SOME` instead. */
  tenderConnection?: InputMaybe<LotTenderConnectionWhere>;
  /** Return Lots where all of the related LotTenderConnections match this filter */
  tenderConnection_ALL?: InputMaybe<LotTenderConnectionWhere>;
  /** Return Lots where none of the related LotTenderConnections match this filter */
  tenderConnection_NONE?: InputMaybe<LotTenderConnectionWhere>;
  /** @deprecated Use `tenderConnection_NONE` instead. */
  tenderConnection_NOT?: InputMaybe<LotTenderConnectionWhere>;
  /** Return Lots where one of the related LotTenderConnections match this filter */
  tenderConnection_SINGLE?: InputMaybe<LotTenderConnectionWhere>;
  /** Return Lots where some of the related LotTenderConnections match this filter */
  tenderConnection_SOME?: InputMaybe<LotTenderConnectionWhere>;
  /** Return Lots where all of the related Tenders match this filter */
  tender_ALL?: InputMaybe<TenderWhere>;
  /** Return Lots where none of the related Tenders match this filter */
  tender_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `tender_NONE` instead. */
  tender_NOT?: InputMaybe<TenderWhere>;
  /** Return Lots where one of the related Tenders match this filter */
  tender_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Lots where some of the related Tenders match this filter */
  tender_SOME?: InputMaybe<TenderWhere>;
  /** @deprecated Use `winners_SOME` instead. */
  winners?: InputMaybe<CompanyWhere>;
  winnersAggregate?: InputMaybe<LotWinnersAggregateInput>;
  /** @deprecated Use `winnersConnection_SOME` instead. */
  winnersConnection?: InputMaybe<LotWinnersConnectionWhere>;
  /** Return Lots where all of the related LotWinnersConnections match this filter */
  winnersConnection_ALL?: InputMaybe<LotWinnersConnectionWhere>;
  /** Return Lots where none of the related LotWinnersConnections match this filter */
  winnersConnection_NONE?: InputMaybe<LotWinnersConnectionWhere>;
  /** @deprecated Use `winnersConnection_NONE` instead. */
  winnersConnection_NOT?: InputMaybe<LotWinnersConnectionWhere>;
  /** Return Lots where one of the related LotWinnersConnections match this filter */
  winnersConnection_SINGLE?: InputMaybe<LotWinnersConnectionWhere>;
  /** Return Lots where some of the related LotWinnersConnections match this filter */
  winnersConnection_SOME?: InputMaybe<LotWinnersConnectionWhere>;
  /** Return Lots where all of the related Companies match this filter */
  winners_ALL?: InputMaybe<CompanyWhere>;
  /** Return Lots where none of the related Companies match this filter */
  winners_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `winners_NONE` instead. */
  winners_NOT?: InputMaybe<CompanyWhere>;
  /** Return Lots where one of the related Companies match this filter */
  winners_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Lots where some of the related Companies match this filter */
  winners_SOME?: InputMaybe<CompanyWhere>;
};

export type LotWinnersAggregateInput = {
  AND?: InputMaybe<Array<LotWinnersAggregateInput>>;
  NOT?: InputMaybe<LotWinnersAggregateInput>;
  OR?: InputMaybe<Array<LotWinnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AwardAggregationWhereInput>;
  node?: InputMaybe<LotWinnersNodeAggregationWhereInput>;
};

export type LotWinnersConnection = {
  __typename?: 'LotWinnersConnection';
  edges: Array<LotWinnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LotWinnersConnectionSort = {
  edge?: InputMaybe<AwardSort>;
  node?: InputMaybe<CompanySort>;
};

export type LotWinnersConnectionWhere = {
  AND?: InputMaybe<Array<LotWinnersConnectionWhere>>;
  NOT?: InputMaybe<LotWinnersConnectionWhere>;
  OR?: InputMaybe<Array<LotWinnersConnectionWhere>>;
  edge?: InputMaybe<AwardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<AwardWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type LotWinnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LotWinnersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LotWinnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LotWinnersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type LotWinnersRelationship = {
  __typename?: 'LotWinnersRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Award;
};

export type LotsConnection = {
  __typename?: 'LotsConnection';
  edges: Array<LotEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Company.managers
 * * Person.managedCompanies
 */
export type Management = {
  __typename?: 'Management';
  role?: Maybe<Scalars['String']['output']>;
  valid_from?: Maybe<Scalars['String']['output']>;
  valid_to?: Maybe<Scalars['String']['output']>;
};

export type ManagementAggregationWhereInput = {
  AND?: InputMaybe<Array<ManagementAggregationWhereInput>>;
  NOT?: InputMaybe<ManagementAggregationWhereInput>;
  OR?: InputMaybe<Array<ManagementAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ManagementSort = {
  role?: InputMaybe<SortDirection>;
  valid_from?: InputMaybe<SortDirection>;
  valid_to?: InputMaybe<SortDirection>;
};

export type ManagementWhere = {
  AND?: InputMaybe<Array<ManagementWhere>>;
  NOT?: InputMaybe<ManagementWhere>;
  OR?: InputMaybe<Array<ManagementWhere>>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_GT?: InputMaybe<Scalars['String']['input']>;
  role_GTE?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_LT?: InputMaybe<Scalars['String']['input']>;
  role_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_from?: InputMaybe<Scalars['String']['input']>;
  valid_from_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valid_from_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_from_GT?: InputMaybe<Scalars['String']['input']>;
  valid_from_GTE?: InputMaybe<Scalars['String']['input']>;
  valid_from_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valid_from_LT?: InputMaybe<Scalars['String']['input']>;
  valid_from_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_from_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to?: InputMaybe<Scalars['String']['input']>;
  valid_to_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valid_to_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to_GT?: InputMaybe<Scalars['String']['input']>;
  valid_to_GTE?: InputMaybe<Scalars['String']['input']>;
  valid_to_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valid_to_LT?: InputMaybe<Scalars['String']['input']>;
  valid_to_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Person.mayorOf
 * * Municipality.mayors
 */
export type Mandate = {
  __typename?: 'Mandate';
  elected_round?: Maybe<Scalars['Int']['output']>;
  elected_year?: Maybe<Scalars['Int']['output']>;
  term_end?: Maybe<Scalars['Int']['output']>;
};

export type MandateAggregationWhereInput = {
  AND?: InputMaybe<Array<MandateAggregationWhereInput>>;
  NOT?: InputMaybe<MandateAggregationWhereInput>;
  OR?: InputMaybe<Array<MandateAggregationWhereInput>>;
  elected_round_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MandateSort = {
  elected_round?: InputMaybe<SortDirection>;
  elected_year?: InputMaybe<SortDirection>;
  term_end?: InputMaybe<SortDirection>;
};

export type MandateWhere = {
  AND?: InputMaybe<Array<MandateWhere>>;
  NOT?: InputMaybe<MandateWhere>;
  OR?: InputMaybe<Array<MandateWhere>>;
  elected_round?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_round_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  term_end?: InputMaybe<Scalars['Int']['input']>;
  term_end_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  term_end_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/**
 * The edge properties for the following fields:
 * * Party.memberOf
 * * Party.members
 */
export type Membership = {
  __typename?: 'Membership';
  created_at?: Maybe<Scalars['String']['output']>;
  from_year?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  to_year?: Maybe<Scalars['Int']['output']>;
};

export type MembershipAggregationWhereInput = {
  AND?: InputMaybe<Array<MembershipAggregationWhereInput>>;
  NOT?: InputMaybe<MembershipAggregationWhereInput>;
  OR?: InputMaybe<Array<MembershipAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  from_year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  from_year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  from_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  from_year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  from_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  to_year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  to_year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  to_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  to_year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  to_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipSort = {
  created_at?: InputMaybe<SortDirection>;
  from_year?: InputMaybe<SortDirection>;
  note?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  to_year?: InputMaybe<SortDirection>;
};

export type MembershipWhere = {
  AND?: InputMaybe<Array<MembershipWhere>>;
  NOT?: InputMaybe<MembershipWhere>;
  OR?: InputMaybe<Array<MembershipWhere>>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_GT?: InputMaybe<Scalars['String']['input']>;
  created_at_GTE?: InputMaybe<Scalars['String']['input']>;
  created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at_LT?: InputMaybe<Scalars['String']['input']>;
  created_at_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  from_year?: InputMaybe<Scalars['Int']['input']>;
  from_year_GT?: InputMaybe<Scalars['Int']['input']>;
  from_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  from_year_LT?: InputMaybe<Scalars['Int']['input']>;
  from_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  note_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  note_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_GT?: InputMaybe<Scalars['String']['input']>;
  note_GTE?: InputMaybe<Scalars['String']['input']>;
  note_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  note_LT?: InputMaybe<Scalars['String']['input']>;
  note_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  to_year?: InputMaybe<Scalars['Int']['input']>;
  to_year_GT?: InputMaybe<Scalars['Int']['input']>;
  to_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to_year_LT?: InputMaybe<Scalars['Int']['input']>;
  to_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type MinisterTerm = {
  __typename?: 'MinisterTerm';
  govId: Scalars['String']['output'];
  ministryName?: Maybe<Scalars['String']['output']>;
  ministryUic: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<Scalars['String']['output']>;
  personHash: Scalars['ID']['output'];
  portfolio: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type MinisterTermAggregateSelection = {
  __typename?: 'MinisterTermAggregateSelection';
  count: Scalars['Int']['output'];
  govId: StringAggregateSelection;
  ministryName: StringAggregateSelection;
  ministryUic: IdAggregateSelection;
  name: StringAggregateSelection;
  party: StringAggregateSelection;
  personHash: IdAggregateSelection;
  portfolio: StringAggregateSelection;
  validFrom: StringAggregateSelection;
  validTo: StringAggregateSelection;
};

export type MinisterTermEdge = {
  __typename?: 'MinisterTermEdge';
  cursor: Scalars['String']['output'];
  node: MinisterTerm;
};

/** Fields to sort MinisterTerms by. The order in which sorts are applied is not guaranteed when specifying many fields in one MinisterTermSort object. */
export type MinisterTermSort = {
  govId?: InputMaybe<SortDirection>;
  ministryName?: InputMaybe<SortDirection>;
  ministryUic?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  party?: InputMaybe<SortDirection>;
  personHash?: InputMaybe<SortDirection>;
  portfolio?: InputMaybe<SortDirection>;
  validFrom?: InputMaybe<SortDirection>;
  validTo?: InputMaybe<SortDirection>;
  verified?: InputMaybe<SortDirection>;
};

export type MinisterTermWhere = {
  AND?: InputMaybe<Array<MinisterTermWhere>>;
  NOT?: InputMaybe<MinisterTermWhere>;
  OR?: InputMaybe<Array<MinisterTermWhere>>;
  govId?: InputMaybe<Scalars['String']['input']>;
  govId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  govId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  govId_GT?: InputMaybe<Scalars['String']['input']>;
  govId_GTE?: InputMaybe<Scalars['String']['input']>;
  govId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  govId_LT?: InputMaybe<Scalars['String']['input']>;
  govId_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  govId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  govId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  govId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  govId_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  govId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  govId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ministryName?: InputMaybe<Scalars['String']['input']>;
  ministryName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ministryName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ministryName_GT?: InputMaybe<Scalars['String']['input']>;
  ministryName_GTE?: InputMaybe<Scalars['String']['input']>;
  ministryName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ministryName_LT?: InputMaybe<Scalars['String']['input']>;
  ministryName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ministryName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ministryUic?: InputMaybe<Scalars['ID']['input']>;
  ministryUic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  ministryUic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ministryUic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryUic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryUic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryUic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryUic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministryUic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ministryUic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  party_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  party_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_GT?: InputMaybe<Scalars['String']['input']>;
  party_GTE?: InputMaybe<Scalars['String']['input']>;
  party_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  party_LT?: InputMaybe<Scalars['String']['input']>;
  party_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  personHash?: InputMaybe<Scalars['ID']['input']>;
  personHash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  personHash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  personHash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personHash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  personHash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  portfolio?: InputMaybe<Scalars['String']['input']>;
  portfolio_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  portfolio_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_GT?: InputMaybe<Scalars['String']['input']>;
  portfolio_GTE?: InputMaybe<Scalars['String']['input']>;
  portfolio_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  portfolio_LT?: InputMaybe<Scalars['String']['input']>;
  portfolio_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validFrom_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validFrom_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFrom_GT?: InputMaybe<Scalars['String']['input']>;
  validFrom_GTE?: InputMaybe<Scalars['String']['input']>;
  validFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validFrom_LT?: InputMaybe<Scalars['String']['input']>;
  validFrom_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFrom_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['String']['input']>;
  validTo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validTo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validTo_GT?: InputMaybe<Scalars['String']['input']>;
  validTo_GTE?: InputMaybe<Scalars['String']['input']>;
  validTo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validTo_LT?: InputMaybe<Scalars['String']['input']>;
  validTo_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validTo_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validTo_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validTo_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validTo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validTo_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validTo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  verified_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MinisterTermsConnection = {
  __typename?: 'MinisterTermsConnection';
  edges: Array<MinisterTermEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MinistriesConnection = {
  __typename?: 'MinistriesConnection';
  edges: Array<MinistryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Ministry = {
  __typename?: 'Ministry';
  cabinets: Scalars['Int']['output'];
  ministers: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  portfolio: Scalars['String']['output'];
  tenders: Scalars['Int']['output'];
  uic: Scalars['ID']['output'];
  unitTenders: Scalars['Int']['output'];
  unitValue: Scalars['Float']['output'];
  units: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type MinistryAggregateSelection = {
  __typename?: 'MinistryAggregateSelection';
  cabinets: IntAggregateSelection;
  count: Scalars['Int']['output'];
  ministers: IntAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  tenders: IntAggregateSelection;
  uic: IdAggregateSelection;
  unitTenders: IntAggregateSelection;
  unitValue: FloatAggregateSelection;
  units: IntAggregateSelection;
  value: FloatAggregateSelection;
};

export type MinistryEdge = {
  __typename?: 'MinistryEdge';
  cursor: Scalars['String']['output'];
  node: Ministry;
};

/** Fields to sort Ministries by. The order in which sorts are applied is not guaranteed when specifying many fields in one MinistrySort object. */
export type MinistrySort = {
  cabinets?: InputMaybe<SortDirection>;
  ministers?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  portfolio?: InputMaybe<SortDirection>;
  tenders?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  unitTenders?: InputMaybe<SortDirection>;
  unitValue?: InputMaybe<SortDirection>;
  units?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type MinistryUnit = {
  __typename?: 'MinistryUnit';
  name?: Maybe<Scalars['String']['output']>;
  tenders: Scalars['Int']['output'];
  uic: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type MinistryUnitAggregateSelection = {
  __typename?: 'MinistryUnitAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  tenders: IntAggregateSelection;
  uic: IdAggregateSelection;
  value: FloatAggregateSelection;
};

export type MinistryUnitEdge = {
  __typename?: 'MinistryUnitEdge';
  cursor: Scalars['String']['output'];
  node: MinistryUnit;
};

/** Fields to sort MinistryUnits by. The order in which sorts are applied is not guaranteed when specifying many fields in one MinistryUnitSort object. */
export type MinistryUnitSort = {
  name?: InputMaybe<SortDirection>;
  tenders?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type MinistryUnitWhere = {
  AND?: InputMaybe<Array<MinistryUnitWhere>>;
  NOT?: InputMaybe<MinistryUnitWhere>;
  OR?: InputMaybe<Array<MinistryUnitWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenders?: InputMaybe<Scalars['Int']['input']>;
  tenders_GT?: InputMaybe<Scalars['Int']['input']>;
  tenders_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenders_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenders_LT?: InputMaybe<Scalars['Int']['input']>;
  tenders_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenders_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenders_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type MinistryUnitsConnection = {
  __typename?: 'MinistryUnitsConnection';
  edges: Array<MinistryUnitEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MinistryWhere = {
  AND?: InputMaybe<Array<MinistryWhere>>;
  NOT?: InputMaybe<MinistryWhere>;
  OR?: InputMaybe<Array<MinistryWhere>>;
  cabinets?: InputMaybe<Scalars['Int']['input']>;
  cabinets_GT?: InputMaybe<Scalars['Int']['input']>;
  cabinets_GTE?: InputMaybe<Scalars['Int']['input']>;
  cabinets_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cabinets_LT?: InputMaybe<Scalars['Int']['input']>;
  cabinets_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cabinets_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cabinets_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  ministers?: InputMaybe<Scalars['Int']['input']>;
  ministers_GT?: InputMaybe<Scalars['Int']['input']>;
  ministers_GTE?: InputMaybe<Scalars['Int']['input']>;
  ministers_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  ministers_LT?: InputMaybe<Scalars['Int']['input']>;
  ministers_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministers_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministers_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio?: InputMaybe<Scalars['String']['input']>;
  portfolio_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  portfolio_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_GT?: InputMaybe<Scalars['String']['input']>;
  portfolio_GTE?: InputMaybe<Scalars['String']['input']>;
  portfolio_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  portfolio_LT?: InputMaybe<Scalars['String']['input']>;
  portfolio_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  portfolio_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  portfolio_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenders?: InputMaybe<Scalars['Int']['input']>;
  tenders_GT?: InputMaybe<Scalars['Int']['input']>;
  tenders_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenders_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenders_LT?: InputMaybe<Scalars['Int']['input']>;
  tenders_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenders_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenders_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  unitTenders?: InputMaybe<Scalars['Int']['input']>;
  unitTenders_GT?: InputMaybe<Scalars['Int']['input']>;
  unitTenders_GTE?: InputMaybe<Scalars['Int']['input']>;
  unitTenders_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitTenders_LT?: InputMaybe<Scalars['Int']['input']>;
  unitTenders_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  unitTenders_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  unitTenders_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitValue?: InputMaybe<Scalars['Float']['input']>;
  unitValue_GT?: InputMaybe<Scalars['Float']['input']>;
  unitValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  unitValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  unitValue_LT?: InputMaybe<Scalars['Float']['input']>;
  unitValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  unitValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  unitValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  units?: InputMaybe<Scalars['Int']['input']>;
  units_GT?: InputMaybe<Scalars['Int']['input']>;
  units_GTE?: InputMaybe<Scalars['Int']['input']>;
  units_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  units_LT?: InputMaybe<Scalars['Int']['input']>;
  units_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  units_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  units_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type MunicipalitiesConnection = {
  __typename?: 'MunicipalitiesConnection';
  edges: Array<MunicipalityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Municipality = {
  __typename?: 'Municipality';
  administration: Array<Company>;
  administrationAggregate?: Maybe<MunicipalityCompanyAdministrationAggregationSelection>;
  administrationConnection: MunicipalityAdministrationConnection;
  companies: Array<Company>;
  companiesAggregate?: Maybe<MunicipalityCompanyCompaniesAggregationSelection>;
  companiesConnection: MunicipalityCompaniesConnection;
  ekatte?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  mayors: Array<Person>;
  mayorsAggregate?: Maybe<MunicipalityPersonMayorsAggregationSelection>;
  mayorsConnection: MunicipalityMayorsConnection;
  name?: Maybe<Scalars['String']['output']>;
  officeHolders: Array<Person>;
  officeHoldersAggregate?: Maybe<MunicipalityPersonOfficeHoldersAggregationSelection>;
  officeHoldersConnection: MunicipalityOfficeHoldersConnection;
  population_as_of?: Maybe<Scalars['String']['output']>;
  population_current?: Maybe<Scalars['Int']['output']>;
  population_permanent?: Maybe<Scalars['Int']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  spend_per_capita?: Maybe<Scalars['Float']['output']>;
  tender_total_bgn?: Maybe<Scalars['Float']['output']>;
  tenders: Array<Tender>;
  tendersAggregate?: Maybe<MunicipalityTenderTendersAggregationSelection>;
  tendersConnection: MunicipalityTendersConnection;
};


export type MunicipalityAdministrationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type MunicipalityAdministrationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type MunicipalityAdministrationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MunicipalityAdministrationConnectionSort>>;
  where?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
};


export type MunicipalityCompaniesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type MunicipalityCompaniesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type MunicipalityCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MunicipalityCompaniesConnectionSort>>;
  where?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
};


export type MunicipalityMayorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type MunicipalityMayorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};


export type MunicipalityMayorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MunicipalityMayorsConnectionSort>>;
  where?: InputMaybe<MunicipalityMayorsConnectionWhere>;
};


export type MunicipalityOfficeHoldersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type MunicipalityOfficeHoldersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};


export type MunicipalityOfficeHoldersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MunicipalityOfficeHoldersConnectionSort>>;
  where?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
};


export type MunicipalityTendersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type MunicipalityTendersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type MunicipalityTendersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MunicipalityTendersConnectionSort>>;
  where?: InputMaybe<MunicipalityTendersConnectionWhere>;
};

export type MunicipalityAdministrationAggregateInput = {
  AND?: InputMaybe<Array<MunicipalityAdministrationAggregateInput>>;
  NOT?: InputMaybe<MunicipalityAdministrationAggregateInput>;
  OR?: InputMaybe<Array<MunicipalityAdministrationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MunicipalityAdministrationNodeAggregationWhereInput>;
};

export type MunicipalityAdministrationConnection = {
  __typename?: 'MunicipalityAdministrationConnection';
  edges: Array<MunicipalityAdministrationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityAdministrationConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type MunicipalityAdministrationConnectionWhere = {
  AND?: InputMaybe<Array<MunicipalityAdministrationConnectionWhere>>;
  NOT?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  OR?: InputMaybe<Array<MunicipalityAdministrationConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type MunicipalityAdministrationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MunicipalityAdministrationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MunicipalityAdministrationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MunicipalityAdministrationNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type MunicipalityAdministrationRelationship = {
  __typename?: 'MunicipalityAdministrationRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type MunicipalityAggregateSelection = {
  __typename?: 'MunicipalityAggregateSelection';
  count: Scalars['Int']['output'];
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type MunicipalityCompaniesAggregateInput = {
  AND?: InputMaybe<Array<MunicipalityCompaniesAggregateInput>>;
  NOT?: InputMaybe<MunicipalityCompaniesAggregateInput>;
  OR?: InputMaybe<Array<MunicipalityCompaniesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MunicipalityCompaniesNodeAggregationWhereInput>;
};

export type MunicipalityCompaniesConnection = {
  __typename?: 'MunicipalityCompaniesConnection';
  edges: Array<MunicipalityCompaniesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityCompaniesConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type MunicipalityCompaniesConnectionWhere = {
  AND?: InputMaybe<Array<MunicipalityCompaniesConnectionWhere>>;
  NOT?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  OR?: InputMaybe<Array<MunicipalityCompaniesConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type MunicipalityCompaniesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MunicipalityCompaniesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MunicipalityCompaniesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MunicipalityCompaniesNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type MunicipalityCompaniesRelationship = {
  __typename?: 'MunicipalityCompaniesRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type MunicipalityCompanyAdministrationAggregationSelection = {
  __typename?: 'MunicipalityCompanyAdministrationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MunicipalityCompanyAdministrationNodeAggregateSelection>;
};

export type MunicipalityCompanyAdministrationNodeAggregateSelection = {
  __typename?: 'MunicipalityCompanyAdministrationNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type MunicipalityCompanyCompaniesAggregationSelection = {
  __typename?: 'MunicipalityCompanyCompaniesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MunicipalityCompanyCompaniesNodeAggregateSelection>;
};

export type MunicipalityCompanyCompaniesNodeAggregateSelection = {
  __typename?: 'MunicipalityCompanyCompaniesNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type MunicipalityEdge = {
  __typename?: 'MunicipalityEdge';
  cursor: Scalars['String']['output'];
  node: Municipality;
};

export type MunicipalityFilter = {
  hasTenders?: InputMaybe<Scalars['Boolean']['input']>;
  minPopulation?: InputMaybe<Scalars['Int']['input']>;
  provinces?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MunicipalityMayorsAggregateInput = {
  AND?: InputMaybe<Array<MunicipalityMayorsAggregateInput>>;
  NOT?: InputMaybe<MunicipalityMayorsAggregateInput>;
  OR?: InputMaybe<Array<MunicipalityMayorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<MandateAggregationWhereInput>;
  node?: InputMaybe<MunicipalityMayorsNodeAggregationWhereInput>;
};

export type MunicipalityMayorsConnection = {
  __typename?: 'MunicipalityMayorsConnection';
  edges: Array<MunicipalityMayorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityMayorsConnectionSort = {
  edge?: InputMaybe<MandateSort>;
  node?: InputMaybe<PersonSort>;
};

export type MunicipalityMayorsConnectionWhere = {
  AND?: InputMaybe<Array<MunicipalityMayorsConnectionWhere>>;
  NOT?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  OR?: InputMaybe<Array<MunicipalityMayorsConnectionWhere>>;
  edge?: InputMaybe<MandateWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<MandateWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type MunicipalityMayorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MunicipalityMayorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MunicipalityMayorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MunicipalityMayorsNodeAggregationWhereInput>>;
  company_links_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  person_hash_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type MunicipalityMayorsRelationship = {
  __typename?: 'MunicipalityMayorsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: Mandate;
};

export type MunicipalityOfficeHoldersAggregateInput = {
  AND?: InputMaybe<Array<MunicipalityOfficeHoldersAggregateInput>>;
  NOT?: InputMaybe<MunicipalityOfficeHoldersAggregateInput>;
  OR?: InputMaybe<Array<MunicipalityOfficeHoldersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<PositionAggregationWhereInput>;
  node?: InputMaybe<MunicipalityOfficeHoldersNodeAggregationWhereInput>;
};

export type MunicipalityOfficeHoldersConnection = {
  __typename?: 'MunicipalityOfficeHoldersConnection';
  edges: Array<MunicipalityOfficeHoldersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityOfficeHoldersConnectionSort = {
  edge?: InputMaybe<PositionSort>;
  node?: InputMaybe<PersonSort>;
};

export type MunicipalityOfficeHoldersConnectionWhere = {
  AND?: InputMaybe<Array<MunicipalityOfficeHoldersConnectionWhere>>;
  NOT?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  OR?: InputMaybe<Array<MunicipalityOfficeHoldersConnectionWhere>>;
  edge?: InputMaybe<PositionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PositionWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type MunicipalityOfficeHoldersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MunicipalityOfficeHoldersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MunicipalityOfficeHoldersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MunicipalityOfficeHoldersNodeAggregationWhereInput>>;
  company_links_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  person_hash_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type MunicipalityOfficeHoldersRelationship = {
  __typename?: 'MunicipalityOfficeHoldersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: Position;
};

export type MunicipalityOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MunicipalitySort objects to sort Municipalities by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MunicipalitySort>>;
};

export type MunicipalityPersonMayorsAggregationSelection = {
  __typename?: 'MunicipalityPersonMayorsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MunicipalityPersonMayorsEdgeAggregateSelection>;
  node?: Maybe<MunicipalityPersonMayorsNodeAggregateSelection>;
};

export type MunicipalityPersonMayorsEdgeAggregateSelection = {
  __typename?: 'MunicipalityPersonMayorsEdgeAggregateSelection';
  elected_round: IntAggregateSelection;
  elected_year: IntAggregateSelection;
  term_end: IntAggregateSelection;
};

export type MunicipalityPersonMayorsNodeAggregateSelection = {
  __typename?: 'MunicipalityPersonMayorsNodeAggregateSelection';
  company_links: IntAggregateSelection;
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

export type MunicipalityPersonOfficeHoldersAggregationSelection = {
  __typename?: 'MunicipalityPersonOfficeHoldersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MunicipalityPersonOfficeHoldersEdgeAggregateSelection>;
  node?: Maybe<MunicipalityPersonOfficeHoldersNodeAggregateSelection>;
};

export type MunicipalityPersonOfficeHoldersEdgeAggregateSelection = {
  __typename?: 'MunicipalityPersonOfficeHoldersEdgeAggregateSelection';
  area: StringAggregateSelection;
  area_code: StringAggregateSelection;
  elected_round: IntAggregateSelection;
  elected_year: IntAggregateSelection;
  list_letter: StringAggregateSelection;
  preferences: IntAggregateSelection;
  replaces: StringAggregateSelection;
  replaces_office: StringAggregateSelection;
  role: StringAggregateSelection;
  term_end: IntAggregateSelection;
  term_start: StringAggregateSelection;
};

export type MunicipalityPersonOfficeHoldersNodeAggregateSelection = {
  __typename?: 'MunicipalityPersonOfficeHoldersNodeAggregateSelection';
  company_links: IntAggregateSelection;
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

/** Fields to sort Municipalities by. The order in which sorts are applied is not guaranteed when specifying many fields in one MunicipalitySort object. */
export type MunicipalitySort = {
  ekatte?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  population_as_of?: InputMaybe<SortDirection>;
  population_current?: InputMaybe<SortDirection>;
  population_permanent?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  spend_per_capita?: InputMaybe<SortDirection>;
  tender_total_bgn?: InputMaybe<SortDirection>;
};

export type MunicipalityStat = {
  __typename?: 'MunicipalityStat';
  key: Scalars['ID']['output'];
  mayor?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<Scalars['String']['output']>;
  partyKey?: Maybe<Scalars['ID']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  tenderCount?: Maybe<Scalars['Int']['output']>;
  tenderTotal?: Maybe<Scalars['Float']['output']>;
};

export type MunicipalityStatAggregateSelection = {
  __typename?: 'MunicipalityStatAggregateSelection';
  count: Scalars['Int']['output'];
  key: IdAggregateSelection;
  mayor: StringAggregateSelection;
  name: StringAggregateSelection;
  party: StringAggregateSelection;
  partyKey: IdAggregateSelection;
  population: IntAggregateSelection;
  province: StringAggregateSelection;
  tenderCount: IntAggregateSelection;
  tenderTotal: FloatAggregateSelection;
};

export type MunicipalityStatEdge = {
  __typename?: 'MunicipalityStatEdge';
  cursor: Scalars['String']['output'];
  node: MunicipalityStat;
};

export type MunicipalityStatOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MunicipalityStatSort objects to sort MunicipalityStats by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MunicipalityStatSort>>;
};

/** Fields to sort MunicipalityStats by. The order in which sorts are applied is not guaranteed when specifying many fields in one MunicipalityStatSort object. */
export type MunicipalityStatSort = {
  key?: InputMaybe<SortDirection>;
  mayor?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  party?: InputMaybe<SortDirection>;
  partyKey?: InputMaybe<SortDirection>;
  population?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  tenderCount?: InputMaybe<SortDirection>;
  tenderTotal?: InputMaybe<SortDirection>;
};

export type MunicipalityStatWhere = {
  AND?: InputMaybe<Array<MunicipalityStatWhere>>;
  NOT?: InputMaybe<MunicipalityStatWhere>;
  OR?: InputMaybe<Array<MunicipalityStatWhere>>;
  key?: InputMaybe<Scalars['ID']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mayor?: InputMaybe<Scalars['String']['input']>;
  mayor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mayor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayor_GT?: InputMaybe<Scalars['String']['input']>;
  mayor_GTE?: InputMaybe<Scalars['String']['input']>;
  mayor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mayor_LT?: InputMaybe<Scalars['String']['input']>;
  mayor_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayor_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  partyKey?: InputMaybe<Scalars['ID']['input']>;
  partyKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  partyKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  partyKey_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  partyKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  partyKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  party_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  party_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_GT?: InputMaybe<Scalars['String']['input']>;
  party_GTE?: InputMaybe<Scalars['String']['input']>;
  party_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  party_LT?: InputMaybe<Scalars['String']['input']>;
  party_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  population_GT?: InputMaybe<Scalars['Int']['input']>;
  population_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  population_LT?: InputMaybe<Scalars['Int']['input']>;
  population_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  province_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_GT?: InputMaybe<Scalars['String']['input']>;
  province_GTE?: InputMaybe<Scalars['String']['input']>;
  province_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  province_LT?: InputMaybe<Scalars['String']['input']>;
  province_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenderCount?: InputMaybe<Scalars['Int']['input']>;
  tenderCount_GT?: InputMaybe<Scalars['Int']['input']>;
  tenderCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenderCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tenderCount_LT?: InputMaybe<Scalars['Int']['input']>;
  tenderCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tenderTotal?: InputMaybe<Scalars['Float']['input']>;
  tenderTotal_GT?: InputMaybe<Scalars['Float']['input']>;
  tenderTotal_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenderTotal_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tenderTotal_LT?: InputMaybe<Scalars['Float']['input']>;
  tenderTotal_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderTotal_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderTotal_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type MunicipalityStatsConnection = {
  __typename?: 'MunicipalityStatsConnection';
  edges: Array<MunicipalityStatEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityTenderTendersAggregationSelection = {
  __typename?: 'MunicipalityTenderTendersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MunicipalityTenderTendersNodeAggregateSelection>;
};

export type MunicipalityTenderTendersNodeAggregateSelection = {
  __typename?: 'MunicipalityTenderTendersNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type MunicipalityTendersAggregateInput = {
  AND?: InputMaybe<Array<MunicipalityTendersAggregateInput>>;
  NOT?: InputMaybe<MunicipalityTendersAggregateInput>;
  OR?: InputMaybe<Array<MunicipalityTendersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MunicipalityTendersNodeAggregationWhereInput>;
};

export type MunicipalityTendersConnection = {
  __typename?: 'MunicipalityTendersConnection';
  edges: Array<MunicipalityTendersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MunicipalityTendersConnectionSort = {
  node?: InputMaybe<TenderSort>;
};

export type MunicipalityTendersConnectionWhere = {
  AND?: InputMaybe<Array<MunicipalityTendersConnectionWhere>>;
  NOT?: InputMaybe<MunicipalityTendersConnectionWhere>;
  OR?: InputMaybe<Array<MunicipalityTendersConnectionWhere>>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type MunicipalityTendersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MunicipalityTendersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MunicipalityTendersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MunicipalityTendersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MunicipalityTendersRelationship = {
  __typename?: 'MunicipalityTendersRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type MunicipalityWhere = {
  AND?: InputMaybe<Array<MunicipalityWhere>>;
  NOT?: InputMaybe<MunicipalityWhere>;
  OR?: InputMaybe<Array<MunicipalityWhere>>;
  /** @deprecated Use `administration_SOME` instead. */
  administration?: InputMaybe<CompanyWhere>;
  administrationAggregate?: InputMaybe<MunicipalityAdministrationAggregateInput>;
  /** @deprecated Use `administrationConnection_SOME` instead. */
  administrationConnection?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** Return Municipalities where all of the related MunicipalityAdministrationConnections match this filter */
  administrationConnection_ALL?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** Return Municipalities where none of the related MunicipalityAdministrationConnections match this filter */
  administrationConnection_NONE?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** @deprecated Use `administrationConnection_NONE` instead. */
  administrationConnection_NOT?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** Return Municipalities where one of the related MunicipalityAdministrationConnections match this filter */
  administrationConnection_SINGLE?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** Return Municipalities where some of the related MunicipalityAdministrationConnections match this filter */
  administrationConnection_SOME?: InputMaybe<MunicipalityAdministrationConnectionWhere>;
  /** Return Municipalities where all of the related Companies match this filter */
  administration_ALL?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where none of the related Companies match this filter */
  administration_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `administration_NONE` instead. */
  administration_NOT?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where one of the related Companies match this filter */
  administration_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where some of the related Companies match this filter */
  administration_SOME?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `companies_SOME` instead. */
  companies?: InputMaybe<CompanyWhere>;
  companiesAggregate?: InputMaybe<MunicipalityCompaniesAggregateInput>;
  /** @deprecated Use `companiesConnection_SOME` instead. */
  companiesConnection?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** Return Municipalities where all of the related MunicipalityCompaniesConnections match this filter */
  companiesConnection_ALL?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** Return Municipalities where none of the related MunicipalityCompaniesConnections match this filter */
  companiesConnection_NONE?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** @deprecated Use `companiesConnection_NONE` instead. */
  companiesConnection_NOT?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** Return Municipalities where one of the related MunicipalityCompaniesConnections match this filter */
  companiesConnection_SINGLE?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** Return Municipalities where some of the related MunicipalityCompaniesConnections match this filter */
  companiesConnection_SOME?: InputMaybe<MunicipalityCompaniesConnectionWhere>;
  /** Return Municipalities where all of the related Companies match this filter */
  companies_ALL?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where none of the related Companies match this filter */
  companies_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `companies_NONE` instead. */
  companies_NOT?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where one of the related Companies match this filter */
  companies_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Municipalities where some of the related Companies match this filter */
  companies_SOME?: InputMaybe<CompanyWhere>;
  ekatte?: InputMaybe<Scalars['String']['input']>;
  ekatte_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ekatte_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ekatte_GT?: InputMaybe<Scalars['String']['input']>;
  ekatte_GTE?: InputMaybe<Scalars['String']['input']>;
  ekatte_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ekatte_LT?: InputMaybe<Scalars['String']['input']>;
  ekatte_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ekatte_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ekatte_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ekatte_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ekatte_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ekatte_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ekatte_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `mayors_SOME` instead. */
  mayors?: InputMaybe<PersonWhere>;
  mayorsAggregate?: InputMaybe<MunicipalityMayorsAggregateInput>;
  /** @deprecated Use `mayorsConnection_SOME` instead. */
  mayorsConnection?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** Return Municipalities where all of the related MunicipalityMayorsConnections match this filter */
  mayorsConnection_ALL?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** Return Municipalities where none of the related MunicipalityMayorsConnections match this filter */
  mayorsConnection_NONE?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** @deprecated Use `mayorsConnection_NONE` instead. */
  mayorsConnection_NOT?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** Return Municipalities where one of the related MunicipalityMayorsConnections match this filter */
  mayorsConnection_SINGLE?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** Return Municipalities where some of the related MunicipalityMayorsConnections match this filter */
  mayorsConnection_SOME?: InputMaybe<MunicipalityMayorsConnectionWhere>;
  /** Return Municipalities where all of the related People match this filter */
  mayors_ALL?: InputMaybe<PersonWhere>;
  /** Return Municipalities where none of the related People match this filter */
  mayors_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `mayors_NONE` instead. */
  mayors_NOT?: InputMaybe<PersonWhere>;
  /** Return Municipalities where one of the related People match this filter */
  mayors_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Municipalities where some of the related People match this filter */
  mayors_SOME?: InputMaybe<PersonWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `officeHolders_SOME` instead. */
  officeHolders?: InputMaybe<PersonWhere>;
  officeHoldersAggregate?: InputMaybe<MunicipalityOfficeHoldersAggregateInput>;
  /** @deprecated Use `officeHoldersConnection_SOME` instead. */
  officeHoldersConnection?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** Return Municipalities where all of the related MunicipalityOfficeHoldersConnections match this filter */
  officeHoldersConnection_ALL?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** Return Municipalities where none of the related MunicipalityOfficeHoldersConnections match this filter */
  officeHoldersConnection_NONE?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** @deprecated Use `officeHoldersConnection_NONE` instead. */
  officeHoldersConnection_NOT?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** Return Municipalities where one of the related MunicipalityOfficeHoldersConnections match this filter */
  officeHoldersConnection_SINGLE?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** Return Municipalities where some of the related MunicipalityOfficeHoldersConnections match this filter */
  officeHoldersConnection_SOME?: InputMaybe<MunicipalityOfficeHoldersConnectionWhere>;
  /** Return Municipalities where all of the related People match this filter */
  officeHolders_ALL?: InputMaybe<PersonWhere>;
  /** Return Municipalities where none of the related People match this filter */
  officeHolders_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `officeHolders_NONE` instead. */
  officeHolders_NOT?: InputMaybe<PersonWhere>;
  /** Return Municipalities where one of the related People match this filter */
  officeHolders_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Municipalities where some of the related People match this filter */
  officeHolders_SOME?: InputMaybe<PersonWhere>;
  population_as_of?: InputMaybe<Scalars['String']['input']>;
  population_as_of_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  population_as_of_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  population_as_of_GT?: InputMaybe<Scalars['String']['input']>;
  population_as_of_GTE?: InputMaybe<Scalars['String']['input']>;
  population_as_of_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  population_as_of_LT?: InputMaybe<Scalars['String']['input']>;
  population_as_of_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_as_of_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_as_of_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_as_of_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_as_of_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_as_of_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  population_as_of_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  population_current?: InputMaybe<Scalars['Int']['input']>;
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_current_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_current_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  population_permanent?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_permanent_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_permanent_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  province_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_GT?: InputMaybe<Scalars['String']['input']>;
  province_GTE?: InputMaybe<Scalars['String']['input']>;
  province_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  province_LT?: InputMaybe<Scalars['String']['input']>;
  province_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  spend_per_capita?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  spend_per_capita_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  spend_per_capita_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tender_total_bgn?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_total_bgn_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_total_bgn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** @deprecated Use `tenders_SOME` instead. */
  tenders?: InputMaybe<TenderWhere>;
  tendersAggregate?: InputMaybe<MunicipalityTendersAggregateInput>;
  /** @deprecated Use `tendersConnection_SOME` instead. */
  tendersConnection?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** Return Municipalities where all of the related MunicipalityTendersConnections match this filter */
  tendersConnection_ALL?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** Return Municipalities where none of the related MunicipalityTendersConnections match this filter */
  tendersConnection_NONE?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** @deprecated Use `tendersConnection_NONE` instead. */
  tendersConnection_NOT?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** Return Municipalities where one of the related MunicipalityTendersConnections match this filter */
  tendersConnection_SINGLE?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** Return Municipalities where some of the related MunicipalityTendersConnections match this filter */
  tendersConnection_SOME?: InputMaybe<MunicipalityTendersConnectionWhere>;
  /** Return Municipalities where all of the related Tenders match this filter */
  tenders_ALL?: InputMaybe<TenderWhere>;
  /** Return Municipalities where none of the related Tenders match this filter */
  tenders_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `tenders_NONE` instead. */
  tenders_NOT?: InputMaybe<TenderWhere>;
  /** Return Municipalities where one of the related Tenders match this filter */
  tenders_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Municipalities where some of the related Tenders match this filter */
  tenders_SOME?: InputMaybe<TenderWhere>;
};

export type NetworkLink = {
  __typename?: 'NetworkLink';
  companies: Array<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  shared: Scalars['Int']['output'];
  source: Scalars['ID']['output'];
  target: Scalars['ID']['output'];
};

export type NetworkLinkAggregateSelection = {
  __typename?: 'NetworkLinkAggregateSelection';
  count: Scalars['Int']['output'];
  kind: StringAggregateSelection;
  shared: IntAggregateSelection;
  source: IdAggregateSelection;
  target: IdAggregateSelection;
};

export type NetworkLinkEdge = {
  __typename?: 'NetworkLinkEdge';
  cursor: Scalars['String']['output'];
  node: NetworkLink;
};

export type NetworkLinkOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NetworkLinkSort objects to sort NetworkLinks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NetworkLinkSort>>;
};

/** Fields to sort NetworkLinks by. The order in which sorts are applied is not guaranteed when specifying many fields in one NetworkLinkSort object. */
export type NetworkLinkSort = {
  kind?: InputMaybe<SortDirection>;
  shared?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  target?: InputMaybe<SortDirection>;
};

export type NetworkLinkWhere = {
  AND?: InputMaybe<Array<NetworkLinkWhere>>;
  NOT?: InputMaybe<NetworkLinkWhere>;
  OR?: InputMaybe<Array<NetworkLinkWhere>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  companies_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kind_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  kind_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_GT?: InputMaybe<Scalars['String']['input']>;
  kind_GTE?: InputMaybe<Scalars['String']['input']>;
  kind_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  kind_LT?: InputMaybe<Scalars['String']['input']>;
  kind_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  kind_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Int']['input']>;
  shared_GT?: InputMaybe<Scalars['Int']['input']>;
  shared_GTE?: InputMaybe<Scalars['Int']['input']>;
  shared_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  shared_LT?: InputMaybe<Scalars['Int']['input']>;
  shared_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shared_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shared_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  source?: InputMaybe<Scalars['ID']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  source_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  target_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  target_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  target_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  target_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  target_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  target_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  target_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  target_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  target_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type NetworkLinksConnection = {
  __typename?: 'NetworkLinksConnection';
  edges: Array<NetworkLinkEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NetworkPeopleConnection = {
  __typename?: 'NetworkPeopleConnection';
  edges: Array<NetworkPersonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NetworkPerson = {
  __typename?: 'NetworkPerson';
  firms: Scalars['Int']['output'];
  hash: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publicFirms: Scalars['Int']['output'];
  tier: Scalars['String']['output'];
};

export type NetworkPersonAggregateSelection = {
  __typename?: 'NetworkPersonAggregateSelection';
  count: Scalars['Int']['output'];
  firms: IntAggregateSelection;
  hash: IdAggregateSelection;
  name: StringAggregateSelection;
  publicFirms: IntAggregateSelection;
  tier: StringAggregateSelection;
};

export type NetworkPersonEdge = {
  __typename?: 'NetworkPersonEdge';
  cursor: Scalars['String']['output'];
  node: NetworkPerson;
};

export type NetworkPersonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NetworkPersonSort objects to sort NetworkPeople by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NetworkPersonSort>>;
};

/** Fields to sort NetworkPeople by. The order in which sorts are applied is not guaranteed when specifying many fields in one NetworkPersonSort object. */
export type NetworkPersonSort = {
  firms?: InputMaybe<SortDirection>;
  hash?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  publicFirms?: InputMaybe<SortDirection>;
  tier?: InputMaybe<SortDirection>;
};

export type NetworkPersonWhere = {
  AND?: InputMaybe<Array<NetworkPersonWhere>>;
  NOT?: InputMaybe<NetworkPersonWhere>;
  OR?: InputMaybe<Array<NetworkPersonWhere>>;
  firms?: InputMaybe<Scalars['Int']['input']>;
  firms_GT?: InputMaybe<Scalars['Int']['input']>;
  firms_GTE?: InputMaybe<Scalars['Int']['input']>;
  firms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  firms_LT?: InputMaybe<Scalars['Int']['input']>;
  firms_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firms_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firms_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  hash?: InputMaybe<Scalars['ID']['input']>;
  hash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  hash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  hash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  hash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicFirms?: InputMaybe<Scalars['Int']['input']>;
  publicFirms_GT?: InputMaybe<Scalars['Int']['input']>;
  publicFirms_GTE?: InputMaybe<Scalars['Int']['input']>;
  publicFirms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  publicFirms_LT?: InputMaybe<Scalars['Int']['input']>;
  publicFirms_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicFirms_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicFirms_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  tier?: InputMaybe<Scalars['String']['input']>;
  tier_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tier_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tier_GT?: InputMaybe<Scalars['String']['input']>;
  tier_GTE?: InputMaybe<Scalars['String']['input']>;
  tier_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tier_LT?: InputMaybe<Scalars['String']['input']>;
  tier_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tier_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tier_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tier_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tier_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tier_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tier_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Person.nominatedBy
 * * Party.nominees
 */
export type Nomination = {
  __typename?: 'Nomination';
  election_year?: Maybe<Scalars['Int']['output']>;
};

export type NominationAggregationWhereInput = {
  AND?: InputMaybe<Array<NominationAggregationWhereInput>>;
  NOT?: InputMaybe<NominationAggregationWhereInput>;
  OR?: InputMaybe<Array<NominationAggregationWhereInput>>;
  election_year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  election_year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  election_year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  election_year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  election_year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  election_year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  election_year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  election_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  election_year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  election_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  election_year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  election_year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  election_year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  election_year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  election_year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  election_year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  election_year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  election_year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  election_year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NominationSort = {
  election_year?: InputMaybe<SortDirection>;
};

export type NominationWhere = {
  AND?: InputMaybe<Array<NominationWhere>>;
  NOT?: InputMaybe<NominationWhere>;
  OR?: InputMaybe<Array<NominationWhere>>;
  election_year?: InputMaybe<Scalars['Int']['input']>;
  election_year_GT?: InputMaybe<Scalars['Int']['input']>;
  election_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  election_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  election_year_LT?: InputMaybe<Scalars['Int']['input']>;
  election_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  election_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  election_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/**
 * The edge properties for the following fields:
 * * Company.owners
 * * Company.corporateOwners
 * * Company.subsidiaries
 * * Person.ownedCompanies
 */
export type Ownership = {
  __typename?: 'Ownership';
  share_amount?: Maybe<Scalars['Float']['output']>;
  share_currency?: Maybe<Scalars['String']['output']>;
  share_percent?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['String']['output']>;
  valid_to?: Maybe<Scalars['String']['output']>;
};

export type OwnershipAggregationWhereInput = {
  AND?: InputMaybe<Array<OwnershipAggregationWhereInput>>;
  NOT?: InputMaybe<OwnershipAggregationWhereInput>;
  OR?: InputMaybe<Array<OwnershipAggregationWhereInput>>;
  share_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  share_currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  share_currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  share_currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  share_currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  share_currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  share_currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  share_currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  share_currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  share_currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  share_currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  share_currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  share_currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  share_currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  share_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valid_from_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_from_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_from_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_from_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valid_to_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  valid_to_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valid_to_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  valid_to_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OwnershipSort = {
  share_amount?: InputMaybe<SortDirection>;
  share_currency?: InputMaybe<SortDirection>;
  share_percent?: InputMaybe<SortDirection>;
  valid_from?: InputMaybe<SortDirection>;
  valid_to?: InputMaybe<SortDirection>;
};

export type OwnershipWhere = {
  AND?: InputMaybe<Array<OwnershipWhere>>;
  NOT?: InputMaybe<OwnershipWhere>;
  OR?: InputMaybe<Array<OwnershipWhere>>;
  share_amount?: InputMaybe<Scalars['Float']['input']>;
  share_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  share_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  share_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  share_currency?: InputMaybe<Scalars['String']['input']>;
  share_currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  share_currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  share_currency_GT?: InputMaybe<Scalars['String']['input']>;
  share_currency_GTE?: InputMaybe<Scalars['String']['input']>;
  share_currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  share_currency_LT?: InputMaybe<Scalars['String']['input']>;
  share_currency_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_currency_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_currency_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_currency_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_currency_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_currency_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  share_currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  share_percent?: InputMaybe<Scalars['Float']['input']>;
  share_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  share_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_percent_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_percent_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  valid_from?: InputMaybe<Scalars['String']['input']>;
  valid_from_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valid_from_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_from_GT?: InputMaybe<Scalars['String']['input']>;
  valid_from_GTE?: InputMaybe<Scalars['String']['input']>;
  valid_from_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valid_from_LT?: InputMaybe<Scalars['String']['input']>;
  valid_from_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_from_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_from_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to?: InputMaybe<Scalars['String']['input']>;
  valid_to_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valid_to_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to_GT?: InputMaybe<Scalars['String']['input']>;
  valid_to_GTE?: InputMaybe<Scalars['String']['input']>;
  valid_to_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valid_to_LT?: InputMaybe<Scalars['String']['input']>;
  valid_to_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valid_to_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valid_to_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartiesConnection = {
  __typename?: 'PartiesConnection';
  edges: Array<PartyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Company.memberships
 * * Consortium.partners
 */
export type Partnership = {
  __typename?: 'Partnership';
  is_lead?: Maybe<Scalars['Boolean']['output']>;
  share_percent?: Maybe<Scalars['Float']['output']>;
};

export type PartnershipAggregationWhereInput = {
  AND?: InputMaybe<Array<PartnershipAggregationWhereInput>>;
  NOT?: InputMaybe<PartnershipAggregationWhereInput>;
  OR?: InputMaybe<Array<PartnershipAggregationWhereInput>>;
  share_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  share_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnershipSort = {
  is_lead?: InputMaybe<SortDirection>;
  share_percent?: InputMaybe<SortDirection>;
};

export type PartnershipWhere = {
  AND?: InputMaybe<Array<PartnershipWhere>>;
  NOT?: InputMaybe<PartnershipWhere>;
  OR?: InputMaybe<Array<PartnershipWhere>>;
  is_lead?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_lead_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  share_percent?: InputMaybe<Scalars['Float']['input']>;
  share_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  share_percent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  share_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  share_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_percent_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  share_percent_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type Party = {
  __typename?: 'Party';
  family_key?: Maybe<Scalars['String']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  governments: Array<Government>;
  governmentsAggregate?: Maybe<PartyGovernmentGovernmentsAggregationSelection>;
  governmentsConnection: PartyGovernmentsConnection;
  key: Scalars['ID']['output'];
  memberOf: Array<Party>;
  memberOfAggregate?: Maybe<PartyPartyMemberOfAggregationSelection>;
  memberOfConnection: PartyMemberOfConnection;
  members: Array<Party>;
  membersAggregate?: Maybe<PartyPartyMembersAggregationSelection>;
  membersConnection: PartyMembersConnection;
  name?: Maybe<Scalars['String']['output']>;
  nominees: Array<Person>;
  nomineesAggregate?: Maybe<PartyPersonNomineesAggregationSelection>;
  nomineesConnection: PartyNomineesConnection;
  succeededBy: Array<Party>;
  succeededByAggregate?: Maybe<PartyPartySucceededByAggregationSelection>;
  succeededByConnection: PartySucceededByConnection;
  succeeds: Array<Party>;
  succeedsAggregate?: Maybe<PartyPartySucceedsAggregationSelection>;
  succeedsConnection: PartySucceedsConnection;
};


export type PartyGovernmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GovernmentOptions>;
  where?: InputMaybe<GovernmentWhere>;
};


export type PartyGovernmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GovernmentWhere>;
};


export type PartyGovernmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartyGovernmentsConnectionSort>>;
  where?: InputMaybe<PartyGovernmentsConnectionWhere>;
};


export type PartyMemberOfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type PartyMemberOfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type PartyMemberOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartyMemberOfConnectionSort>>;
  where?: InputMaybe<PartyMemberOfConnectionWhere>;
};


export type PartyMembersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type PartyMembersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type PartyMembersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartyMembersConnectionSort>>;
  where?: InputMaybe<PartyMembersConnectionWhere>;
};


export type PartyNomineesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type PartyNomineesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};


export type PartyNomineesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartyNomineesConnectionSort>>;
  where?: InputMaybe<PartyNomineesConnectionWhere>;
};


export type PartySucceededByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type PartySucceededByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type PartySucceededByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartySucceededByConnectionSort>>;
  where?: InputMaybe<PartySucceededByConnectionWhere>;
};


export type PartySucceedsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type PartySucceedsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type PartySucceedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartySucceedsConnectionSort>>;
  where?: InputMaybe<PartySucceedsConnectionWhere>;
};

export type PartyAggregateSelection = {
  __typename?: 'PartyAggregateSelection';
  count: Scalars['Int']['output'];
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyCouncil = {
  __typename?: 'PartyCouncil';
  councilSize: Scalars['Int']['output'];
  electedYear: Scalars['Int']['output'];
  leads: Scalars['Boolean']['output'];
  majority: Scalars['Boolean']['output'];
  mayorIndependent: Scalars['Boolean']['output'];
  mayorIsOurs: Scalars['Boolean']['output'];
  mayorParty?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  municipalityKey: Scalars['ID']['output'];
  party?: Maybe<Scalars['String']['output']>;
  population: Scalars['Int']['output'];
  province?: Maybe<Scalars['String']['output']>;
  seats: Scalars['Int']['output'];
};

export type PartyCouncilAggregateSelection = {
  __typename?: 'PartyCouncilAggregateSelection';
  councilSize: IntAggregateSelection;
  count: Scalars['Int']['output'];
  electedYear: IntAggregateSelection;
  mayorParty: StringAggregateSelection;
  municipality: StringAggregateSelection;
  municipalityKey: IdAggregateSelection;
  party: StringAggregateSelection;
  population: IntAggregateSelection;
  province: StringAggregateSelection;
  seats: IntAggregateSelection;
};

export type PartyCouncilEdge = {
  __typename?: 'PartyCouncilEdge';
  cursor: Scalars['String']['output'];
  node: PartyCouncil;
};

/** Fields to sort PartyCouncils by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartyCouncilSort object. */
export type PartyCouncilSort = {
  councilSize?: InputMaybe<SortDirection>;
  electedYear?: InputMaybe<SortDirection>;
  leads?: InputMaybe<SortDirection>;
  majority?: InputMaybe<SortDirection>;
  mayorIndependent?: InputMaybe<SortDirection>;
  mayorIsOurs?: InputMaybe<SortDirection>;
  mayorParty?: InputMaybe<SortDirection>;
  municipality?: InputMaybe<SortDirection>;
  municipalityKey?: InputMaybe<SortDirection>;
  party?: InputMaybe<SortDirection>;
  population?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  seats?: InputMaybe<SortDirection>;
};

export type PartyCouncilWhere = {
  AND?: InputMaybe<Array<PartyCouncilWhere>>;
  NOT?: InputMaybe<PartyCouncilWhere>;
  OR?: InputMaybe<Array<PartyCouncilWhere>>;
  councilSize?: InputMaybe<Scalars['Int']['input']>;
  councilSize_GT?: InputMaybe<Scalars['Int']['input']>;
  councilSize_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilSize_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilSize_LT?: InputMaybe<Scalars['Int']['input']>;
  councilSize_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilSize_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilSize_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  electedYear?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_GTE?: InputMaybe<Scalars['Int']['input']>;
  electedYear_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  electedYear_LT?: InputMaybe<Scalars['Int']['input']>;
  electedYear_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  electedYear_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  leads?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  leads_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  majority?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  majority_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  mayorIndependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorIndependent_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  mayorIsOurs?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorIsOurs_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  mayorParty?: InputMaybe<Scalars['String']['input']>;
  mayorParty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mayorParty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayorParty_GT?: InputMaybe<Scalars['String']['input']>;
  mayorParty_GTE?: InputMaybe<Scalars['String']['input']>;
  mayorParty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mayorParty_LT?: InputMaybe<Scalars['String']['input']>;
  mayorParty_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorParty_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorParty_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorParty_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorParty_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayorParty_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayorParty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  municipalityKey?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalityKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipalityKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipality_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  municipality_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_GT?: InputMaybe<Scalars['String']['input']>;
  municipality_GTE?: InputMaybe<Scalars['String']['input']>;
  municipality_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  municipality_LT?: InputMaybe<Scalars['String']['input']>;
  municipality_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  party_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  party_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_GT?: InputMaybe<Scalars['String']['input']>;
  party_GTE?: InputMaybe<Scalars['String']['input']>;
  party_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  party_LT?: InputMaybe<Scalars['String']['input']>;
  party_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  population_GT?: InputMaybe<Scalars['Int']['input']>;
  population_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  population_LT?: InputMaybe<Scalars['Int']['input']>;
  population_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  province_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_GT?: InputMaybe<Scalars['String']['input']>;
  province_GTE?: InputMaybe<Scalars['String']['input']>;
  province_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  province_LT?: InputMaybe<Scalars['String']['input']>;
  province_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  seats_GT?: InputMaybe<Scalars['Int']['input']>;
  seats_GTE?: InputMaybe<Scalars['Int']['input']>;
  seats_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  seats_LT?: InputMaybe<Scalars['Int']['input']>;
  seats_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seats_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  seats_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PartyCouncilsConnection = {
  __typename?: 'PartyCouncilsConnection';
  edges: Array<PartyCouncilEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyEdge = {
  __typename?: 'PartyEdge';
  cursor: Scalars['String']['output'];
  node: Party;
};

export type PartyFamiliesConnection = {
  __typename?: 'PartyFamiliesConnection';
  edges: Array<PartyFamilyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyFamily = {
  __typename?: 'PartyFamily';
  banners: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  mayors: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PartyFamilyAggregateSelection = {
  __typename?: 'PartyFamilyAggregateSelection';
  banners: IntAggregateSelection;
  count: Scalars['Int']['output'];
  key: StringAggregateSelection;
  mayors: IntAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyFamilyEdge = {
  __typename?: 'PartyFamilyEdge';
  cursor: Scalars['String']['output'];
  node: PartyFamily;
};

/** Fields to sort PartyFamilies by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartyFamilySort object. */
export type PartyFamilySort = {
  banners?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  mayors?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PartyFamilyWhere = {
  AND?: InputMaybe<Array<PartyFamilyWhere>>;
  NOT?: InputMaybe<PartyFamilyWhere>;
  OR?: InputMaybe<Array<PartyFamilyWhere>>;
  banners?: InputMaybe<Scalars['Int']['input']>;
  banners_GT?: InputMaybe<Scalars['Int']['input']>;
  banners_GTE?: InputMaybe<Scalars['Int']['input']>;
  banners_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  banners_LT?: InputMaybe<Scalars['Int']['input']>;
  banners_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  banners_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  banners_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_GT?: InputMaybe<Scalars['String']['input']>;
  key_GTE?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_LT?: InputMaybe<Scalars['String']['input']>;
  key_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mayors?: InputMaybe<Scalars['Int']['input']>;
  mayors_GT?: InputMaybe<Scalars['Int']['input']>;
  mayors_GTE?: InputMaybe<Scalars['Int']['input']>;
  mayors_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mayors_LT?: InputMaybe<Scalars['Int']['input']>;
  mayors_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayors_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayors_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PartyGovernmentGovernmentsAggregationSelection = {
  __typename?: 'PartyGovernmentGovernmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PartyGovernmentGovernmentsNodeAggregateSelection>;
};

export type PartyGovernmentGovernmentsNodeAggregateSelection = {
  __typename?: 'PartyGovernmentGovernmentsNodeAggregateSelection';
  end_date: StringAggregateSelection;
  gov_id: IdAggregateSelection;
  name: StringAggregateSelection;
  pm_name: StringAggregateSelection;
  start_date: StringAggregateSelection;
};

export type PartyGovernmentsAggregateInput = {
  AND?: InputMaybe<Array<PartyGovernmentsAggregateInput>>;
  NOT?: InputMaybe<PartyGovernmentsAggregateInput>;
  OR?: InputMaybe<Array<PartyGovernmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PartyGovernmentsNodeAggregationWhereInput>;
};

export type PartyGovernmentsConnection = {
  __typename?: 'PartyGovernmentsConnection';
  edges: Array<PartyGovernmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyGovernmentsConnectionSort = {
  node?: InputMaybe<GovernmentSort>;
};

export type PartyGovernmentsConnectionWhere = {
  AND?: InputMaybe<Array<PartyGovernmentsConnectionWhere>>;
  NOT?: InputMaybe<PartyGovernmentsConnectionWhere>;
  OR?: InputMaybe<Array<PartyGovernmentsConnectionWhere>>;
  node?: InputMaybe<GovernmentWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GovernmentWhere>;
};

export type PartyGovernmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartyGovernmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartyGovernmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartyGovernmentsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  end_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  end_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  gov_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pm_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pm_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pm_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pm_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pm_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  pm_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  pm_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  pm_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  pm_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pm_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pm_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pm_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pm_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  pm_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  pm_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  pm_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pm_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pm_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pm_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pm_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  pm_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  start_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  start_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartyGovernmentsRelationship = {
  __typename?: 'PartyGovernmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Government;
};

export type PartyMayor = {
  __typename?: 'PartyMayor';
  elected_round?: Maybe<Scalars['Int']['output']>;
  elected_year?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  municipality_key: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<Scalars['String']['output']>;
  person_hash: Scalars['ID']['output'];
  population?: Maybe<Scalars['Int']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  term_end?: Maybe<Scalars['Int']['output']>;
};

export type PartyMayorAggregateSelection = {
  __typename?: 'PartyMayorAggregateSelection';
  count: Scalars['Int']['output'];
  elected_round: IntAggregateSelection;
  elected_year: IntAggregateSelection;
  municipality: StringAggregateSelection;
  municipality_key: IdAggregateSelection;
  name: StringAggregateSelection;
  party: StringAggregateSelection;
  person_hash: IdAggregateSelection;
  population: IntAggregateSelection;
  province: StringAggregateSelection;
  term_end: IntAggregateSelection;
};

export type PartyMayorEdge = {
  __typename?: 'PartyMayorEdge';
  cursor: Scalars['String']['output'];
  node: PartyMayor;
};

/** Fields to sort PartyMayors by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartyMayorSort object. */
export type PartyMayorSort = {
  elected_round?: InputMaybe<SortDirection>;
  elected_year?: InputMaybe<SortDirection>;
  municipality?: InputMaybe<SortDirection>;
  municipality_key?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  party?: InputMaybe<SortDirection>;
  person_hash?: InputMaybe<SortDirection>;
  population?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  term_end?: InputMaybe<SortDirection>;
};

export type PartyMayorWhere = {
  AND?: InputMaybe<Array<PartyMayorWhere>>;
  NOT?: InputMaybe<PartyMayorWhere>;
  OR?: InputMaybe<Array<PartyMayorWhere>>;
  elected_round?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_round_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  municipality_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  municipality_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_GT?: InputMaybe<Scalars['String']['input']>;
  municipality_GTE?: InputMaybe<Scalars['String']['input']>;
  municipality_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  municipality_LT?: InputMaybe<Scalars['String']['input']>;
  municipality_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  municipality_key?: InputMaybe<Scalars['ID']['input']>;
  municipality_key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  municipality_key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipality_key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipality_key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  municipality_key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  party_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  party_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_GT?: InputMaybe<Scalars['String']['input']>;
  party_GTE?: InputMaybe<Scalars['String']['input']>;
  party_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  party_LT?: InputMaybe<Scalars['String']['input']>;
  party_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  party_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  party_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  person_hash?: InputMaybe<Scalars['ID']['input']>;
  person_hash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  person_hash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  person_hash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  person_hash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  population_GT?: InputMaybe<Scalars['Int']['input']>;
  population_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  population_LT?: InputMaybe<Scalars['Int']['input']>;
  population_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  population_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  province_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_GT?: InputMaybe<Scalars['String']['input']>;
  province_GTE?: InputMaybe<Scalars['String']['input']>;
  province_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  province_LT?: InputMaybe<Scalars['String']['input']>;
  province_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  province_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  province_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  term_end?: InputMaybe<Scalars['Int']['input']>;
  term_end_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  term_end_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PartyMayorsConnection = {
  __typename?: 'PartyMayorsConnection';
  edges: Array<PartyMayorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyMemberOfAggregateInput = {
  AND?: InputMaybe<Array<PartyMemberOfAggregateInput>>;
  NOT?: InputMaybe<PartyMemberOfAggregateInput>;
  OR?: InputMaybe<Array<PartyMemberOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<MembershipAggregationWhereInput>;
  node?: InputMaybe<PartyMemberOfNodeAggregationWhereInput>;
};

export type PartyMemberOfConnection = {
  __typename?: 'PartyMemberOfConnection';
  edges: Array<PartyMemberOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyMemberOfConnectionSort = {
  edge?: InputMaybe<MembershipSort>;
  node?: InputMaybe<PartySort>;
};

export type PartyMemberOfConnectionWhere = {
  AND?: InputMaybe<Array<PartyMemberOfConnectionWhere>>;
  NOT?: InputMaybe<PartyMemberOfConnectionWhere>;
  OR?: InputMaybe<Array<PartyMemberOfConnectionWhere>>;
  edge?: InputMaybe<MembershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<MembershipWhere>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type PartyMemberOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartyMemberOfNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartyMemberOfNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartyMemberOfNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartyMemberOfRelationship = {
  __typename?: 'PartyMemberOfRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
  properties: Membership;
};

export type PartyMembersAggregateInput = {
  AND?: InputMaybe<Array<PartyMembersAggregateInput>>;
  NOT?: InputMaybe<PartyMembersAggregateInput>;
  OR?: InputMaybe<Array<PartyMembersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<MembershipAggregationWhereInput>;
  node?: InputMaybe<PartyMembersNodeAggregationWhereInput>;
};

export type PartyMembersConnection = {
  __typename?: 'PartyMembersConnection';
  edges: Array<PartyMembersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyMembersConnectionSort = {
  edge?: InputMaybe<MembershipSort>;
  node?: InputMaybe<PartySort>;
};

export type PartyMembersConnectionWhere = {
  AND?: InputMaybe<Array<PartyMembersConnectionWhere>>;
  NOT?: InputMaybe<PartyMembersConnectionWhere>;
  OR?: InputMaybe<Array<PartyMembersConnectionWhere>>;
  edge?: InputMaybe<MembershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<MembershipWhere>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type PartyMembersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartyMembersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartyMembersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartyMembersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartyMembersRelationship = {
  __typename?: 'PartyMembersRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
  properties: Membership;
};

export type PartyNomineesAggregateInput = {
  AND?: InputMaybe<Array<PartyNomineesAggregateInput>>;
  NOT?: InputMaybe<PartyNomineesAggregateInput>;
  OR?: InputMaybe<Array<PartyNomineesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<NominationAggregationWhereInput>;
  node?: InputMaybe<PartyNomineesNodeAggregationWhereInput>;
};

export type PartyNomineesConnection = {
  __typename?: 'PartyNomineesConnection';
  edges: Array<PartyNomineesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyNomineesConnectionSort = {
  edge?: InputMaybe<NominationSort>;
  node?: InputMaybe<PersonSort>;
};

export type PartyNomineesConnectionWhere = {
  AND?: InputMaybe<Array<PartyNomineesConnectionWhere>>;
  NOT?: InputMaybe<PartyNomineesConnectionWhere>;
  OR?: InputMaybe<Array<PartyNomineesConnectionWhere>>;
  edge?: InputMaybe<NominationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NominationWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type PartyNomineesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartyNomineesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartyNomineesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartyNomineesNodeAggregationWhereInput>>;
  company_links_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  company_links_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  person_hash_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type PartyNomineesRelationship = {
  __typename?: 'PartyNomineesRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: Nomination;
};

export type PartyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PartySort objects to sort Parties by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PartySort>>;
};

export type PartyPartyMemberOfAggregationSelection = {
  __typename?: 'PartyPartyMemberOfAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PartyPartyMemberOfEdgeAggregateSelection>;
  node?: Maybe<PartyPartyMemberOfNodeAggregateSelection>;
};

export type PartyPartyMemberOfEdgeAggregateSelection = {
  __typename?: 'PartyPartyMemberOfEdgeAggregateSelection';
  created_at: StringAggregateSelection;
  from_year: IntAggregateSelection;
  note: StringAggregateSelection;
  source: StringAggregateSelection;
  to_year: IntAggregateSelection;
};

export type PartyPartyMemberOfNodeAggregateSelection = {
  __typename?: 'PartyPartyMemberOfNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyPartyMembersAggregationSelection = {
  __typename?: 'PartyPartyMembersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PartyPartyMembersEdgeAggregateSelection>;
  node?: Maybe<PartyPartyMembersNodeAggregateSelection>;
};

export type PartyPartyMembersEdgeAggregateSelection = {
  __typename?: 'PartyPartyMembersEdgeAggregateSelection';
  created_at: StringAggregateSelection;
  from_year: IntAggregateSelection;
  note: StringAggregateSelection;
  source: StringAggregateSelection;
  to_year: IntAggregateSelection;
};

export type PartyPartyMembersNodeAggregateSelection = {
  __typename?: 'PartyPartyMembersNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyPartySucceededByAggregationSelection = {
  __typename?: 'PartyPartySucceededByAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PartyPartySucceededByEdgeAggregateSelection>;
  node?: Maybe<PartyPartySucceededByNodeAggregateSelection>;
};

export type PartyPartySucceededByEdgeAggregateSelection = {
  __typename?: 'PartyPartySucceededByEdgeAggregateSelection';
  created_at: StringAggregateSelection;
  note: StringAggregateSelection;
  source: StringAggregateSelection;
  year: IntAggregateSelection;
};

export type PartyPartySucceededByNodeAggregateSelection = {
  __typename?: 'PartyPartySucceededByNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyPartySucceedsAggregationSelection = {
  __typename?: 'PartyPartySucceedsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PartyPartySucceedsEdgeAggregateSelection>;
  node?: Maybe<PartyPartySucceedsNodeAggregateSelection>;
};

export type PartyPartySucceedsEdgeAggregateSelection = {
  __typename?: 'PartyPartySucceedsEdgeAggregateSelection';
  created_at: StringAggregateSelection;
  note: StringAggregateSelection;
  source: StringAggregateSelection;
  year: IntAggregateSelection;
};

export type PartyPartySucceedsNodeAggregateSelection = {
  __typename?: 'PartyPartySucceedsNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PartyPersonNomineesAggregationSelection = {
  __typename?: 'PartyPersonNomineesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PartyPersonNomineesEdgeAggregateSelection>;
  node?: Maybe<PartyPersonNomineesNodeAggregateSelection>;
};

export type PartyPersonNomineesEdgeAggregateSelection = {
  __typename?: 'PartyPersonNomineesEdgeAggregateSelection';
  election_year: IntAggregateSelection;
};

export type PartyPersonNomineesNodeAggregateSelection = {
  __typename?: 'PartyPersonNomineesNodeAggregateSelection';
  company_links: IntAggregateSelection;
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

/** Fields to sort Parties by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartySort object. */
export type PartySort = {
  family_key?: InputMaybe<SortDirection>;
  family_name?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PartyStat = {
  __typename?: 'PartyStat';
  awards: Scalars['Int']['output'];
  banners: Scalars['Int']['output'];
  councilSeats: Scalars['Int']['output'];
  councils: Scalars['Int']['output'];
  councilsLed: Scalars['Int']['output'];
  councilsWithMajority: Scalars['Int']['output'];
  currentMunicipalities: Scalars['Int']['output'];
  governmentAwards: Scalars['Int']['output'];
  governmentValue: Scalars['Float']['output'];
  isFamily: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  mayors: Scalars['Int']['output'];
  ministries: Scalars['Int']['output'];
  municipalities: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PartyStatAggregateSelection = {
  __typename?: 'PartyStatAggregateSelection';
  awards: IntAggregateSelection;
  banners: IntAggregateSelection;
  councilSeats: IntAggregateSelection;
  councils: IntAggregateSelection;
  councilsLed: IntAggregateSelection;
  councilsWithMajority: IntAggregateSelection;
  count: Scalars['Int']['output'];
  currentMunicipalities: IntAggregateSelection;
  governmentAwards: IntAggregateSelection;
  governmentValue: FloatAggregateSelection;
  key: IdAggregateSelection;
  mayors: IntAggregateSelection;
  ministries: IntAggregateSelection;
  municipalities: IntAggregateSelection;
  name: StringAggregateSelection;
  value: FloatAggregateSelection;
};

export type PartyStatEdge = {
  __typename?: 'PartyStatEdge';
  cursor: Scalars['String']['output'];
  node: PartyStat;
};

/** Fields to sort PartyStats by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartyStatSort object. */
export type PartyStatSort = {
  awards?: InputMaybe<SortDirection>;
  banners?: InputMaybe<SortDirection>;
  councilSeats?: InputMaybe<SortDirection>;
  councils?: InputMaybe<SortDirection>;
  councilsLed?: InputMaybe<SortDirection>;
  councilsWithMajority?: InputMaybe<SortDirection>;
  currentMunicipalities?: InputMaybe<SortDirection>;
  governmentAwards?: InputMaybe<SortDirection>;
  governmentValue?: InputMaybe<SortDirection>;
  isFamily?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  mayors?: InputMaybe<SortDirection>;
  ministries?: InputMaybe<SortDirection>;
  municipalities?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type PartyStatWhere = {
  AND?: InputMaybe<Array<PartyStatWhere>>;
  NOT?: InputMaybe<PartyStatWhere>;
  OR?: InputMaybe<Array<PartyStatWhere>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  banners?: InputMaybe<Scalars['Int']['input']>;
  banners_GT?: InputMaybe<Scalars['Int']['input']>;
  banners_GTE?: InputMaybe<Scalars['Int']['input']>;
  banners_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  banners_LT?: InputMaybe<Scalars['Int']['input']>;
  banners_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  banners_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  banners_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilSeats?: InputMaybe<Scalars['Int']['input']>;
  councilSeats_GT?: InputMaybe<Scalars['Int']['input']>;
  councilSeats_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilSeats_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilSeats_LT?: InputMaybe<Scalars['Int']['input']>;
  councilSeats_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilSeats_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilSeats_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councils?: InputMaybe<Scalars['Int']['input']>;
  councilsLed?: InputMaybe<Scalars['Int']['input']>;
  councilsLed_GT?: InputMaybe<Scalars['Int']['input']>;
  councilsLed_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilsLed_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilsLed_LT?: InputMaybe<Scalars['Int']['input']>;
  councilsLed_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilsLed_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilsLed_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilsWithMajority?: InputMaybe<Scalars['Int']['input']>;
  councilsWithMajority_GT?: InputMaybe<Scalars['Int']['input']>;
  councilsWithMajority_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilsWithMajority_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilsWithMajority_LT?: InputMaybe<Scalars['Int']['input']>;
  councilsWithMajority_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilsWithMajority_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilsWithMajority_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councils_GT?: InputMaybe<Scalars['Int']['input']>;
  councils_GTE?: InputMaybe<Scalars['Int']['input']>;
  councils_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councils_LT?: InputMaybe<Scalars['Int']['input']>;
  councils_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councils_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councils_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentMunicipalities?: InputMaybe<Scalars['Int']['input']>;
  currentMunicipalities_GT?: InputMaybe<Scalars['Int']['input']>;
  currentMunicipalities_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentMunicipalities_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentMunicipalities_LT?: InputMaybe<Scalars['Int']['input']>;
  currentMunicipalities_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentMunicipalities_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentMunicipalities_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  governmentAwards?: InputMaybe<Scalars['Int']['input']>;
  governmentAwards_GT?: InputMaybe<Scalars['Int']['input']>;
  governmentAwards_GTE?: InputMaybe<Scalars['Int']['input']>;
  governmentAwards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  governmentAwards_LT?: InputMaybe<Scalars['Int']['input']>;
  governmentAwards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  governmentAwards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  governmentAwards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  governmentValue?: InputMaybe<Scalars['Float']['input']>;
  governmentValue_GT?: InputMaybe<Scalars['Float']['input']>;
  governmentValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  governmentValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  governmentValue_LT?: InputMaybe<Scalars['Float']['input']>;
  governmentValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  governmentValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  governmentValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  isFamily?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isFamily_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mayors?: InputMaybe<Scalars['Int']['input']>;
  mayors_GT?: InputMaybe<Scalars['Int']['input']>;
  mayors_GTE?: InputMaybe<Scalars['Int']['input']>;
  mayors_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mayors_LT?: InputMaybe<Scalars['Int']['input']>;
  mayors_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayors_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mayors_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  ministries?: InputMaybe<Scalars['Int']['input']>;
  ministries_GT?: InputMaybe<Scalars['Int']['input']>;
  ministries_GTE?: InputMaybe<Scalars['Int']['input']>;
  ministries_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  ministries_LT?: InputMaybe<Scalars['Int']['input']>;
  ministries_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministries_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ministries_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  municipalities?: InputMaybe<Scalars['Int']['input']>;
  municipalities_GT?: InputMaybe<Scalars['Int']['input']>;
  municipalities_GTE?: InputMaybe<Scalars['Int']['input']>;
  municipalities_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  municipalities_LT?: InputMaybe<Scalars['Int']['input']>;
  municipalities_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalities_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalities_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type PartyStatsConnection = {
  __typename?: 'PartyStatsConnection';
  edges: Array<PartyStatEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartySucceededByAggregateInput = {
  AND?: InputMaybe<Array<PartySucceededByAggregateInput>>;
  NOT?: InputMaybe<PartySucceededByAggregateInput>;
  OR?: InputMaybe<Array<PartySucceededByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<SuccessionAggregationWhereInput>;
  node?: InputMaybe<PartySucceededByNodeAggregationWhereInput>;
};

export type PartySucceededByConnection = {
  __typename?: 'PartySucceededByConnection';
  edges: Array<PartySucceededByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartySucceededByConnectionSort = {
  edge?: InputMaybe<SuccessionSort>;
  node?: InputMaybe<PartySort>;
};

export type PartySucceededByConnectionWhere = {
  AND?: InputMaybe<Array<PartySucceededByConnectionWhere>>;
  NOT?: InputMaybe<PartySucceededByConnectionWhere>;
  OR?: InputMaybe<Array<PartySucceededByConnectionWhere>>;
  edge?: InputMaybe<SuccessionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<SuccessionWhere>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type PartySucceededByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartySucceededByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartySucceededByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartySucceededByNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartySucceededByRelationship = {
  __typename?: 'PartySucceededByRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
  properties: Succession;
};

export type PartySucceedsAggregateInput = {
  AND?: InputMaybe<Array<PartySucceedsAggregateInput>>;
  NOT?: InputMaybe<PartySucceedsAggregateInput>;
  OR?: InputMaybe<Array<PartySucceedsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<SuccessionAggregationWhereInput>;
  node?: InputMaybe<PartySucceedsNodeAggregationWhereInput>;
};

export type PartySucceedsConnection = {
  __typename?: 'PartySucceedsConnection';
  edges: Array<PartySucceedsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartySucceedsConnectionSort = {
  edge?: InputMaybe<SuccessionSort>;
  node?: InputMaybe<PartySort>;
};

export type PartySucceedsConnectionWhere = {
  AND?: InputMaybe<Array<PartySucceedsConnectionWhere>>;
  NOT?: InputMaybe<PartySucceedsConnectionWhere>;
  OR?: InputMaybe<Array<PartySucceedsConnectionWhere>>;
  edge?: InputMaybe<SuccessionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<SuccessionWhere>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type PartySucceedsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartySucceedsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartySucceedsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartySucceedsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartySucceedsRelationship = {
  __typename?: 'PartySucceedsRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
  properties: Succession;
};

export type PartySupplier = {
  __typename?: 'PartySupplier';
  awards: Scalars['Int']['output'];
  municipalities: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  shareOfCompany?: Maybe<Scalars['Float']['output']>;
  shareOfParty: Scalars['Float']['output'];
  uic: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type PartySupplierAggregateSelection = {
  __typename?: 'PartySupplierAggregateSelection';
  awards: IntAggregateSelection;
  count: Scalars['Int']['output'];
  municipalities: IntAggregateSelection;
  name: StringAggregateSelection;
  shareOfCompany: FloatAggregateSelection;
  shareOfParty: FloatAggregateSelection;
  uic: IdAggregateSelection;
  value: FloatAggregateSelection;
};

export type PartySupplierEdge = {
  __typename?: 'PartySupplierEdge';
  cursor: Scalars['String']['output'];
  node: PartySupplier;
};

/** Fields to sort PartySuppliers by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartySupplierSort object. */
export type PartySupplierSort = {
  awards?: InputMaybe<SortDirection>;
  municipalities?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shareOfCompany?: InputMaybe<SortDirection>;
  shareOfParty?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type PartySupplierWhere = {
  AND?: InputMaybe<Array<PartySupplierWhere>>;
  NOT?: InputMaybe<PartySupplierWhere>;
  OR?: InputMaybe<Array<PartySupplierWhere>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  municipalities?: InputMaybe<Scalars['Int']['input']>;
  municipalities_GT?: InputMaybe<Scalars['Int']['input']>;
  municipalities_GTE?: InputMaybe<Scalars['Int']['input']>;
  municipalities_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  municipalities_LT?: InputMaybe<Scalars['Int']['input']>;
  municipalities_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalities_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  municipalities_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shareOfCompany?: InputMaybe<Scalars['Float']['input']>;
  shareOfCompany_GT?: InputMaybe<Scalars['Float']['input']>;
  shareOfCompany_GTE?: InputMaybe<Scalars['Float']['input']>;
  shareOfCompany_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  shareOfCompany_LT?: InputMaybe<Scalars['Float']['input']>;
  shareOfCompany_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shareOfCompany_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shareOfCompany_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  shareOfParty?: InputMaybe<Scalars['Float']['input']>;
  shareOfParty_GT?: InputMaybe<Scalars['Float']['input']>;
  shareOfParty_GTE?: InputMaybe<Scalars['Float']['input']>;
  shareOfParty_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  shareOfParty_LT?: InputMaybe<Scalars['Float']['input']>;
  shareOfParty_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shareOfParty_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shareOfParty_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type PartySuppliersConnection = {
  __typename?: 'PartySuppliersConnection';
  edges: Array<PartySupplierEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartyWhere = {
  AND?: InputMaybe<Array<PartyWhere>>;
  NOT?: InputMaybe<PartyWhere>;
  OR?: InputMaybe<Array<PartyWhere>>;
  family_key?: InputMaybe<Scalars['String']['input']>;
  family_key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  family_key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  family_key_GT?: InputMaybe<Scalars['String']['input']>;
  family_key_GTE?: InputMaybe<Scalars['String']['input']>;
  family_key_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  family_key_LT?: InputMaybe<Scalars['String']['input']>;
  family_key_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_key_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_key_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_key_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_key_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_key_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  family_key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  family_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  family_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  family_name_GT?: InputMaybe<Scalars['String']['input']>;
  family_name_GTE?: InputMaybe<Scalars['String']['input']>;
  family_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  family_name_LT?: InputMaybe<Scalars['String']['input']>;
  family_name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  family_name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  family_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `governments_SOME` instead. */
  governments?: InputMaybe<GovernmentWhere>;
  governmentsAggregate?: InputMaybe<PartyGovernmentsAggregateInput>;
  /** @deprecated Use `governmentsConnection_SOME` instead. */
  governmentsConnection?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** Return Parties where all of the related PartyGovernmentsConnections match this filter */
  governmentsConnection_ALL?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** Return Parties where none of the related PartyGovernmentsConnections match this filter */
  governmentsConnection_NONE?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** @deprecated Use `governmentsConnection_NONE` instead. */
  governmentsConnection_NOT?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** Return Parties where one of the related PartyGovernmentsConnections match this filter */
  governmentsConnection_SINGLE?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** Return Parties where some of the related PartyGovernmentsConnections match this filter */
  governmentsConnection_SOME?: InputMaybe<PartyGovernmentsConnectionWhere>;
  /** Return Parties where all of the related Governments match this filter */
  governments_ALL?: InputMaybe<GovernmentWhere>;
  /** Return Parties where none of the related Governments match this filter */
  governments_NONE?: InputMaybe<GovernmentWhere>;
  /** @deprecated Use `governments_NONE` instead. */
  governments_NOT?: InputMaybe<GovernmentWhere>;
  /** Return Parties where one of the related Governments match this filter */
  governments_SINGLE?: InputMaybe<GovernmentWhere>;
  /** Return Parties where some of the related Governments match this filter */
  governments_SOME?: InputMaybe<GovernmentWhere>;
  key?: InputMaybe<Scalars['ID']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  key_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `memberOf_SOME` instead. */
  memberOf?: InputMaybe<PartyWhere>;
  memberOfAggregate?: InputMaybe<PartyMemberOfAggregateInput>;
  /** @deprecated Use `memberOfConnection_SOME` instead. */
  memberOfConnection?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** Return Parties where all of the related PartyMemberOfConnections match this filter */
  memberOfConnection_ALL?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** Return Parties where none of the related PartyMemberOfConnections match this filter */
  memberOfConnection_NONE?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** @deprecated Use `memberOfConnection_NONE` instead. */
  memberOfConnection_NOT?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** Return Parties where one of the related PartyMemberOfConnections match this filter */
  memberOfConnection_SINGLE?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** Return Parties where some of the related PartyMemberOfConnections match this filter */
  memberOfConnection_SOME?: InputMaybe<PartyMemberOfConnectionWhere>;
  /** Return Parties where all of the related Parties match this filter */
  memberOf_ALL?: InputMaybe<PartyWhere>;
  /** Return Parties where none of the related Parties match this filter */
  memberOf_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `memberOf_NONE` instead. */
  memberOf_NOT?: InputMaybe<PartyWhere>;
  /** Return Parties where one of the related Parties match this filter */
  memberOf_SINGLE?: InputMaybe<PartyWhere>;
  /** Return Parties where some of the related Parties match this filter */
  memberOf_SOME?: InputMaybe<PartyWhere>;
  /** @deprecated Use `members_SOME` instead. */
  members?: InputMaybe<PartyWhere>;
  membersAggregate?: InputMaybe<PartyMembersAggregateInput>;
  /** @deprecated Use `membersConnection_SOME` instead. */
  membersConnection?: InputMaybe<PartyMembersConnectionWhere>;
  /** Return Parties where all of the related PartyMembersConnections match this filter */
  membersConnection_ALL?: InputMaybe<PartyMembersConnectionWhere>;
  /** Return Parties where none of the related PartyMembersConnections match this filter */
  membersConnection_NONE?: InputMaybe<PartyMembersConnectionWhere>;
  /** @deprecated Use `membersConnection_NONE` instead. */
  membersConnection_NOT?: InputMaybe<PartyMembersConnectionWhere>;
  /** Return Parties where one of the related PartyMembersConnections match this filter */
  membersConnection_SINGLE?: InputMaybe<PartyMembersConnectionWhere>;
  /** Return Parties where some of the related PartyMembersConnections match this filter */
  membersConnection_SOME?: InputMaybe<PartyMembersConnectionWhere>;
  /** Return Parties where all of the related Parties match this filter */
  members_ALL?: InputMaybe<PartyWhere>;
  /** Return Parties where none of the related Parties match this filter */
  members_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `members_NONE` instead. */
  members_NOT?: InputMaybe<PartyWhere>;
  /** Return Parties where one of the related Parties match this filter */
  members_SINGLE?: InputMaybe<PartyWhere>;
  /** Return Parties where some of the related Parties match this filter */
  members_SOME?: InputMaybe<PartyWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `nominees_SOME` instead. */
  nominees?: InputMaybe<PersonWhere>;
  nomineesAggregate?: InputMaybe<PartyNomineesAggregateInput>;
  /** @deprecated Use `nomineesConnection_SOME` instead. */
  nomineesConnection?: InputMaybe<PartyNomineesConnectionWhere>;
  /** Return Parties where all of the related PartyNomineesConnections match this filter */
  nomineesConnection_ALL?: InputMaybe<PartyNomineesConnectionWhere>;
  /** Return Parties where none of the related PartyNomineesConnections match this filter */
  nomineesConnection_NONE?: InputMaybe<PartyNomineesConnectionWhere>;
  /** @deprecated Use `nomineesConnection_NONE` instead. */
  nomineesConnection_NOT?: InputMaybe<PartyNomineesConnectionWhere>;
  /** Return Parties where one of the related PartyNomineesConnections match this filter */
  nomineesConnection_SINGLE?: InputMaybe<PartyNomineesConnectionWhere>;
  /** Return Parties where some of the related PartyNomineesConnections match this filter */
  nomineesConnection_SOME?: InputMaybe<PartyNomineesConnectionWhere>;
  /** Return Parties where all of the related People match this filter */
  nominees_ALL?: InputMaybe<PersonWhere>;
  /** Return Parties where none of the related People match this filter */
  nominees_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `nominees_NONE` instead. */
  nominees_NOT?: InputMaybe<PersonWhere>;
  /** Return Parties where one of the related People match this filter */
  nominees_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Parties where some of the related People match this filter */
  nominees_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `succeededBy_SOME` instead. */
  succeededBy?: InputMaybe<PartyWhere>;
  succeededByAggregate?: InputMaybe<PartySucceededByAggregateInput>;
  /** @deprecated Use `succeededByConnection_SOME` instead. */
  succeededByConnection?: InputMaybe<PartySucceededByConnectionWhere>;
  /** Return Parties where all of the related PartySucceededByConnections match this filter */
  succeededByConnection_ALL?: InputMaybe<PartySucceededByConnectionWhere>;
  /** Return Parties where none of the related PartySucceededByConnections match this filter */
  succeededByConnection_NONE?: InputMaybe<PartySucceededByConnectionWhere>;
  /** @deprecated Use `succeededByConnection_NONE` instead. */
  succeededByConnection_NOT?: InputMaybe<PartySucceededByConnectionWhere>;
  /** Return Parties where one of the related PartySucceededByConnections match this filter */
  succeededByConnection_SINGLE?: InputMaybe<PartySucceededByConnectionWhere>;
  /** Return Parties where some of the related PartySucceededByConnections match this filter */
  succeededByConnection_SOME?: InputMaybe<PartySucceededByConnectionWhere>;
  /** Return Parties where all of the related Parties match this filter */
  succeededBy_ALL?: InputMaybe<PartyWhere>;
  /** Return Parties where none of the related Parties match this filter */
  succeededBy_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `succeededBy_NONE` instead. */
  succeededBy_NOT?: InputMaybe<PartyWhere>;
  /** Return Parties where one of the related Parties match this filter */
  succeededBy_SINGLE?: InputMaybe<PartyWhere>;
  /** Return Parties where some of the related Parties match this filter */
  succeededBy_SOME?: InputMaybe<PartyWhere>;
  /** @deprecated Use `succeeds_SOME` instead. */
  succeeds?: InputMaybe<PartyWhere>;
  succeedsAggregate?: InputMaybe<PartySucceedsAggregateInput>;
  /** @deprecated Use `succeedsConnection_SOME` instead. */
  succeedsConnection?: InputMaybe<PartySucceedsConnectionWhere>;
  /** Return Parties where all of the related PartySucceedsConnections match this filter */
  succeedsConnection_ALL?: InputMaybe<PartySucceedsConnectionWhere>;
  /** Return Parties where none of the related PartySucceedsConnections match this filter */
  succeedsConnection_NONE?: InputMaybe<PartySucceedsConnectionWhere>;
  /** @deprecated Use `succeedsConnection_NONE` instead. */
  succeedsConnection_NOT?: InputMaybe<PartySucceedsConnectionWhere>;
  /** Return Parties where one of the related PartySucceedsConnections match this filter */
  succeedsConnection_SINGLE?: InputMaybe<PartySucceedsConnectionWhere>;
  /** Return Parties where some of the related PartySucceedsConnections match this filter */
  succeedsConnection_SOME?: InputMaybe<PartySucceedsConnectionWhere>;
  /** Return Parties where all of the related Parties match this filter */
  succeeds_ALL?: InputMaybe<PartyWhere>;
  /** Return Parties where none of the related Parties match this filter */
  succeeds_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `succeeds_NONE` instead. */
  succeeds_NOT?: InputMaybe<PartyWhere>;
  /** Return Parties where one of the related Parties match this filter */
  succeeds_SINGLE?: InputMaybe<PartyWhere>;
  /** Return Parties where some of the related Parties match this filter */
  succeeds_SOME?: InputMaybe<PartyWhere>;
};

export type PeopleConnection = {
  __typename?: 'PeopleConnection';
  edges: Array<PersonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Person = {
  __typename?: 'Person';
  company_links?: Maybe<Scalars['Int']['output']>;
  managedCompanies: Array<Company>;
  managedCompaniesAggregate?: Maybe<PersonCompanyManagedCompaniesAggregationSelection>;
  managedCompaniesConnection: PersonManagedCompaniesConnection;
  mayorOf: Array<Municipality>;
  mayorOfAggregate?: Maybe<PersonMunicipalityMayorOfAggregationSelection>;
  mayorOfConnection: PersonMayorOfConnection;
  name?: Maybe<Scalars['String']['output']>;
  nominatedBy: Array<Party>;
  nominatedByAggregate?: Maybe<PersonPartyNominatedByAggregationSelection>;
  nominatedByConnection: PersonNominatedByConnection;
  ownedCompanies: Array<Company>;
  ownedCompaniesAggregate?: Maybe<PersonCompanyOwnedCompaniesAggregationSelection>;
  ownedCompaniesConnection: PersonOwnedCompaniesConnection;
  person_hash: Scalars['ID']['output'];
  positions: Array<Municipality>;
  positionsAggregate?: Maybe<PersonMunicipalityPositionsAggregationSelection>;
  positionsConnection: PersonPositionsConnection;
};


export type PersonManagedCompaniesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type PersonManagedCompaniesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type PersonManagedCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonManagedCompaniesConnectionSort>>;
  where?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
};


export type PersonMayorOfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type PersonMayorOfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type PersonMayorOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonMayorOfConnectionSort>>;
  where?: InputMaybe<PersonMayorOfConnectionWhere>;
};


export type PersonNominatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type PersonNominatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartyWhere>;
};


export type PersonNominatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonNominatedByConnectionSort>>;
  where?: InputMaybe<PersonNominatedByConnectionWhere>;
};


export type PersonOwnedCompaniesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type PersonOwnedCompaniesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type PersonOwnedCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonOwnedCompaniesConnectionSort>>;
  where?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
};


export type PersonPositionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type PersonPositionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type PersonPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonPositionsConnectionSort>>;
  where?: InputMaybe<PersonPositionsConnectionWhere>;
};

export type PersonAggregateSelection = {
  __typename?: 'PersonAggregateSelection';
  company_links: IntAggregateSelection;
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  person_hash: IdAggregateSelection;
};

export type PersonCompanyManagedCompaniesAggregationSelection = {
  __typename?: 'PersonCompanyManagedCompaniesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PersonCompanyManagedCompaniesEdgeAggregateSelection>;
  node?: Maybe<PersonCompanyManagedCompaniesNodeAggregateSelection>;
};

export type PersonCompanyManagedCompaniesEdgeAggregateSelection = {
  __typename?: 'PersonCompanyManagedCompaniesEdgeAggregateSelection';
  role: StringAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type PersonCompanyManagedCompaniesNodeAggregateSelection = {
  __typename?: 'PersonCompanyManagedCompaniesNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type PersonCompanyOwnedCompaniesAggregationSelection = {
  __typename?: 'PersonCompanyOwnedCompaniesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PersonCompanyOwnedCompaniesEdgeAggregateSelection>;
  node?: Maybe<PersonCompanyOwnedCompaniesNodeAggregateSelection>;
};

export type PersonCompanyOwnedCompaniesEdgeAggregateSelection = {
  __typename?: 'PersonCompanyOwnedCompaniesEdgeAggregateSelection';
  share_amount: FloatAggregateSelection;
  share_currency: StringAggregateSelection;
  share_percent: FloatAggregateSelection;
  valid_from: StringAggregateSelection;
  valid_to: StringAggregateSelection;
};

export type PersonCompanyOwnedCompaniesNodeAggregateSelection = {
  __typename?: 'PersonCompanyOwnedCompaniesNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type PersonEdge = {
  __typename?: 'PersonEdge';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type PersonFilter = {
  isCouncillor?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isMayor?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isVillageMayor?: InputMaybe<Scalars['Boolean']['input']>;
  minCompanies?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PersonManagedCompaniesAggregateInput = {
  AND?: InputMaybe<Array<PersonManagedCompaniesAggregateInput>>;
  NOT?: InputMaybe<PersonManagedCompaniesAggregateInput>;
  OR?: InputMaybe<Array<PersonManagedCompaniesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ManagementAggregationWhereInput>;
  node?: InputMaybe<PersonManagedCompaniesNodeAggregationWhereInput>;
};

export type PersonManagedCompaniesConnection = {
  __typename?: 'PersonManagedCompaniesConnection';
  edges: Array<PersonManagedCompaniesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonManagedCompaniesConnectionSort = {
  edge?: InputMaybe<ManagementSort>;
  node?: InputMaybe<CompanySort>;
};

export type PersonManagedCompaniesConnectionWhere = {
  AND?: InputMaybe<Array<PersonManagedCompaniesConnectionWhere>>;
  NOT?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  OR?: InputMaybe<Array<PersonManagedCompaniesConnectionWhere>>;
  edge?: InputMaybe<ManagementWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ManagementWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type PersonManagedCompaniesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonManagedCompaniesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonManagedCompaniesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonManagedCompaniesNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type PersonManagedCompaniesRelationship = {
  __typename?: 'PersonManagedCompaniesRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Management;
};

export type PersonMayorOfAggregateInput = {
  AND?: InputMaybe<Array<PersonMayorOfAggregateInput>>;
  NOT?: InputMaybe<PersonMayorOfAggregateInput>;
  OR?: InputMaybe<Array<PersonMayorOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<MandateAggregationWhereInput>;
  node?: InputMaybe<PersonMayorOfNodeAggregationWhereInput>;
};

export type PersonMayorOfConnection = {
  __typename?: 'PersonMayorOfConnection';
  edges: Array<PersonMayorOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonMayorOfConnectionSort = {
  edge?: InputMaybe<MandateSort>;
  node?: InputMaybe<MunicipalitySort>;
};

export type PersonMayorOfConnectionWhere = {
  AND?: InputMaybe<Array<PersonMayorOfConnectionWhere>>;
  NOT?: InputMaybe<PersonMayorOfConnectionWhere>;
  OR?: InputMaybe<Array<PersonMayorOfConnectionWhere>>;
  edge?: InputMaybe<MandateWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<MandateWhere>;
  node?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MunicipalityWhere>;
};

export type PersonMayorOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonMayorOfNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonMayorOfNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonMayorOfNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  spend_per_capita_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PersonMayorOfRelationship = {
  __typename?: 'PersonMayorOfRelationship';
  cursor: Scalars['String']['output'];
  node: Municipality;
  properties: Mandate;
};

export type PersonMunicipalityMayorOfAggregationSelection = {
  __typename?: 'PersonMunicipalityMayorOfAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PersonMunicipalityMayorOfEdgeAggregateSelection>;
  node?: Maybe<PersonMunicipalityMayorOfNodeAggregateSelection>;
};

export type PersonMunicipalityMayorOfEdgeAggregateSelection = {
  __typename?: 'PersonMunicipalityMayorOfEdgeAggregateSelection';
  elected_round: IntAggregateSelection;
  elected_year: IntAggregateSelection;
  term_end: IntAggregateSelection;
};

export type PersonMunicipalityMayorOfNodeAggregateSelection = {
  __typename?: 'PersonMunicipalityMayorOfNodeAggregateSelection';
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type PersonMunicipalityPositionsAggregationSelection = {
  __typename?: 'PersonMunicipalityPositionsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PersonMunicipalityPositionsEdgeAggregateSelection>;
  node?: Maybe<PersonMunicipalityPositionsNodeAggregateSelection>;
};

export type PersonMunicipalityPositionsEdgeAggregateSelection = {
  __typename?: 'PersonMunicipalityPositionsEdgeAggregateSelection';
  area: StringAggregateSelection;
  area_code: StringAggregateSelection;
  elected_round: IntAggregateSelection;
  elected_year: IntAggregateSelection;
  list_letter: StringAggregateSelection;
  preferences: IntAggregateSelection;
  replaces: StringAggregateSelection;
  replaces_office: StringAggregateSelection;
  role: StringAggregateSelection;
  term_end: IntAggregateSelection;
  term_start: StringAggregateSelection;
};

export type PersonMunicipalityPositionsNodeAggregateSelection = {
  __typename?: 'PersonMunicipalityPositionsNodeAggregateSelection';
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type PersonNetwork = {
  __typename?: 'PersonNetwork';
  eligible: Scalars['Int']['output'];
  links: Array<NetworkLink>;
  minFirms: Scalars['Int']['output'];
  minShared: Scalars['Int']['output'];
  people: Array<NetworkPerson>;
};

export type PersonNetworkAggregateSelection = {
  __typename?: 'PersonNetworkAggregateSelection';
  count: Scalars['Int']['output'];
  eligible: IntAggregateSelection;
  minFirms: IntAggregateSelection;
  minShared: IntAggregateSelection;
};

export type PersonNetworkEdge = {
  __typename?: 'PersonNetworkEdge';
  cursor: Scalars['String']['output'];
  node: PersonNetwork;
};

export type PersonNetworkOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PersonNetworkSort objects to sort PersonNetworks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PersonNetworkSort>>;
};

/** Fields to sort PersonNetworks by. The order in which sorts are applied is not guaranteed when specifying many fields in one PersonNetworkSort object. */
export type PersonNetworkSort = {
  eligible?: InputMaybe<SortDirection>;
  minFirms?: InputMaybe<SortDirection>;
  minShared?: InputMaybe<SortDirection>;
};

export type PersonNetworkWhere = {
  AND?: InputMaybe<Array<PersonNetworkWhere>>;
  NOT?: InputMaybe<PersonNetworkWhere>;
  OR?: InputMaybe<Array<PersonNetworkWhere>>;
  eligible?: InputMaybe<Scalars['Int']['input']>;
  eligible_GT?: InputMaybe<Scalars['Int']['input']>;
  eligible_GTE?: InputMaybe<Scalars['Int']['input']>;
  eligible_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  eligible_LT?: InputMaybe<Scalars['Int']['input']>;
  eligible_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  eligible_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  eligible_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  minFirms?: InputMaybe<Scalars['Int']['input']>;
  minFirms_GT?: InputMaybe<Scalars['Int']['input']>;
  minFirms_GTE?: InputMaybe<Scalars['Int']['input']>;
  minFirms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  minFirms_LT?: InputMaybe<Scalars['Int']['input']>;
  minFirms_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minFirms_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minFirms_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  minShared?: InputMaybe<Scalars['Int']['input']>;
  minShared_GT?: InputMaybe<Scalars['Int']['input']>;
  minShared_GTE?: InputMaybe<Scalars['Int']['input']>;
  minShared_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  minShared_LT?: InputMaybe<Scalars['Int']['input']>;
  minShared_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minShared_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minShared_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PersonNetworksConnection = {
  __typename?: 'PersonNetworksConnection';
  edges: Array<PersonNetworkEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonNominatedByAggregateInput = {
  AND?: InputMaybe<Array<PersonNominatedByAggregateInput>>;
  NOT?: InputMaybe<PersonNominatedByAggregateInput>;
  OR?: InputMaybe<Array<PersonNominatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<NominationAggregationWhereInput>;
  node?: InputMaybe<PersonNominatedByNodeAggregationWhereInput>;
};

export type PersonNominatedByConnection = {
  __typename?: 'PersonNominatedByConnection';
  edges: Array<PersonNominatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonNominatedByConnectionSort = {
  edge?: InputMaybe<NominationSort>;
  node?: InputMaybe<PartySort>;
};

export type PersonNominatedByConnectionWhere = {
  AND?: InputMaybe<Array<PersonNominatedByConnectionWhere>>;
  NOT?: InputMaybe<PersonNominatedByConnectionWhere>;
  OR?: InputMaybe<Array<PersonNominatedByConnectionWhere>>;
  edge?: InputMaybe<NominationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NominationWhere>;
  node?: InputMaybe<PartyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PartyWhere>;
};

export type PersonNominatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonNominatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonNominatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonNominatedByNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_key_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_key_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  family_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  family_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  family_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  family_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonNominatedByRelationship = {
  __typename?: 'PersonNominatedByRelationship';
  cursor: Scalars['String']['output'];
  node: Party;
  properties: Nomination;
};

export type PersonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PersonSort objects to sort People by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PersonSort>>;
};

export type PersonOwnedCompaniesAggregateInput = {
  AND?: InputMaybe<Array<PersonOwnedCompaniesAggregateInput>>;
  NOT?: InputMaybe<PersonOwnedCompaniesAggregateInput>;
  OR?: InputMaybe<Array<PersonOwnedCompaniesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OwnershipAggregationWhereInput>;
  node?: InputMaybe<PersonOwnedCompaniesNodeAggregationWhereInput>;
};

export type PersonOwnedCompaniesConnection = {
  __typename?: 'PersonOwnedCompaniesConnection';
  edges: Array<PersonOwnedCompaniesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonOwnedCompaniesConnectionSort = {
  edge?: InputMaybe<OwnershipSort>;
  node?: InputMaybe<CompanySort>;
};

export type PersonOwnedCompaniesConnectionWhere = {
  AND?: InputMaybe<Array<PersonOwnedCompaniesConnectionWhere>>;
  NOT?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  OR?: InputMaybe<Array<PersonOwnedCompaniesConnectionWhere>>;
  edge?: InputMaybe<OwnershipWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OwnershipWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type PersonOwnedCompaniesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonOwnedCompaniesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonOwnedCompaniesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonOwnedCompaniesNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type PersonOwnedCompaniesRelationship = {
  __typename?: 'PersonOwnedCompaniesRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Ownership;
};

export type PersonPartyNominatedByAggregationSelection = {
  __typename?: 'PersonPartyNominatedByAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PersonPartyNominatedByEdgeAggregateSelection>;
  node?: Maybe<PersonPartyNominatedByNodeAggregateSelection>;
};

export type PersonPartyNominatedByEdgeAggregateSelection = {
  __typename?: 'PersonPartyNominatedByEdgeAggregateSelection';
  election_year: IntAggregateSelection;
};

export type PersonPartyNominatedByNodeAggregateSelection = {
  __typename?: 'PersonPartyNominatedByNodeAggregateSelection';
  family_key: StringAggregateSelection;
  family_name: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
};

export type PersonPositionsAggregateInput = {
  AND?: InputMaybe<Array<PersonPositionsAggregateInput>>;
  NOT?: InputMaybe<PersonPositionsAggregateInput>;
  OR?: InputMaybe<Array<PersonPositionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<PositionAggregationWhereInput>;
  node?: InputMaybe<PersonPositionsNodeAggregationWhereInput>;
};

export type PersonPositionsConnection = {
  __typename?: 'PersonPositionsConnection';
  edges: Array<PersonPositionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonPositionsConnectionSort = {
  edge?: InputMaybe<PositionSort>;
  node?: InputMaybe<MunicipalitySort>;
};

export type PersonPositionsConnectionWhere = {
  AND?: InputMaybe<Array<PersonPositionsConnectionWhere>>;
  NOT?: InputMaybe<PersonPositionsConnectionWhere>;
  OR?: InputMaybe<Array<PersonPositionsConnectionWhere>>;
  edge?: InputMaybe<PositionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PositionWhere>;
  node?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MunicipalityWhere>;
};

export type PersonPositionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonPositionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonPositionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonPositionsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  spend_per_capita_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PersonPositionsRelationship = {
  __typename?: 'PersonPositionsRelationship';
  cursor: Scalars['String']['output'];
  node: Municipality;
  properties: Position;
};

/** Fields to sort People by. The order in which sorts are applied is not guaranteed when specifying many fields in one PersonSort object. */
export type PersonSort = {
  company_links?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  person_hash?: InputMaybe<SortDirection>;
};

export type PersonWhere = {
  AND?: InputMaybe<Array<PersonWhere>>;
  NOT?: InputMaybe<PersonWhere>;
  OR?: InputMaybe<Array<PersonWhere>>;
  company_links?: InputMaybe<Scalars['Int']['input']>;
  company_links_GT?: InputMaybe<Scalars['Int']['input']>;
  company_links_GTE?: InputMaybe<Scalars['Int']['input']>;
  company_links_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  company_links_LT?: InputMaybe<Scalars['Int']['input']>;
  company_links_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  company_links_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  company_links_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `managedCompanies_SOME` instead. */
  managedCompanies?: InputMaybe<CompanyWhere>;
  managedCompaniesAggregate?: InputMaybe<PersonManagedCompaniesAggregateInput>;
  /** @deprecated Use `managedCompaniesConnection_SOME` instead. */
  managedCompaniesConnection?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** Return People where all of the related PersonManagedCompaniesConnections match this filter */
  managedCompaniesConnection_ALL?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** Return People where none of the related PersonManagedCompaniesConnections match this filter */
  managedCompaniesConnection_NONE?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** @deprecated Use `managedCompaniesConnection_NONE` instead. */
  managedCompaniesConnection_NOT?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** Return People where one of the related PersonManagedCompaniesConnections match this filter */
  managedCompaniesConnection_SINGLE?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** Return People where some of the related PersonManagedCompaniesConnections match this filter */
  managedCompaniesConnection_SOME?: InputMaybe<PersonManagedCompaniesConnectionWhere>;
  /** Return People where all of the related Companies match this filter */
  managedCompanies_ALL?: InputMaybe<CompanyWhere>;
  /** Return People where none of the related Companies match this filter */
  managedCompanies_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `managedCompanies_NONE` instead. */
  managedCompanies_NOT?: InputMaybe<CompanyWhere>;
  /** Return People where one of the related Companies match this filter */
  managedCompanies_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return People where some of the related Companies match this filter */
  managedCompanies_SOME?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `mayorOf_SOME` instead. */
  mayorOf?: InputMaybe<MunicipalityWhere>;
  mayorOfAggregate?: InputMaybe<PersonMayorOfAggregateInput>;
  /** @deprecated Use `mayorOfConnection_SOME` instead. */
  mayorOfConnection?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** Return People where all of the related PersonMayorOfConnections match this filter */
  mayorOfConnection_ALL?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** Return People where none of the related PersonMayorOfConnections match this filter */
  mayorOfConnection_NONE?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** @deprecated Use `mayorOfConnection_NONE` instead. */
  mayorOfConnection_NOT?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** Return People where one of the related PersonMayorOfConnections match this filter */
  mayorOfConnection_SINGLE?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** Return People where some of the related PersonMayorOfConnections match this filter */
  mayorOfConnection_SOME?: InputMaybe<PersonMayorOfConnectionWhere>;
  /** Return People where all of the related Municipalities match this filter */
  mayorOf_ALL?: InputMaybe<MunicipalityWhere>;
  /** Return People where none of the related Municipalities match this filter */
  mayorOf_NONE?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `mayorOf_NONE` instead. */
  mayorOf_NOT?: InputMaybe<MunicipalityWhere>;
  /** Return People where one of the related Municipalities match this filter */
  mayorOf_SINGLE?: InputMaybe<MunicipalityWhere>;
  /** Return People where some of the related Municipalities match this filter */
  mayorOf_SOME?: InputMaybe<MunicipalityWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `nominatedBy_SOME` instead. */
  nominatedBy?: InputMaybe<PartyWhere>;
  nominatedByAggregate?: InputMaybe<PersonNominatedByAggregateInput>;
  /** @deprecated Use `nominatedByConnection_SOME` instead. */
  nominatedByConnection?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** Return People where all of the related PersonNominatedByConnections match this filter */
  nominatedByConnection_ALL?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** Return People where none of the related PersonNominatedByConnections match this filter */
  nominatedByConnection_NONE?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** @deprecated Use `nominatedByConnection_NONE` instead. */
  nominatedByConnection_NOT?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** Return People where one of the related PersonNominatedByConnections match this filter */
  nominatedByConnection_SINGLE?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** Return People where some of the related PersonNominatedByConnections match this filter */
  nominatedByConnection_SOME?: InputMaybe<PersonNominatedByConnectionWhere>;
  /** Return People where all of the related Parties match this filter */
  nominatedBy_ALL?: InputMaybe<PartyWhere>;
  /** Return People where none of the related Parties match this filter */
  nominatedBy_NONE?: InputMaybe<PartyWhere>;
  /** @deprecated Use `nominatedBy_NONE` instead. */
  nominatedBy_NOT?: InputMaybe<PartyWhere>;
  /** Return People where one of the related Parties match this filter */
  nominatedBy_SINGLE?: InputMaybe<PartyWhere>;
  /** Return People where some of the related Parties match this filter */
  nominatedBy_SOME?: InputMaybe<PartyWhere>;
  /** @deprecated Use `ownedCompanies_SOME` instead. */
  ownedCompanies?: InputMaybe<CompanyWhere>;
  ownedCompaniesAggregate?: InputMaybe<PersonOwnedCompaniesAggregateInput>;
  /** @deprecated Use `ownedCompaniesConnection_SOME` instead. */
  ownedCompaniesConnection?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** Return People where all of the related PersonOwnedCompaniesConnections match this filter */
  ownedCompaniesConnection_ALL?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** Return People where none of the related PersonOwnedCompaniesConnections match this filter */
  ownedCompaniesConnection_NONE?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** @deprecated Use `ownedCompaniesConnection_NONE` instead. */
  ownedCompaniesConnection_NOT?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** Return People where one of the related PersonOwnedCompaniesConnections match this filter */
  ownedCompaniesConnection_SINGLE?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** Return People where some of the related PersonOwnedCompaniesConnections match this filter */
  ownedCompaniesConnection_SOME?: InputMaybe<PersonOwnedCompaniesConnectionWhere>;
  /** Return People where all of the related Companies match this filter */
  ownedCompanies_ALL?: InputMaybe<CompanyWhere>;
  /** Return People where none of the related Companies match this filter */
  ownedCompanies_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `ownedCompanies_NONE` instead. */
  ownedCompanies_NOT?: InputMaybe<CompanyWhere>;
  /** Return People where one of the related Companies match this filter */
  ownedCompanies_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return People where some of the related Companies match this filter */
  ownedCompanies_SOME?: InputMaybe<CompanyWhere>;
  person_hash?: InputMaybe<Scalars['ID']['input']>;
  person_hash_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  person_hash_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  person_hash_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  person_hash_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  person_hash_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `positions_SOME` instead. */
  positions?: InputMaybe<MunicipalityWhere>;
  positionsAggregate?: InputMaybe<PersonPositionsAggregateInput>;
  /** @deprecated Use `positionsConnection_SOME` instead. */
  positionsConnection?: InputMaybe<PersonPositionsConnectionWhere>;
  /** Return People where all of the related PersonPositionsConnections match this filter */
  positionsConnection_ALL?: InputMaybe<PersonPositionsConnectionWhere>;
  /** Return People where none of the related PersonPositionsConnections match this filter */
  positionsConnection_NONE?: InputMaybe<PersonPositionsConnectionWhere>;
  /** @deprecated Use `positionsConnection_NONE` instead. */
  positionsConnection_NOT?: InputMaybe<PersonPositionsConnectionWhere>;
  /** Return People where one of the related PersonPositionsConnections match this filter */
  positionsConnection_SINGLE?: InputMaybe<PersonPositionsConnectionWhere>;
  /** Return People where some of the related PersonPositionsConnections match this filter */
  positionsConnection_SOME?: InputMaybe<PersonPositionsConnectionWhere>;
  /** Return People where all of the related Municipalities match this filter */
  positions_ALL?: InputMaybe<MunicipalityWhere>;
  /** Return People where none of the related Municipalities match this filter */
  positions_NONE?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `positions_NONE` instead. */
  positions_NOT?: InputMaybe<MunicipalityWhere>;
  /** Return People where one of the related Municipalities match this filter */
  positions_SINGLE?: InputMaybe<MunicipalityWhere>;
  /** Return People where some of the related Municipalities match this filter */
  positions_SOME?: InputMaybe<MunicipalityWhere>;
};

/**
 * The edge properties for the following fields:
 * * Person.positions
 * * Municipality.officeHolders
 */
export type Position = {
  __typename?: 'Position';
  area?: Maybe<Scalars['String']['output']>;
  area_code?: Maybe<Scalars['String']['output']>;
  elected_round?: Maybe<Scalars['Int']['output']>;
  elected_year?: Maybe<Scalars['Int']['output']>;
  list_letter?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['Int']['output']>;
  replaces?: Maybe<Scalars['String']['output']>;
  replaces_office?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  term_end?: Maybe<Scalars['Int']['output']>;
  term_start?: Maybe<Scalars['String']['output']>;
};

export type PositionAggregationWhereInput = {
  AND?: InputMaybe<Array<PositionAggregationWhereInput>>;
  NOT?: InputMaybe<PositionAggregationWhereInput>;
  OR?: InputMaybe<Array<PositionAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  area_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  area_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  area_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  area_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  area_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  area_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  area_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  area_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  area_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  area_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  area_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  area_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  area_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  area_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  area_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  area_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  area_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  area_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  area_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  area_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  area_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  area_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  area_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  area_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  area_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  elected_round_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_round_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  elected_year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  elected_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  list_letter_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  list_letter_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  list_letter_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  list_letter_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  list_letter_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  list_letter_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  list_letter_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  list_letter_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  list_letter_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  list_letter_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  list_letter_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  list_letter_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  list_letter_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  list_letter_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  list_letter_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  list_letter_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  list_letter_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  list_letter_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  list_letter_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  list_letter_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  list_letter_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferences_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  preferences_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferences_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  preferences_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  preferences_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  preferences_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  preferences_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  preferences_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  preferences_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferences_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  preferences_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  preferences_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferences_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  preferences_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  preferences_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferences_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  preferences_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  preferences_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  replaces_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  replaces_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  replaces_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  replaces_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  replaces_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  replaces_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  replaces_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  replaces_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  replaces_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  replaces_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  replaces_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  replaces_office_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  replaces_office_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  replaces_office_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  replaces_office_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  replaces_office_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_office_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_office_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_office_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_office_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  replaces_office_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  replaces_office_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  replaces_office_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  role_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  role_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  term_end_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_end_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  term_start_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  term_start_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  term_start_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  term_start_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  term_start_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_start_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_start_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_start_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_start_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_start_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  term_start_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_start_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  term_start_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_start_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  term_start_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_start_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  term_start_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  term_start_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_start_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  term_start_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  term_start_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionSort = {
  area?: InputMaybe<SortDirection>;
  area_code?: InputMaybe<SortDirection>;
  elected_round?: InputMaybe<SortDirection>;
  elected_year?: InputMaybe<SortDirection>;
  list_letter?: InputMaybe<SortDirection>;
  preferences?: InputMaybe<SortDirection>;
  replaces?: InputMaybe<SortDirection>;
  replaces_office?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  term_end?: InputMaybe<SortDirection>;
  term_start?: InputMaybe<SortDirection>;
};

export type PositionWhere = {
  AND?: InputMaybe<Array<PositionWhere>>;
  NOT?: InputMaybe<PositionWhere>;
  OR?: InputMaybe<Array<PositionWhere>>;
  area?: InputMaybe<Scalars['String']['input']>;
  area_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  area_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  area_GT?: InputMaybe<Scalars['String']['input']>;
  area_GTE?: InputMaybe<Scalars['String']['input']>;
  area_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  area_LT?: InputMaybe<Scalars['String']['input']>;
  area_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  area_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  area_code?: InputMaybe<Scalars['String']['input']>;
  area_code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  area_code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  area_code_GT?: InputMaybe<Scalars['String']['input']>;
  area_code_GTE?: InputMaybe<Scalars['String']['input']>;
  area_code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  area_code_LT?: InputMaybe<Scalars['String']['input']>;
  area_code_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_code_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_code_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_code_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  area_code_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  area_code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  elected_round?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_round_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_round_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_round_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_round_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_GTE?: InputMaybe<Scalars['Int']['input']>;
  elected_year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elected_year_LT?: InputMaybe<Scalars['Int']['input']>;
  elected_year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elected_year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  list_letter?: InputMaybe<Scalars['String']['input']>;
  list_letter_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  list_letter_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  list_letter_GT?: InputMaybe<Scalars['String']['input']>;
  list_letter_GTE?: InputMaybe<Scalars['String']['input']>;
  list_letter_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_letter_LT?: InputMaybe<Scalars['String']['input']>;
  list_letter_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  list_letter_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  list_letter_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  list_letter_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  list_letter_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  list_letter_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  list_letter_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['Int']['input']>;
  preferences_GT?: InputMaybe<Scalars['Int']['input']>;
  preferences_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferences_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  preferences_LT?: InputMaybe<Scalars['Int']['input']>;
  preferences_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferences_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferences_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  replaces?: InputMaybe<Scalars['String']['input']>;
  replaces_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  replaces_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces_GT?: InputMaybe<Scalars['String']['input']>;
  replaces_GTE?: InputMaybe<Scalars['String']['input']>;
  replaces_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replaces_LT?: InputMaybe<Scalars['String']['input']>;
  replaces_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces_office?: InputMaybe<Scalars['String']['input']>;
  replaces_office_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  replaces_office_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces_office_GT?: InputMaybe<Scalars['String']['input']>;
  replaces_office_GTE?: InputMaybe<Scalars['String']['input']>;
  replaces_office_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replaces_office_LT?: InputMaybe<Scalars['String']['input']>;
  replaces_office_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_office_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_office_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_office_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_office_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  replaces_office_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces_office_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_GT?: InputMaybe<Scalars['String']['input']>;
  role_GTE?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_LT?: InputMaybe<Scalars['String']['input']>;
  role_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  role_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  term_end?: InputMaybe<Scalars['Int']['input']>;
  term_end_GT?: InputMaybe<Scalars['Int']['input']>;
  term_end_GTE?: InputMaybe<Scalars['Int']['input']>;
  term_end_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  term_end_LT?: InputMaybe<Scalars['Int']['input']>;
  term_end_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_end_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  term_start?: InputMaybe<Scalars['String']['input']>;
  term_start_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  term_start_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  term_start_GT?: InputMaybe<Scalars['String']['input']>;
  term_start_GTE?: InputMaybe<Scalars['String']['input']>;
  term_start_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  term_start_LT?: InputMaybe<Scalars['String']['input']>;
  term_start_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_start_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_start_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_start_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_start_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  term_start_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  term_start_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activityBlocks: Array<ActivityBlock>;
  activityBlocksAggregate: ActivityBlockAggregateSelection;
  activityBlocksConnection: ActivityBlocksConnection;
  activityMap?: Maybe<ActivityMap>;
  activityMaps: Array<ActivityMap>;
  activityMapsAggregate: ActivityMapAggregateSelection;
  activityMapsConnection: ActivityMapsConnection;
  activityPartners: Array<ActivityPartner>;
  activityPartnersAggregate: ActivityPartnerAggregateSelection;
  activityPartnersConnection: ActivityPartnersConnection;
  buyerProvinces: Array<FacetValue>;
  companies: Array<Company>;
  companiesAggregate: CompanyAggregateSelection;
  companiesConnection: CompaniesConnection;
  companyCouncillorMatches: Array<CompanyCouncillorMatch>;
  companyCouncillorMatchesAggregate: CompanyCouncillorMatchAggregateSelection;
  companyCouncillorMatchesConnection: CompanyCouncillorMatchesConnection;
  companyFacets: Array<FacetGroup>;
  companyFamilyTies: Array<CompanyCouncillorMatch>;
  companyLegalForms: Array<FacetValue>;
  companyStats: Array<CompanyStat>;
  companyStatsAggregate: CompanyStatAggregateSelection;
  companyStatsConnection: CompanyStatsConnection;
  consortiums: Array<Consortium>;
  consortiumsAggregate: ConsortiumAggregateSelection;
  consortiumsConnection: ConsortiumsConnection;
  councilInterestLeads: Array<CouncilInterestLead>;
  councilInterestLeadsAggregate: CouncilInterestLeadAggregateSelection;
  councilInterestLeadsConnection: CouncilInterestLeadsConnection;
  dataIssueCounts: Array<FacetValue>;
  dataIssues: Array<DataIssue>;
  dataIssuesAggregate: DataIssueAggregateSelection;
  dataIssuesConnection: DataIssuesConnection;
  electionYears: Array<Scalars['Int']['output']>;
  facetGroups: Array<FacetGroup>;
  facetGroupsAggregate: FacetGroupAggregateSelection;
  facetGroupsConnection: FacetGroupsConnection;
  facetValues: Array<FacetValue>;
  facetValuesAggregate: FacetValueAggregateSelection;
  facetValuesConnection: FacetValuesConnection;
  governments: Array<Government>;
  governmentsAggregate: GovernmentAggregateSelection;
  governmentsConnection: GovernmentsConnection;
  lots: Array<Lot>;
  lotsAggregate: LotAggregateSelection;
  lotsConnection: LotsConnection;
  ministerTerms: Array<MinisterTerm>;
  ministerTermsAggregate: MinisterTermAggregateSelection;
  ministerTermsConnection: MinisterTermsConnection;
  ministries: Array<Ministry>;
  ministriesAggregate: MinistryAggregateSelection;
  ministriesConnection: MinistriesConnection;
  ministryUnits: Array<MinistryUnit>;
  ministryUnitsAggregate: MinistryUnitAggregateSelection;
  ministryUnitsConnection: MinistryUnitsConnection;
  municipalities: Array<Municipality>;
  municipalitiesAggregate: MunicipalityAggregateSelection;
  municipalitiesConnection: MunicipalitiesConnection;
  municipalityFacets: Array<FacetGroup>;
  municipalityProcurement: Array<MunicipalityStat>;
  municipalityStats: Array<MunicipalityStat>;
  municipalityStatsAggregate: MunicipalityStatAggregateSelection;
  municipalityStatsConnection: MunicipalityStatsConnection;
  networkLinks: Array<NetworkLink>;
  networkLinksAggregate: NetworkLinkAggregateSelection;
  networkLinksConnection: NetworkLinksConnection;
  networkPeople: Array<NetworkPerson>;
  networkPeopleAggregate: NetworkPersonAggregateSelection;
  networkPeopleConnection: NetworkPeopleConnection;
  parties: Array<Party>;
  partiesAggregate: PartyAggregateSelection;
  partiesConnection: PartiesConnection;
  partyCouncils: Array<PartyCouncil>;
  partyCouncilsAggregate: PartyCouncilAggregateSelection;
  partyCouncilsConnection: PartyCouncilsConnection;
  partyFamilies: Array<PartyFamily>;
  partyFamiliesAggregate: PartyFamilyAggregateSelection;
  partyFamiliesConnection: PartyFamiliesConnection;
  partyMayors: Array<PartyMayor>;
  partyMayorsAggregate: PartyMayorAggregateSelection;
  partyMayorsConnection: PartyMayorsConnection;
  partyProcurement?: Maybe<CompanyStat>;
  partyStatCounts: Array<FacetValue>;
  partyStats: Array<PartyStat>;
  partyStatsAggregate: PartyStatAggregateSelection;
  partyStatsConnection: PartyStatsConnection;
  partySuppliers: Array<PartySupplier>;
  partySuppliersAggregate: PartySupplierAggregateSelection;
  partySuppliersConnection: PartySuppliersConnection;
  people: Array<Person>;
  peopleAggregate: PersonAggregateSelection;
  peopleConnection: PeopleConnection;
  personFacets: Array<FacetGroup>;
  personNetwork?: Maybe<PersonNetwork>;
  personNetworks: Array<PersonNetwork>;
  personNetworksAggregate: PersonNetworkAggregateSelection;
  personNetworksConnection: PersonNetworksConnection;
  provinces: Array<FacetValue>;
  registerCoverage: RegisterCoverage;
  registerCoverages: Array<RegisterCoverage>;
  registerCoveragesAggregate: RegisterCoverageAggregateSelection;
  registerCoveragesConnection: RegisterCoveragesConnection;
  riskOverlap: Array<CompanyStat>;
  signalLeadCount: Scalars['Int']['output'];
  signalLeads: Array<SignalLead>;
  signalLeadsAggregate: SignalLeadAggregateSelection;
  signalLeadsConnection: SignalLeadsConnection;
  signalSummary: Array<FacetValue>;
  signalYears: Array<Scalars['Int']['output']>;
  signalsComputedAt?: Maybe<Scalars['String']['output']>;
  subsidies: Array<Subsidy>;
  subsidiesAggregate: SubsidyAggregateSelection;
  subsidiesConnection: SubsidiesConnection;
  subsidyFacets: Array<FacetGroup>;
  subsidyYears: Array<FacetValue>;
  taxDebtRecords: Array<TaxDebtRecord>;
  taxDebtRecordsAggregate: TaxDebtRecordAggregateSelection;
  taxDebtRecordsConnection: TaxDebtRecordsConnection;
  tenderCpvDivisions: Array<FacetValue>;
  tenderFacets: Array<FacetGroup>;
  tenderYears: Array<FacetValue>;
  tenders: Array<Tender>;
  tendersAggregate: TenderAggregateSelection;
  tendersConnection: TendersConnection;
  topSubsidyRecipients: Array<CompanyStat>;
  topTenderWinners: Array<CompanyStat>;
  treasuryPayments: Array<TreasuryPayment>;
  treasuryPaymentsAggregate: TreasuryPaymentAggregateSelection;
  treasuryPaymentsConnection: TreasuryPaymentsConnection;
  valueObservationCounts: Array<FacetValue>;
  valueObservations: Array<ValueObservation>;
  valueObservationsAggregate: ValueObservationAggregateSelection;
  valueObservationsConnection: ValueObservationsConnection;
};


export type QueryActivityBlocksArgs = {
  options?: InputMaybe<ActivityBlockOptions>;
  where?: InputMaybe<ActivityBlockWhere>;
};


export type QueryActivityBlocksAggregateArgs = {
  where?: InputMaybe<ActivityBlockWhere>;
};


export type QueryActivityBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ActivityBlockSort>>>;
  where?: InputMaybe<ActivityBlockWhere>;
};


export type QueryActivityMapArgs = {
  company?: InputMaybe<Scalars['ID']['input']>;
  companyLimit?: InputMaybe<Scalars['Int']['input']>;
  minMunicipalities?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['ID']['input']>;
  partnersPerCompany?: InputMaybe<Scalars['Int']['input']>;
  perCompany?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActivityMapsArgs = {
  options?: InputMaybe<ActivityMapOptions>;
  where?: InputMaybe<ActivityMapWhere>;
};


export type QueryActivityMapsAggregateArgs = {
  where?: InputMaybe<ActivityMapWhere>;
};


export type QueryActivityMapsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ActivityMapSort>>>;
  where?: InputMaybe<ActivityMapWhere>;
};


export type QueryActivityPartnersArgs = {
  options?: InputMaybe<ActivityPartnerOptions>;
  where?: InputMaybe<ActivityPartnerWhere>;
};


export type QueryActivityPartnersAggregateArgs = {
  where?: InputMaybe<ActivityPartnerWhere>;
};


export type QueryActivityPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ActivityPartnerSort>>>;
  where?: InputMaybe<ActivityPartnerWhere>;
};


export type QueryCompaniesArgs = {
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompaniesAggregateArgs = {
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanySort>>>;
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompanyCouncillorMatchesArgs = {
  uic: Scalars['ID']['input'];
};


export type QueryCompanyCouncillorMatchesAggregateArgs = {
  where?: InputMaybe<CompanyCouncillorMatchWhere>;
};


export type QueryCompanyCouncillorMatchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanyCouncillorMatchSort>>>;
  where?: InputMaybe<CompanyCouncillorMatchWhere>;
};


export type QueryCompanyFacetsArgs = {
  filter?: InputMaybe<CompanyFilter>;
};


export type QueryCompanyFamilyTiesArgs = {
  uic: Scalars['ID']['input'];
};


export type QueryCompanyLegalFormsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyStatsArgs = {
  options?: InputMaybe<CompanyStatOptions>;
  where?: InputMaybe<CompanyStatWhere>;
};


export type QueryCompanyStatsAggregateArgs = {
  where?: InputMaybe<CompanyStatWhere>;
};


export type QueryCompanyStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanyStatSort>>>;
  where?: InputMaybe<CompanyStatWhere>;
};


export type QueryConsortiumsArgs = {
  options?: InputMaybe<ConsortiumOptions>;
  where?: InputMaybe<ConsortiumWhere>;
};


export type QueryConsortiumsAggregateArgs = {
  where?: InputMaybe<ConsortiumWhere>;
};


export type QueryConsortiumsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ConsortiumSort>>>;
  where?: InputMaybe<ConsortiumWhere>;
};


export type QueryCouncilInterestLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCouncilInterestLeadsAggregateArgs = {
  where?: InputMaybe<CouncilInterestLeadWhere>;
};


export type QueryCouncilInterestLeadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CouncilInterestLeadSort>>>;
  where?: InputMaybe<CouncilInterestLeadWhere>;
};


export type QueryDataIssuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataIssuesAggregateArgs = {
  where?: InputMaybe<DataIssueWhere>;
};


export type QueryDataIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DataIssueSort>>>;
  where?: InputMaybe<DataIssueWhere>;
};


export type QueryFacetGroupsArgs = {
  options?: InputMaybe<FacetGroupOptions>;
  where?: InputMaybe<FacetGroupWhere>;
};


export type QueryFacetGroupsAggregateArgs = {
  where?: InputMaybe<FacetGroupWhere>;
};


export type QueryFacetGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FacetGroupSort>>>;
  where?: InputMaybe<FacetGroupWhere>;
};


export type QueryFacetValuesArgs = {
  options?: InputMaybe<FacetValueOptions>;
  where?: InputMaybe<FacetValueWhere>;
};


export type QueryFacetValuesAggregateArgs = {
  where?: InputMaybe<FacetValueWhere>;
};


export type QueryFacetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FacetValueSort>>>;
  where?: InputMaybe<FacetValueWhere>;
};


export type QueryGovernmentsArgs = {
  options?: InputMaybe<GovernmentOptions>;
  where?: InputMaybe<GovernmentWhere>;
};


export type QueryGovernmentsAggregateArgs = {
  where?: InputMaybe<GovernmentWhere>;
};


export type QueryGovernmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GovernmentSort>>>;
  where?: InputMaybe<GovernmentWhere>;
};


export type QueryLotsArgs = {
  options?: InputMaybe<LotOptions>;
  where?: InputMaybe<LotWhere>;
};


export type QueryLotsAggregateArgs = {
  where?: InputMaybe<LotWhere>;
};


export type QueryLotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LotSort>>>;
  where?: InputMaybe<LotWhere>;
};


export type QueryMinisterTermsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  uic?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMinisterTermsAggregateArgs = {
  where?: InputMaybe<MinisterTermWhere>;
};


export type QueryMinisterTermsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MinisterTermSort>>>;
  where?: InputMaybe<MinisterTermWhere>;
};


export type QueryMinistriesAggregateArgs = {
  where?: InputMaybe<MinistryWhere>;
};


export type QueryMinistriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MinistrySort>>>;
  where?: InputMaybe<MinistryWhere>;
};


export type QueryMinistryUnitsArgs = {
  uic: Scalars['ID']['input'];
};


export type QueryMinistryUnitsAggregateArgs = {
  where?: InputMaybe<MinistryUnitWhere>;
};


export type QueryMinistryUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MinistryUnitSort>>>;
  where?: InputMaybe<MinistryUnitWhere>;
};


export type QueryMunicipalitiesArgs = {
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type QueryMunicipalitiesAggregateArgs = {
  where?: InputMaybe<MunicipalityWhere>;
};


export type QueryMunicipalitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MunicipalitySort>>>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type QueryMunicipalityFacetsArgs = {
  filter?: InputMaybe<MunicipalityFilter>;
};


export type QueryMunicipalityProcurementArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMunicipalityStatsArgs = {
  options?: InputMaybe<MunicipalityStatOptions>;
  where?: InputMaybe<MunicipalityStatWhere>;
};


export type QueryMunicipalityStatsAggregateArgs = {
  where?: InputMaybe<MunicipalityStatWhere>;
};


export type QueryMunicipalityStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MunicipalityStatSort>>>;
  where?: InputMaybe<MunicipalityStatWhere>;
};


export type QueryNetworkLinksArgs = {
  options?: InputMaybe<NetworkLinkOptions>;
  where?: InputMaybe<NetworkLinkWhere>;
};


export type QueryNetworkLinksAggregateArgs = {
  where?: InputMaybe<NetworkLinkWhere>;
};


export type QueryNetworkLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NetworkLinkSort>>>;
  where?: InputMaybe<NetworkLinkWhere>;
};


export type QueryNetworkPeopleArgs = {
  options?: InputMaybe<NetworkPersonOptions>;
  where?: InputMaybe<NetworkPersonWhere>;
};


export type QueryNetworkPeopleAggregateArgs = {
  where?: InputMaybe<NetworkPersonWhere>;
};


export type QueryNetworkPeopleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NetworkPersonSort>>>;
  where?: InputMaybe<NetworkPersonWhere>;
};


export type QueryPartiesArgs = {
  options?: InputMaybe<PartyOptions>;
  where?: InputMaybe<PartyWhere>;
};


export type QueryPartiesAggregateArgs = {
  where?: InputMaybe<PartyWhere>;
};


export type QueryPartiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartySort>>>;
  where?: InputMaybe<PartyWhere>;
};


export type QueryPartyCouncilsArgs = {
  electionYear?: InputMaybe<Scalars['Int']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  party?: InputMaybe<Scalars['ID']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartyCouncilsAggregateArgs = {
  where?: InputMaybe<PartyCouncilWhere>;
};


export type QueryPartyCouncilsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartyCouncilSort>>>;
  where?: InputMaybe<PartyCouncilWhere>;
};


export type QueryPartyFamiliesAggregateArgs = {
  where?: InputMaybe<PartyFamilyWhere>;
};


export type QueryPartyFamiliesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartyFamilySort>>>;
  where?: InputMaybe<PartyFamilyWhere>;
};


export type QueryPartyMayorsArgs = {
  electionYear?: InputMaybe<Scalars['Int']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['ID']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartyMayorsAggregateArgs = {
  where?: InputMaybe<PartyMayorWhere>;
};


export type QueryPartyMayorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartyMayorSort>>>;
  where?: InputMaybe<PartyMayorWhere>;
};


export type QueryPartyProcurementArgs = {
  family?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['ID']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartyStatCountsArgs = {
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartyStatsArgs = {
  electionYear?: InputMaybe<Scalars['Int']['input']>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartyStatsAggregateArgs = {
  where?: InputMaybe<PartyStatWhere>;
};


export type QueryPartyStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartyStatSort>>>;
  where?: InputMaybe<PartyStatWhere>;
};


export type QueryPartySuppliersArgs = {
  family?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  party?: InputMaybe<Scalars['ID']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartySuppliersAggregateArgs = {
  where?: InputMaybe<PartySupplierWhere>;
};


export type QueryPartySuppliersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartySupplierSort>>>;
  where?: InputMaybe<PartySupplierWhere>;
};


export type QueryPeopleArgs = {
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};


export type QueryPeopleAggregateArgs = {
  where?: InputMaybe<PersonWhere>;
};


export type QueryPeopleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PersonSort>>>;
  where?: InputMaybe<PersonWhere>;
};


export type QueryPersonFacetsArgs = {
  filter?: InputMaybe<PersonFilter>;
};


export type QueryPersonNetworkArgs = {
  minFirms?: InputMaybe<Scalars['Int']['input']>;
  minShared?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonNetworksArgs = {
  options?: InputMaybe<PersonNetworkOptions>;
  where?: InputMaybe<PersonNetworkWhere>;
};


export type QueryPersonNetworksAggregateArgs = {
  where?: InputMaybe<PersonNetworkWhere>;
};


export type QueryPersonNetworksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PersonNetworkSort>>>;
  where?: InputMaybe<PersonNetworkWhere>;
};


export type QueryRegisterCoveragesArgs = {
  options?: InputMaybe<RegisterCoverageOptions>;
  where?: InputMaybe<RegisterCoverageWhere>;
};


export type QueryRegisterCoveragesAggregateArgs = {
  where?: InputMaybe<RegisterCoverageWhere>;
};


export type QueryRegisterCoveragesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RegisterCoverageSort>>>;
  where?: InputMaybe<RegisterCoverageWhere>;
};


export type QueryRiskOverlapArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignalLeadCountArgs = {
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  minFlaggedValue?: InputMaybe<Scalars['Float']['input']>;
  minShare?: InputMaybe<Scalars['Float']['input']>;
  requireMandate?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignalLeadsArgs = {
  dir?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minFlaggedValue?: InputMaybe<Scalars['Float']['input']>;
  minShare?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  requireMandate?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignalLeadsAggregateArgs = {
  where?: InputMaybe<SignalLeadWhere>;
};


export type QuerySignalLeadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SignalLeadSort>>>;
  where?: InputMaybe<SignalLeadWhere>;
};


export type QuerySubsidiesArgs = {
  options?: InputMaybe<SubsidyOptions>;
  where?: InputMaybe<SubsidyWhere>;
};


export type QuerySubsidiesAggregateArgs = {
  where?: InputMaybe<SubsidyWhere>;
};


export type QuerySubsidiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubsidySort>>>;
  where?: InputMaybe<SubsidyWhere>;
};


export type QuerySubsidyFacetsArgs = {
  filter?: InputMaybe<SubsidyFilter>;
};


export type QueryTaxDebtRecordsArgs = {
  options?: InputMaybe<TaxDebtRecordOptions>;
  where?: InputMaybe<TaxDebtRecordWhere>;
};


export type QueryTaxDebtRecordsAggregateArgs = {
  where?: InputMaybe<TaxDebtRecordWhere>;
};


export type QueryTaxDebtRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TaxDebtRecordSort>>>;
  where?: InputMaybe<TaxDebtRecordWhere>;
};


export type QueryTenderCpvDivisionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTenderFacetsArgs = {
  filter?: InputMaybe<TenderFilter>;
};


export type QueryTendersArgs = {
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type QueryTendersAggregateArgs = {
  where?: InputMaybe<TenderWhere>;
};


export type QueryTendersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TenderSort>>>;
  where?: InputMaybe<TenderWhere>;
};


export type QueryTopSubsidyRecipientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopTenderWinnersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTreasuryPaymentsArgs = {
  options?: InputMaybe<TreasuryPaymentOptions>;
  where?: InputMaybe<TreasuryPaymentWhere>;
};


export type QueryTreasuryPaymentsAggregateArgs = {
  where?: InputMaybe<TreasuryPaymentWhere>;
};


export type QueryTreasuryPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreasuryPaymentSort>>>;
  where?: InputMaybe<TreasuryPaymentWhere>;
};


export type QueryValueObservationsArgs = {
  flag?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValueObservationsAggregateArgs = {
  where?: InputMaybe<ValueObservationWhere>;
};


export type QueryValueObservationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ValueObservationSort>>>;
  where?: InputMaybe<ValueObservationWhere>;
};

export type RegisterCoverage = {
  __typename?: 'RegisterCoverage';
  beneficialOwners: Scalars['Int']['output'];
  checkedThrough?: Maybe<Scalars['String']['output']>;
  companies: Scalars['Int']['output'];
  encumbrances: Scalars['Int']['output'];
  known: Scalars['Int']['output'];
  maskedParties: Scalars['Int']['output'];
  outsideRegister: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

export type RegisterCoverageAggregateSelection = {
  __typename?: 'RegisterCoverageAggregateSelection';
  beneficialOwners: IntAggregateSelection;
  checkedThrough: StringAggregateSelection;
  companies: IntAggregateSelection;
  count: Scalars['Int']['output'];
  encumbrances: IntAggregateSelection;
  known: IntAggregateSelection;
  maskedParties: IntAggregateSelection;
  outsideRegister: IntAggregateSelection;
  pending: IntAggregateSelection;
};

export type RegisterCoverageEdge = {
  __typename?: 'RegisterCoverageEdge';
  cursor: Scalars['String']['output'];
  node: RegisterCoverage;
};

export type RegisterCoverageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RegisterCoverageSort objects to sort RegisterCoverages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RegisterCoverageSort>>;
};

/** Fields to sort RegisterCoverages by. The order in which sorts are applied is not guaranteed when specifying many fields in one RegisterCoverageSort object. */
export type RegisterCoverageSort = {
  beneficialOwners?: InputMaybe<SortDirection>;
  checkedThrough?: InputMaybe<SortDirection>;
  companies?: InputMaybe<SortDirection>;
  encumbrances?: InputMaybe<SortDirection>;
  known?: InputMaybe<SortDirection>;
  maskedParties?: InputMaybe<SortDirection>;
  outsideRegister?: InputMaybe<SortDirection>;
  pending?: InputMaybe<SortDirection>;
};

export type RegisterCoverageWhere = {
  AND?: InputMaybe<Array<RegisterCoverageWhere>>;
  NOT?: InputMaybe<RegisterCoverageWhere>;
  OR?: InputMaybe<Array<RegisterCoverageWhere>>;
  beneficialOwners?: InputMaybe<Scalars['Int']['input']>;
  beneficialOwners_GT?: InputMaybe<Scalars['Int']['input']>;
  beneficialOwners_GTE?: InputMaybe<Scalars['Int']['input']>;
  beneficialOwners_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  beneficialOwners_LT?: InputMaybe<Scalars['Int']['input']>;
  beneficialOwners_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  beneficialOwners_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  beneficialOwners_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  checkedThrough?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_GT?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_GTE?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkedThrough_LT?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  checkedThrough_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  checkedThrough_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  checkedThrough_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  checkedThrough_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  checkedThrough_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkedThrough_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Scalars['Int']['input']>;
  companies_GT?: InputMaybe<Scalars['Int']['input']>;
  companies_GTE?: InputMaybe<Scalars['Int']['input']>;
  companies_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  companies_LT?: InputMaybe<Scalars['Int']['input']>;
  companies_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  companies_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  encumbrances?: InputMaybe<Scalars['Int']['input']>;
  encumbrances_GT?: InputMaybe<Scalars['Int']['input']>;
  encumbrances_GTE?: InputMaybe<Scalars['Int']['input']>;
  encumbrances_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  encumbrances_LT?: InputMaybe<Scalars['Int']['input']>;
  encumbrances_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  encumbrances_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  encumbrances_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  known?: InputMaybe<Scalars['Int']['input']>;
  known_GT?: InputMaybe<Scalars['Int']['input']>;
  known_GTE?: InputMaybe<Scalars['Int']['input']>;
  known_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  known_LT?: InputMaybe<Scalars['Int']['input']>;
  known_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  known_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  known_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maskedParties?: InputMaybe<Scalars['Int']['input']>;
  maskedParties_GT?: InputMaybe<Scalars['Int']['input']>;
  maskedParties_GTE?: InputMaybe<Scalars['Int']['input']>;
  maskedParties_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maskedParties_LT?: InputMaybe<Scalars['Int']['input']>;
  maskedParties_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maskedParties_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maskedParties_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  outsideRegister?: InputMaybe<Scalars['Int']['input']>;
  outsideRegister_GT?: InputMaybe<Scalars['Int']['input']>;
  outsideRegister_GTE?: InputMaybe<Scalars['Int']['input']>;
  outsideRegister_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  outsideRegister_LT?: InputMaybe<Scalars['Int']['input']>;
  outsideRegister_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  outsideRegister_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  outsideRegister_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  pending?: InputMaybe<Scalars['Int']['input']>;
  pending_GT?: InputMaybe<Scalars['Int']['input']>;
  pending_GTE?: InputMaybe<Scalars['Int']['input']>;
  pending_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  pending_LT?: InputMaybe<Scalars['Int']['input']>;
  pending_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pending_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pending_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RegisterCoveragesConnection = {
  __typename?: 'RegisterCoveragesConnection';
  edges: Array<RegisterCoverageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SignalLead = {
  __typename?: 'SignalLead';
  awardValue: Scalars['Float']['output'];
  awards: Scalars['Int']['output'];
  buyers: Scalars['Int']['output'];
  cobidders: Scalars['Int']['output'];
  councilInterest: Scalars['Int']['output'];
  councilInterestNamesakes: Scalars['Int']['output'];
  councilInterestValue: Scalars['Float']['output'];
  councilMajorityValue?: Maybe<Scalars['Float']['output']>;
  councilPartyKey?: Maybe<Scalars['ID']['output']>;
  councilPartyName?: Maybe<Scalars['String']['output']>;
  councilPartyShare?: Maybe<Scalars['Float']['output']>;
  councilPartyValue?: Maybe<Scalars['Float']['output']>;
  directAward: Scalars['Int']['output'];
  directAwardValue: Scalars['Float']['output'];
  flaggedAwards: Scalars['Int']['output'];
  flaggedValue: Scalars['Float']['output'];
  holdingsUndated: Scalars['Int']['output'];
  mandateAwards: Scalars['Int']['output'];
  mandateOfficials: Scalars['Int']['output'];
  mandateValue: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sharedAwards: Scalars['Int']['output'];
  singleBid: Scalars['Int']['output'];
  singleBidValue: Scalars['Float']['output'];
  subcontracted: Scalars['Int']['output'];
  topBuyerKey?: Maybe<Scalars['ID']['output']>;
  topBuyerName?: Maybe<Scalars['String']['output']>;
  topBuyerShare?: Maybe<Scalars['Float']['output']>;
  topBuyerTotal?: Maybe<Scalars['Float']['output']>;
  topBuyerValue?: Maybe<Scalars['Float']['output']>;
  topPartyKey?: Maybe<Scalars['ID']['output']>;
  topPartyName?: Maybe<Scalars['String']['output']>;
  topPartyShare?: Maybe<Scalars['Float']['output']>;
  topPartyValue?: Maybe<Scalars['Float']['output']>;
  uic: Scalars['ID']['output'];
};

export type SignalLeadAggregateSelection = {
  __typename?: 'SignalLeadAggregateSelection';
  awardValue: FloatAggregateSelection;
  awards: IntAggregateSelection;
  buyers: IntAggregateSelection;
  cobidders: IntAggregateSelection;
  councilInterest: IntAggregateSelection;
  councilInterestNamesakes: IntAggregateSelection;
  councilInterestValue: FloatAggregateSelection;
  councilMajorityValue: FloatAggregateSelection;
  councilPartyKey: IdAggregateSelection;
  councilPartyName: StringAggregateSelection;
  councilPartyShare: FloatAggregateSelection;
  councilPartyValue: FloatAggregateSelection;
  count: Scalars['Int']['output'];
  directAward: IntAggregateSelection;
  directAwardValue: FloatAggregateSelection;
  flaggedAwards: IntAggregateSelection;
  flaggedValue: FloatAggregateSelection;
  holdingsUndated: IntAggregateSelection;
  mandateAwards: IntAggregateSelection;
  mandateOfficials: IntAggregateSelection;
  mandateValue: FloatAggregateSelection;
  name: StringAggregateSelection;
  sharedAwards: IntAggregateSelection;
  singleBid: IntAggregateSelection;
  singleBidValue: FloatAggregateSelection;
  subcontracted: IntAggregateSelection;
  topBuyerKey: IdAggregateSelection;
  topBuyerName: StringAggregateSelection;
  topBuyerShare: FloatAggregateSelection;
  topBuyerTotal: FloatAggregateSelection;
  topBuyerValue: FloatAggregateSelection;
  topPartyKey: IdAggregateSelection;
  topPartyName: StringAggregateSelection;
  topPartyShare: FloatAggregateSelection;
  topPartyValue: FloatAggregateSelection;
  uic: IdAggregateSelection;
};

export type SignalLeadEdge = {
  __typename?: 'SignalLeadEdge';
  cursor: Scalars['String']['output'];
  node: SignalLead;
};

/** Fields to sort SignalLeads by. The order in which sorts are applied is not guaranteed when specifying many fields in one SignalLeadSort object. */
export type SignalLeadSort = {
  awardValue?: InputMaybe<SortDirection>;
  awards?: InputMaybe<SortDirection>;
  buyers?: InputMaybe<SortDirection>;
  cobidders?: InputMaybe<SortDirection>;
  councilInterest?: InputMaybe<SortDirection>;
  councilInterestNamesakes?: InputMaybe<SortDirection>;
  councilInterestValue?: InputMaybe<SortDirection>;
  councilMajorityValue?: InputMaybe<SortDirection>;
  councilPartyKey?: InputMaybe<SortDirection>;
  councilPartyName?: InputMaybe<SortDirection>;
  councilPartyShare?: InputMaybe<SortDirection>;
  councilPartyValue?: InputMaybe<SortDirection>;
  directAward?: InputMaybe<SortDirection>;
  directAwardValue?: InputMaybe<SortDirection>;
  flaggedAwards?: InputMaybe<SortDirection>;
  flaggedValue?: InputMaybe<SortDirection>;
  holdingsUndated?: InputMaybe<SortDirection>;
  mandateAwards?: InputMaybe<SortDirection>;
  mandateOfficials?: InputMaybe<SortDirection>;
  mandateValue?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  sharedAwards?: InputMaybe<SortDirection>;
  singleBid?: InputMaybe<SortDirection>;
  singleBidValue?: InputMaybe<SortDirection>;
  subcontracted?: InputMaybe<SortDirection>;
  topBuyerKey?: InputMaybe<SortDirection>;
  topBuyerName?: InputMaybe<SortDirection>;
  topBuyerShare?: InputMaybe<SortDirection>;
  topBuyerTotal?: InputMaybe<SortDirection>;
  topBuyerValue?: InputMaybe<SortDirection>;
  topPartyKey?: InputMaybe<SortDirection>;
  topPartyName?: InputMaybe<SortDirection>;
  topPartyShare?: InputMaybe<SortDirection>;
  topPartyValue?: InputMaybe<SortDirection>;
  uic?: InputMaybe<SortDirection>;
};

export type SignalLeadWhere = {
  AND?: InputMaybe<Array<SignalLeadWhere>>;
  NOT?: InputMaybe<SignalLeadWhere>;
  OR?: InputMaybe<Array<SignalLeadWhere>>;
  awardValue?: InputMaybe<Scalars['Float']['input']>;
  awardValue_GT?: InputMaybe<Scalars['Float']['input']>;
  awardValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  awardValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  awardValue_LT?: InputMaybe<Scalars['Float']['input']>;
  awardValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awardValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awardValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  awards?: InputMaybe<Scalars['Int']['input']>;
  awards_GT?: InputMaybe<Scalars['Int']['input']>;
  awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  awards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  awards_LT?: InputMaybe<Scalars['Int']['input']>;
  awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  buyers?: InputMaybe<Scalars['Int']['input']>;
  buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyers_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyers_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyers_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cobidders?: InputMaybe<Scalars['Int']['input']>;
  cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  cobidders_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cobidders_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cobidders_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilInterest?: InputMaybe<Scalars['Int']['input']>;
  councilInterestNamesakes?: InputMaybe<Scalars['Int']['input']>;
  councilInterestNamesakes_GT?: InputMaybe<Scalars['Int']['input']>;
  councilInterestNamesakes_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilInterestNamesakes_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilInterestNamesakes_LT?: InputMaybe<Scalars['Int']['input']>;
  councilInterestNamesakes_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterestNamesakes_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterestNamesakes_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilInterestValue?: InputMaybe<Scalars['Float']['input']>;
  councilInterestValue_GT?: InputMaybe<Scalars['Float']['input']>;
  councilInterestValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  councilInterestValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  councilInterestValue_LT?: InputMaybe<Scalars['Float']['input']>;
  councilInterestValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterestValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterestValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  councilInterest_GT?: InputMaybe<Scalars['Int']['input']>;
  councilInterest_GTE?: InputMaybe<Scalars['Int']['input']>;
  councilInterest_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilInterest_LT?: InputMaybe<Scalars['Int']['input']>;
  councilInterest_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterest_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilInterest_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  councilMajorityValue?: InputMaybe<Scalars['Float']['input']>;
  councilMajorityValue_GT?: InputMaybe<Scalars['Float']['input']>;
  councilMajorityValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  councilMajorityValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  councilMajorityValue_LT?: InputMaybe<Scalars['Float']['input']>;
  councilMajorityValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilMajorityValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilMajorityValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  councilPartyKey?: InputMaybe<Scalars['ID']['input']>;
  councilPartyKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  councilPartyKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councilPartyKey_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councilPartyKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  councilPartyName?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_GT?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_GTE?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  councilPartyName_LT?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  councilPartyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  councilPartyShare?: InputMaybe<Scalars['Float']['input']>;
  councilPartyShare_GT?: InputMaybe<Scalars['Float']['input']>;
  councilPartyShare_GTE?: InputMaybe<Scalars['Float']['input']>;
  councilPartyShare_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  councilPartyShare_LT?: InputMaybe<Scalars['Float']['input']>;
  councilPartyShare_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyShare_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyShare_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  councilPartyValue?: InputMaybe<Scalars['Float']['input']>;
  councilPartyValue_GT?: InputMaybe<Scalars['Float']['input']>;
  councilPartyValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  councilPartyValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  councilPartyValue_LT?: InputMaybe<Scalars['Float']['input']>;
  councilPartyValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  councilPartyValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  directAward?: InputMaybe<Scalars['Int']['input']>;
  directAwardValue?: InputMaybe<Scalars['Float']['input']>;
  directAwardValue_GT?: InputMaybe<Scalars['Float']['input']>;
  directAwardValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  directAwardValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  directAwardValue_LT?: InputMaybe<Scalars['Float']['input']>;
  directAwardValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  directAwardValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  directAwardValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  directAward_GT?: InputMaybe<Scalars['Int']['input']>;
  directAward_GTE?: InputMaybe<Scalars['Int']['input']>;
  directAward_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  directAward_LT?: InputMaybe<Scalars['Int']['input']>;
  directAward_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  directAward_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  directAward_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  flaggedAwards?: InputMaybe<Scalars['Int']['input']>;
  flaggedAwards_GT?: InputMaybe<Scalars['Int']['input']>;
  flaggedAwards_GTE?: InputMaybe<Scalars['Int']['input']>;
  flaggedAwards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  flaggedAwards_LT?: InputMaybe<Scalars['Int']['input']>;
  flaggedAwards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flaggedAwards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flaggedAwards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  flaggedValue?: InputMaybe<Scalars['Float']['input']>;
  flaggedValue_GT?: InputMaybe<Scalars['Float']['input']>;
  flaggedValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  flaggedValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  flaggedValue_LT?: InputMaybe<Scalars['Float']['input']>;
  flaggedValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flaggedValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flaggedValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  holdingsUndated?: InputMaybe<Scalars['Int']['input']>;
  holdingsUndated_GT?: InputMaybe<Scalars['Int']['input']>;
  holdingsUndated_GTE?: InputMaybe<Scalars['Int']['input']>;
  holdingsUndated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  holdingsUndated_LT?: InputMaybe<Scalars['Int']['input']>;
  holdingsUndated_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  holdingsUndated_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  holdingsUndated_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mandateAwards?: InputMaybe<Scalars['Int']['input']>;
  mandateAwards_GT?: InputMaybe<Scalars['Int']['input']>;
  mandateAwards_GTE?: InputMaybe<Scalars['Int']['input']>;
  mandateAwards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mandateAwards_LT?: InputMaybe<Scalars['Int']['input']>;
  mandateAwards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateAwards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateAwards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mandateOfficials?: InputMaybe<Scalars['Int']['input']>;
  mandateOfficials_GT?: InputMaybe<Scalars['Int']['input']>;
  mandateOfficials_GTE?: InputMaybe<Scalars['Int']['input']>;
  mandateOfficials_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mandateOfficials_LT?: InputMaybe<Scalars['Int']['input']>;
  mandateOfficials_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateOfficials_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateOfficials_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  mandateValue?: InputMaybe<Scalars['Float']['input']>;
  mandateValue_GT?: InputMaybe<Scalars['Float']['input']>;
  mandateValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  mandateValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  mandateValue_LT?: InputMaybe<Scalars['Float']['input']>;
  mandateValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mandateValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_GT?: InputMaybe<Scalars['String']['input']>;
  name_GTE?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_LT?: InputMaybe<Scalars['String']['input']>;
  name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sharedAwards?: InputMaybe<Scalars['Int']['input']>;
  sharedAwards_GT?: InputMaybe<Scalars['Int']['input']>;
  sharedAwards_GTE?: InputMaybe<Scalars['Int']['input']>;
  sharedAwards_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  sharedAwards_LT?: InputMaybe<Scalars['Int']['input']>;
  sharedAwards_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sharedAwards_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sharedAwards_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  singleBid?: InputMaybe<Scalars['Int']['input']>;
  singleBidValue?: InputMaybe<Scalars['Float']['input']>;
  singleBidValue_GT?: InputMaybe<Scalars['Float']['input']>;
  singleBidValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  singleBidValue_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  singleBidValue_LT?: InputMaybe<Scalars['Float']['input']>;
  singleBidValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  singleBidValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  singleBidValue_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  singleBid_GT?: InputMaybe<Scalars['Int']['input']>;
  singleBid_GTE?: InputMaybe<Scalars['Int']['input']>;
  singleBid_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  singleBid_LT?: InputMaybe<Scalars['Int']['input']>;
  singleBid_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  singleBid_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  singleBid_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  subcontracted?: InputMaybe<Scalars['Int']['input']>;
  subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracted_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontracted_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontracted_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  topBuyerKey?: InputMaybe<Scalars['ID']['input']>;
  topBuyerKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  topBuyerKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topBuyerKey_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topBuyerKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topBuyerName?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_GT?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_GTE?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topBuyerName_LT?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topBuyerName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topBuyerShare?: InputMaybe<Scalars['Float']['input']>;
  topBuyerShare_GT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerShare_GTE?: InputMaybe<Scalars['Float']['input']>;
  topBuyerShare_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topBuyerShare_LT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerShare_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerShare_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerShare_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topBuyerTotal?: InputMaybe<Scalars['Float']['input']>;
  topBuyerTotal_GT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerTotal_GTE?: InputMaybe<Scalars['Float']['input']>;
  topBuyerTotal_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topBuyerTotal_LT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerTotal_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerTotal_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerTotal_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topBuyerValue?: InputMaybe<Scalars['Float']['input']>;
  topBuyerValue_GT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  topBuyerValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topBuyerValue_LT?: InputMaybe<Scalars['Float']['input']>;
  topBuyerValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topBuyerValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topPartyKey?: InputMaybe<Scalars['ID']['input']>;
  topPartyKey_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  topPartyKey_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topPartyKey_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyKey_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyKey_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyKey_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyKey_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topPartyKey_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  topPartyName?: InputMaybe<Scalars['String']['input']>;
  topPartyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  topPartyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  topPartyName_GT?: InputMaybe<Scalars['String']['input']>;
  topPartyName_GTE?: InputMaybe<Scalars['String']['input']>;
  topPartyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topPartyName_LT?: InputMaybe<Scalars['String']['input']>;
  topPartyName_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topPartyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topPartyShare?: InputMaybe<Scalars['Float']['input']>;
  topPartyShare_GT?: InputMaybe<Scalars['Float']['input']>;
  topPartyShare_GTE?: InputMaybe<Scalars['Float']['input']>;
  topPartyShare_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topPartyShare_LT?: InputMaybe<Scalars['Float']['input']>;
  topPartyShare_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyShare_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyShare_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topPartyValue?: InputMaybe<Scalars['Float']['input']>;
  topPartyValue_GT?: InputMaybe<Scalars['Float']['input']>;
  topPartyValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  topPartyValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  topPartyValue_LT?: InputMaybe<Scalars['Float']['input']>;
  topPartyValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topPartyValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  uic?: InputMaybe<Scalars['ID']['input']>;
  uic_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uic_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uic_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uic_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SignalLeadsConnection = {
  __typename?: 'SignalLeadsConnection';
  edges: Array<SignalLeadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type SubsidiesConnection = {
  __typename?: 'SubsidiesConnection';
  edges: Array<SubsidyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Subsidy = {
  __typename?: 'Subsidy';
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiaries: Array<Company>;
  beneficiariesAggregate?: Maybe<SubsidyCompanyBeneficiariesAggregationSelection>;
  beneficiariesConnection: SubsidyBeneficiariesConnection;
  description?: Maybe<Scalars['String']['output']>;
  duration_months?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<Scalars['String']['output']>;
  paid_amount?: Maybe<Scalars['Float']['output']>;
  places?: Maybe<Array<Scalars['String']['output']>>;
  project_title?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidy_id: Scalars['ID']['output'];
  total_value?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type SubsidyBeneficiariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type SubsidyBeneficiariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type SubsidyBeneficiariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubsidyBeneficiariesConnectionSort>>;
  where?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
};

export type SubsidyAggregateSelection = {
  __typename?: 'SubsidyAggregateSelection';
  amount: FloatAggregateSelection;
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  duration_months: IntAggregateSelection;
  end_date: StringAggregateSelection;
  measure: StringAggregateSelection;
  paid_amount: FloatAggregateSelection;
  project_title: StringAggregateSelection;
  source: StringAggregateSelection;
  start_date: StringAggregateSelection;
  status: StringAggregateSelection;
  subsidy_id: IdAggregateSelection;
  total_value: FloatAggregateSelection;
  year: IntAggregateSelection;
};

export type SubsidyBeneficiariesAggregateInput = {
  AND?: InputMaybe<Array<SubsidyBeneficiariesAggregateInput>>;
  NOT?: InputMaybe<SubsidyBeneficiariesAggregateInput>;
  OR?: InputMaybe<Array<SubsidyBeneficiariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubsidyBeneficiariesNodeAggregationWhereInput>;
};

export type SubsidyBeneficiariesConnection = {
  __typename?: 'SubsidyBeneficiariesConnection';
  edges: Array<SubsidyBeneficiariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubsidyBeneficiariesConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type SubsidyBeneficiariesConnectionWhere = {
  AND?: InputMaybe<Array<SubsidyBeneficiariesConnectionWhere>>;
  NOT?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  OR?: InputMaybe<Array<SubsidyBeneficiariesConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type SubsidyBeneficiariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubsidyBeneficiariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubsidyBeneficiariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubsidyBeneficiariesNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type SubsidyBeneficiariesRelationship = {
  __typename?: 'SubsidyBeneficiariesRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type SubsidyCompanyBeneficiariesAggregationSelection = {
  __typename?: 'SubsidyCompanyBeneficiariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubsidyCompanyBeneficiariesNodeAggregateSelection>;
};

export type SubsidyCompanyBeneficiariesNodeAggregateSelection = {
  __typename?: 'SubsidyCompanyBeneficiariesNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type SubsidyEdge = {
  __typename?: 'SubsidyEdge';
  cursor: Scalars['String']['output'];
  node: Subsidy;
};

export type SubsidyFilter = {
  beneficiaryUics?: InputMaybe<Array<Scalars['ID']['input']>>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SubsidyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubsidySort objects to sort Subsidies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubsidySort>>;
};

/** Fields to sort Subsidies by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubsidySort object. */
export type SubsidySort = {
  amount?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  duration_months?: InputMaybe<SortDirection>;
  end_date?: InputMaybe<SortDirection>;
  measure?: InputMaybe<SortDirection>;
  paid_amount?: InputMaybe<SortDirection>;
  project_title?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  start_date?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subsidy_id?: InputMaybe<SortDirection>;
  total_value?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type SubsidyWhere = {
  AND?: InputMaybe<Array<SubsidyWhere>>;
  NOT?: InputMaybe<SubsidyWhere>;
  OR?: InputMaybe<Array<SubsidyWhere>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** @deprecated Use `beneficiaries_SOME` instead. */
  beneficiaries?: InputMaybe<CompanyWhere>;
  beneficiariesAggregate?: InputMaybe<SubsidyBeneficiariesAggregateInput>;
  /** @deprecated Use `beneficiariesConnection_SOME` instead. */
  beneficiariesConnection?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** Return Subsidies where all of the related SubsidyBeneficiariesConnections match this filter */
  beneficiariesConnection_ALL?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** Return Subsidies where none of the related SubsidyBeneficiariesConnections match this filter */
  beneficiariesConnection_NONE?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** @deprecated Use `beneficiariesConnection_NONE` instead. */
  beneficiariesConnection_NOT?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** Return Subsidies where one of the related SubsidyBeneficiariesConnections match this filter */
  beneficiariesConnection_SINGLE?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** Return Subsidies where some of the related SubsidyBeneficiariesConnections match this filter */
  beneficiariesConnection_SOME?: InputMaybe<SubsidyBeneficiariesConnectionWhere>;
  /** Return Subsidies where all of the related Companies match this filter */
  beneficiaries_ALL?: InputMaybe<CompanyWhere>;
  /** Return Subsidies where none of the related Companies match this filter */
  beneficiaries_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `beneficiaries_NONE` instead. */
  beneficiaries_NOT?: InputMaybe<CompanyWhere>;
  /** Return Subsidies where one of the related Companies match this filter */
  beneficiaries_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Subsidies where some of the related Companies match this filter */
  beneficiaries_SOME?: InputMaybe<CompanyWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_GT?: InputMaybe<Scalars['String']['input']>;
  description_GTE?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_LT?: InputMaybe<Scalars['String']['input']>;
  description_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  duration_months?: InputMaybe<Scalars['Int']['input']>;
  duration_months_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_months_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_months_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_months_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_months_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_months_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  end_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  end_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_date_GT?: InputMaybe<Scalars['String']['input']>;
  end_date_GTE?: InputMaybe<Scalars['String']['input']>;
  end_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date_LT?: InputMaybe<Scalars['String']['input']>;
  end_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<Scalars['String']['input']>;
  measure_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  measure_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  measure_GT?: InputMaybe<Scalars['String']['input']>;
  measure_GTE?: InputMaybe<Scalars['String']['input']>;
  measure_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  measure_LT?: InputMaybe<Scalars['String']['input']>;
  measure_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  measure_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  measure_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  measure_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  measure_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  measure_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  measure_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paid_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  paid_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  paid_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  paid_amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  paid_amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  places?: InputMaybe<Array<Scalars['String']['input']>>;
  places_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  places_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  places_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  project_title?: InputMaybe<Scalars['String']['input']>;
  project_title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  project_title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  project_title_GT?: InputMaybe<Scalars['String']['input']>;
  project_title_GTE?: InputMaybe<Scalars['String']['input']>;
  project_title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  project_title_LT?: InputMaybe<Scalars['String']['input']>;
  project_title_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  project_title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  project_title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  project_title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  project_title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  project_title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  project_title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  start_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date_GT?: InputMaybe<Scalars['String']['input']>;
  start_date_GTE?: InputMaybe<Scalars['String']['input']>;
  start_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date_LT?: InputMaybe<Scalars['String']['input']>;
  start_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_GT?: InputMaybe<Scalars['String']['input']>;
  status_GTE?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_LT?: InputMaybe<Scalars['String']['input']>;
  status_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subsidy_id?: InputMaybe<Scalars['ID']['input']>;
  subsidy_id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  subsidy_id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  subsidy_id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subsidy_id_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subsidy_id_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subsidy_id_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subsidy_id_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subsidy_id_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  subsidy_id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  total_value?: InputMaybe<Scalars['Float']['input']>;
  total_value_GT?: InputMaybe<Scalars['Float']['input']>;
  total_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  total_value_LT?: InputMaybe<Scalars['Float']['input']>;
  total_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  total_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  total_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/**
 * The edge properties for the following fields:
 * * Party.succeededBy
 * * Party.succeeds
 */
export type Succession = {
  __typename?: 'Succession';
  created_at?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type SuccessionAggregationWhereInput = {
  AND?: InputMaybe<Array<SuccessionAggregationWhereInput>>;
  NOT?: InputMaybe<SuccessionAggregationWhereInput>;
  OR?: InputMaybe<Array<SuccessionAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  created_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  created_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  note_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  note_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  source_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  source_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  source_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  source_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SuccessionSort = {
  created_at?: InputMaybe<SortDirection>;
  note?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type SuccessionWhere = {
  AND?: InputMaybe<Array<SuccessionWhere>>;
  NOT?: InputMaybe<SuccessionWhere>;
  OR?: InputMaybe<Array<SuccessionWhere>>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_GT?: InputMaybe<Scalars['String']['input']>;
  created_at_GTE?: InputMaybe<Scalars['String']['input']>;
  created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at_LT?: InputMaybe<Scalars['String']['input']>;
  created_at_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_at_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  note_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  note_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_GT?: InputMaybe<Scalars['String']['input']>;
  note_GTE?: InputMaybe<Scalars['String']['input']>;
  note_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  note_LT?: InputMaybe<Scalars['String']['input']>;
  note_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  note_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type TaxDebtRecord = {
  __typename?: 'TaxDebtRecord';
  amount?: Maybe<Scalars['Float']['output']>;
  as_of?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  debt_type?: Maybe<Scalars['String']['output']>;
  debtors: Array<Company>;
  debtorsAggregate?: Maybe<TaxDebtRecordCompanyDebtorsAggregationSelection>;
  debtorsConnection: TaxDebtRecordDebtorsConnection;
  record_id: Scalars['ID']['output'];
  resolved?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
};


export type TaxDebtRecordDebtorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type TaxDebtRecordDebtorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type TaxDebtRecordDebtorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaxDebtRecordDebtorsConnectionSort>>;
  where?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
};

export type TaxDebtRecordAggregateSelection = {
  __typename?: 'TaxDebtRecordAggregateSelection';
  amount: FloatAggregateSelection;
  as_of: StringAggregateSelection;
  count: Scalars['Int']['output'];
  date: StringAggregateSelection;
  debt_type: StringAggregateSelection;
  record_id: IdAggregateSelection;
  source: StringAggregateSelection;
  territory: StringAggregateSelection;
};

export type TaxDebtRecordCompanyDebtorsAggregationSelection = {
  __typename?: 'TaxDebtRecordCompanyDebtorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TaxDebtRecordCompanyDebtorsNodeAggregateSelection>;
};

export type TaxDebtRecordCompanyDebtorsNodeAggregateSelection = {
  __typename?: 'TaxDebtRecordCompanyDebtorsNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type TaxDebtRecordDebtorsAggregateInput = {
  AND?: InputMaybe<Array<TaxDebtRecordDebtorsAggregateInput>>;
  NOT?: InputMaybe<TaxDebtRecordDebtorsAggregateInput>;
  OR?: InputMaybe<Array<TaxDebtRecordDebtorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TaxDebtRecordDebtorsNodeAggregationWhereInput>;
};

export type TaxDebtRecordDebtorsConnection = {
  __typename?: 'TaxDebtRecordDebtorsConnection';
  edges: Array<TaxDebtRecordDebtorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaxDebtRecordDebtorsConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type TaxDebtRecordDebtorsConnectionWhere = {
  AND?: InputMaybe<Array<TaxDebtRecordDebtorsConnectionWhere>>;
  NOT?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  OR?: InputMaybe<Array<TaxDebtRecordDebtorsConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type TaxDebtRecordDebtorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaxDebtRecordDebtorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaxDebtRecordDebtorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaxDebtRecordDebtorsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type TaxDebtRecordDebtorsRelationship = {
  __typename?: 'TaxDebtRecordDebtorsRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type TaxDebtRecordEdge = {
  __typename?: 'TaxDebtRecordEdge';
  cursor: Scalars['String']['output'];
  node: TaxDebtRecord;
};

export type TaxDebtRecordOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TaxDebtRecordSort objects to sort TaxDebtRecords by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TaxDebtRecordSort>>;
};

/** Fields to sort TaxDebtRecords by. The order in which sorts are applied is not guaranteed when specifying many fields in one TaxDebtRecordSort object. */
export type TaxDebtRecordSort = {
  amount?: InputMaybe<SortDirection>;
  as_of?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  debt_type?: InputMaybe<SortDirection>;
  record_id?: InputMaybe<SortDirection>;
  resolved?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  territory?: InputMaybe<SortDirection>;
};

export type TaxDebtRecordWhere = {
  AND?: InputMaybe<Array<TaxDebtRecordWhere>>;
  NOT?: InputMaybe<TaxDebtRecordWhere>;
  OR?: InputMaybe<Array<TaxDebtRecordWhere>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  as_of?: InputMaybe<Scalars['String']['input']>;
  as_of_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  as_of_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  as_of_GT?: InputMaybe<Scalars['String']['input']>;
  as_of_GTE?: InputMaybe<Scalars['String']['input']>;
  as_of_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  as_of_LT?: InputMaybe<Scalars['String']['input']>;
  as_of_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  as_of_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  date_GT?: InputMaybe<Scalars['String']['input']>;
  date_GTE?: InputMaybe<Scalars['String']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date_LT?: InputMaybe<Scalars['String']['input']>;
  date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  debt_type?: InputMaybe<Scalars['String']['input']>;
  debt_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  debt_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  debt_type_GT?: InputMaybe<Scalars['String']['input']>;
  debt_type_GTE?: InputMaybe<Scalars['String']['input']>;
  debt_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  debt_type_LT?: InputMaybe<Scalars['String']['input']>;
  debt_type_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_type_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_type_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_type_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  debt_type_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  debt_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `debtors_SOME` instead. */
  debtors?: InputMaybe<CompanyWhere>;
  debtorsAggregate?: InputMaybe<TaxDebtRecordDebtorsAggregateInput>;
  /** @deprecated Use `debtorsConnection_SOME` instead. */
  debtorsConnection?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** Return TaxDebtRecords where all of the related TaxDebtRecordDebtorsConnections match this filter */
  debtorsConnection_ALL?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** Return TaxDebtRecords where none of the related TaxDebtRecordDebtorsConnections match this filter */
  debtorsConnection_NONE?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** @deprecated Use `debtorsConnection_NONE` instead. */
  debtorsConnection_NOT?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** Return TaxDebtRecords where one of the related TaxDebtRecordDebtorsConnections match this filter */
  debtorsConnection_SINGLE?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** Return TaxDebtRecords where some of the related TaxDebtRecordDebtorsConnections match this filter */
  debtorsConnection_SOME?: InputMaybe<TaxDebtRecordDebtorsConnectionWhere>;
  /** Return TaxDebtRecords where all of the related Companies match this filter */
  debtors_ALL?: InputMaybe<CompanyWhere>;
  /** Return TaxDebtRecords where none of the related Companies match this filter */
  debtors_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `debtors_NONE` instead. */
  debtors_NOT?: InputMaybe<CompanyWhere>;
  /** Return TaxDebtRecords where one of the related Companies match this filter */
  debtors_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return TaxDebtRecords where some of the related Companies match this filter */
  debtors_SOME?: InputMaybe<CompanyWhere>;
  record_id?: InputMaybe<Scalars['ID']['input']>;
  record_id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  record_id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  record_id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  record_id_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  record_id_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  record_id_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  record_id_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  record_id_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  record_id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  resolved_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  territory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  territory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  territory_GT?: InputMaybe<Scalars['String']['input']>;
  territory_GTE?: InputMaybe<Scalars['String']['input']>;
  territory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  territory_LT?: InputMaybe<Scalars['String']['input']>;
  territory_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  territory_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  territory_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  territory_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  territory_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  territory_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  territory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TaxDebtRecordsConnection = {
  __typename?: 'TaxDebtRecordsConnection';
  edges: Array<TaxDebtRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Tender = {
  __typename?: 'Tender';
  alsoPublishedAs: Array<Tender>;
  alsoPublishedAsAggregate?: Maybe<TenderTenderAlsoPublishedAsAggregationSelection>;
  alsoPublishedAsConnection: TenderAlsoPublishedAsConnection;
  award_method?: Maybe<Scalars['String']['output']>;
  awarded_amount?: Maybe<Scalars['Float']['output']>;
  awarded_total_bgn?: Maybe<Scalars['Float']['output']>;
  buyer_activity?: Maybe<Scalars['String']['output']>;
  buyer_type?: Maybe<Scalars['String']['output']>;
  commissionedBy: Array<Municipality>;
  commissionedByAggregate?: Maybe<TenderMunicipalityCommissionedByAggregationSelection>;
  commissionedByConnection: TenderCommissionedByConnection;
  contract_type?: Maybe<Scalars['String']['output']>;
  cpv_code?: Maybe<Scalars['String']['output']>;
  cpv_description?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  direct_award_justification?: Maybe<Scalars['String']['output']>;
  disqualified_offers_count?: Maybe<Scalars['Int']['output']>;
  duplicate_of?: Maybe<Scalars['String']['output']>;
  estimated_value?: Maybe<Scalars['Float']['output']>;
  european_program?: Maybe<Scalars['String']['output']>;
  execution_nuts?: Maybe<Scalars['String']['output']>;
  has_subcontractors?: Maybe<Scalars['Boolean']['output']>;
  is_accelerated?: Maybe<Scalars['Boolean']['output']>;
  is_cancelled?: Maybe<Scalars['Boolean']['output']>;
  is_eu_funded?: Maybe<Scalars['Boolean']['output']>;
  is_framework?: Maybe<Scalars['Boolean']['output']>;
  is_green?: Maybe<Scalars['Boolean']['output']>;
  legal_basis?: Maybe<Scalars['String']['output']>;
  link_to_ojeu?: Maybe<Scalars['String']['output']>;
  lot_count?: Maybe<Scalars['Int']['output']>;
  lots: Array<Lot>;
  lotsAggregate?: Maybe<TenderLotLotsAggregationSelection>;
  lotsConnection: TenderLotsConnection;
  offers_count?: Maybe<Scalars['Int']['output']>;
  procedure_type?: Maybe<Scalars['String']['output']>;
  procuredBy: Array<Company>;
  procuredByAggregate?: Maybe<TenderCompanyProcuredByAggregationSelection>;
  procuredByConnection: TenderProcuredByConnection;
  procuring_entity?: Maybe<Scalars['String']['output']>;
  procuring_entity_uic?: Maybe<Scalars['String']['output']>;
  publication_date?: Maybe<Scalars['String']['output']>;
  publishedAlsoIn: Array<Tender>;
  publishedAlsoInAggregate?: Maybe<TenderTenderPublishedAlsoInAggregationSelection>;
  publishedAlsoInConnection: TenderPublishedAlsoInConnection;
  sme_offers_count?: Maybe<Scalars['Int']['output']>;
  subcontracting_percent?: Maybe<Scalars['Float']['output']>;
  subcontractor_name?: Maybe<Scalars['String']['output']>;
  submission_deadline?: Maybe<Scalars['String']['output']>;
  tender_id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  value_bgn?: Maybe<Scalars['Float']['output']>;
  value_excluded?: Maybe<Scalars['Boolean']['output']>;
  value_flag?: Maybe<Scalars['String']['output']>;
  value_flag_reason?: Maybe<Scalars['String']['output']>;
  value_ratio?: Maybe<Scalars['Float']['output']>;
  winner_count?: Maybe<Scalars['Int']['output']>;
  winners: Array<Company>;
  winnersAggregate?: Maybe<TenderCompanyWinnersAggregationSelection>;
  winnersConnection: TenderWinnersConnection;
};


export type TenderAlsoPublishedAsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type TenderAlsoPublishedAsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type TenderAlsoPublishedAsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderAlsoPublishedAsConnectionSort>>;
  where?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
};


export type TenderCommissionedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MunicipalityOptions>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type TenderCommissionedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MunicipalityWhere>;
};


export type TenderCommissionedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderCommissionedByConnectionSort>>;
  where?: InputMaybe<TenderCommissionedByConnectionWhere>;
};


export type TenderLotsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LotOptions>;
  where?: InputMaybe<LotWhere>;
};


export type TenderLotsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LotWhere>;
};


export type TenderLotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderLotsConnectionSort>>;
  where?: InputMaybe<TenderLotsConnectionWhere>;
};


export type TenderProcuredByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type TenderProcuredByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type TenderProcuredByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderProcuredByConnectionSort>>;
  where?: InputMaybe<TenderProcuredByConnectionWhere>;
};


export type TenderPublishedAlsoInArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenderOptions>;
  where?: InputMaybe<TenderWhere>;
};


export type TenderPublishedAlsoInAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenderWhere>;
};


export type TenderPublishedAlsoInConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderPublishedAlsoInConnectionSort>>;
  where?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
};


export type TenderWinnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type TenderWinnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type TenderWinnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenderWinnersConnectionSort>>;
  where?: InputMaybe<TenderWinnersConnectionWhere>;
};

export type TenderAggregateSelection = {
  __typename?: 'TenderAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  count: Scalars['Int']['output'];
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type TenderAlsoPublishedAsAggregateInput = {
  AND?: InputMaybe<Array<TenderAlsoPublishedAsAggregateInput>>;
  NOT?: InputMaybe<TenderAlsoPublishedAsAggregateInput>;
  OR?: InputMaybe<Array<TenderAlsoPublishedAsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenderAlsoPublishedAsNodeAggregationWhereInput>;
};

export type TenderAlsoPublishedAsConnection = {
  __typename?: 'TenderAlsoPublishedAsConnection';
  edges: Array<TenderAlsoPublishedAsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderAlsoPublishedAsConnectionSort = {
  node?: InputMaybe<TenderSort>;
};

export type TenderAlsoPublishedAsConnectionWhere = {
  AND?: InputMaybe<Array<TenderAlsoPublishedAsConnectionWhere>>;
  NOT?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  OR?: InputMaybe<Array<TenderAlsoPublishedAsConnectionWhere>>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type TenderAlsoPublishedAsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderAlsoPublishedAsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderAlsoPublishedAsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderAlsoPublishedAsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenderAlsoPublishedAsRelationship = {
  __typename?: 'TenderAlsoPublishedAsRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type TenderCommissionedByAggregateInput = {
  AND?: InputMaybe<Array<TenderCommissionedByAggregateInput>>;
  NOT?: InputMaybe<TenderCommissionedByAggregateInput>;
  OR?: InputMaybe<Array<TenderCommissionedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenderCommissionedByNodeAggregationWhereInput>;
};

export type TenderCommissionedByConnection = {
  __typename?: 'TenderCommissionedByConnection';
  edges: Array<TenderCommissionedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderCommissionedByConnectionSort = {
  node?: InputMaybe<MunicipalitySort>;
};

export type TenderCommissionedByConnectionWhere = {
  AND?: InputMaybe<Array<TenderCommissionedByConnectionWhere>>;
  NOT?: InputMaybe<TenderCommissionedByConnectionWhere>;
  OR?: InputMaybe<Array<TenderCommissionedByConnectionWhere>>;
  node?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MunicipalityWhere>;
};

export type TenderCommissionedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderCommissionedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderCommissionedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderCommissionedByNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ekatte_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  ekatte_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ekatte_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  ekatte_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  population_as_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_as_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  population_as_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  population_as_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_current_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_current_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_current_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  population_permanent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  population_permanent_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  population_permanent_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  province_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  province_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  province_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  province_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  spend_per_capita_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  spend_per_capita_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  spend_per_capita_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  tender_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type TenderCommissionedByRelationship = {
  __typename?: 'TenderCommissionedByRelationship';
  cursor: Scalars['String']['output'];
  node: Municipality;
};

export type TenderCompanyProcuredByAggregationSelection = {
  __typename?: 'TenderCompanyProcuredByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenderCompanyProcuredByNodeAggregateSelection>;
};

export type TenderCompanyProcuredByNodeAggregateSelection = {
  __typename?: 'TenderCompanyProcuredByNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type TenderCompanyWinnersAggregationSelection = {
  __typename?: 'TenderCompanyWinnersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TenderCompanyWinnersEdgeAggregateSelection>;
  node?: Maybe<TenderCompanyWinnersNodeAggregateSelection>;
};

export type TenderCompanyWinnersEdgeAggregateSelection = {
  __typename?: 'TenderCompanyWinnersEdgeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
};

export type TenderCompanyWinnersNodeAggregateSelection = {
  __typename?: 'TenderCompanyWinnersNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type TenderEdge = {
  __typename?: 'TenderEdge';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type TenderFilter = {
  buyerKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  buyerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerUics?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  cpv?: InputMaybe<Array<Scalars['String']['input']>>;
  euFunded?: InputMaybe<Scalars['Boolean']['input']>;
  framework?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  procedures?: InputMaybe<Array<Scalars['String']['input']>>;
  provinces?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  singleOffer?: InputMaybe<Scalars['Boolean']['input']>;
  subcontracted?: InputMaybe<Scalars['Boolean']['input']>;
  valueBand?: InputMaybe<Scalars['Int']['input']>;
  winnerUics?: InputMaybe<Array<Scalars['ID']['input']>>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TenderLotLotsAggregationSelection = {
  __typename?: 'TenderLotLotsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenderLotLotsNodeAggregateSelection>;
};

export type TenderLotLotsNodeAggregateSelection = {
  __typename?: 'TenderLotLotsNodeAggregateSelection';
  awarded_amount: FloatAggregateSelection;
  contract_number: StringAggregateSelection;
  currency: StringAggregateSelection;
  lot_id: StringAggregateSelection;
  lot_key: IdAggregateSelection;
  publication_date: StringAggregateSelection;
};

export type TenderLotsAggregateInput = {
  AND?: InputMaybe<Array<TenderLotsAggregateInput>>;
  NOT?: InputMaybe<TenderLotsAggregateInput>;
  OR?: InputMaybe<Array<TenderLotsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenderLotsNodeAggregationWhereInput>;
};

export type TenderLotsConnection = {
  __typename?: 'TenderLotsConnection';
  edges: Array<TenderLotsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderLotsConnectionSort = {
  node?: InputMaybe<LotSort>;
};

export type TenderLotsConnectionWhere = {
  AND?: InputMaybe<Array<TenderLotsConnectionWhere>>;
  NOT?: InputMaybe<TenderLotsConnectionWhere>;
  OR?: InputMaybe<Array<TenderLotsConnectionWhere>>;
  node?: InputMaybe<LotWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LotWhere>;
};

export type TenderLotsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderLotsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderLotsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderLotsNodeAggregationWhereInput>>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_number_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_number_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_number_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_number_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_id_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  lot_id_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenderLotsRelationship = {
  __typename?: 'TenderLotsRelationship';
  cursor: Scalars['String']['output'];
  node: Lot;
};

export type TenderMunicipalityCommissionedByAggregationSelection = {
  __typename?: 'TenderMunicipalityCommissionedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenderMunicipalityCommissionedByNodeAggregateSelection>;
};

export type TenderMunicipalityCommissionedByNodeAggregateSelection = {
  __typename?: 'TenderMunicipalityCommissionedByNodeAggregateSelection';
  ekatte: StringAggregateSelection;
  key: IdAggregateSelection;
  name: StringAggregateSelection;
  population_as_of: StringAggregateSelection;
  population_current: IntAggregateSelection;
  population_permanent: IntAggregateSelection;
  province: StringAggregateSelection;
  spend_per_capita: FloatAggregateSelection;
  tender_total_bgn: FloatAggregateSelection;
};

export type TenderOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TenderSort objects to sort Tenders by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TenderSort>>;
};

export type TenderProcuredByAggregateInput = {
  AND?: InputMaybe<Array<TenderProcuredByAggregateInput>>;
  NOT?: InputMaybe<TenderProcuredByAggregateInput>;
  OR?: InputMaybe<Array<TenderProcuredByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenderProcuredByNodeAggregationWhereInput>;
};

export type TenderProcuredByConnection = {
  __typename?: 'TenderProcuredByConnection';
  edges: Array<TenderProcuredByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderProcuredByConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type TenderProcuredByConnectionWhere = {
  AND?: InputMaybe<Array<TenderProcuredByConnectionWhere>>;
  NOT?: InputMaybe<TenderProcuredByConnectionWhere>;
  OR?: InputMaybe<Array<TenderProcuredByConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type TenderProcuredByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderProcuredByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderProcuredByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderProcuredByNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type TenderProcuredByRelationship = {
  __typename?: 'TenderProcuredByRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type TenderPublishedAlsoInAggregateInput = {
  AND?: InputMaybe<Array<TenderPublishedAlsoInAggregateInput>>;
  NOT?: InputMaybe<TenderPublishedAlsoInAggregateInput>;
  OR?: InputMaybe<Array<TenderPublishedAlsoInAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenderPublishedAlsoInNodeAggregationWhereInput>;
};

export type TenderPublishedAlsoInConnection = {
  __typename?: 'TenderPublishedAlsoInConnection';
  edges: Array<TenderPublishedAlsoInRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderPublishedAlsoInConnectionSort = {
  node?: InputMaybe<TenderSort>;
};

export type TenderPublishedAlsoInConnectionWhere = {
  AND?: InputMaybe<Array<TenderPublishedAlsoInConnectionWhere>>;
  NOT?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  OR?: InputMaybe<Array<TenderPublishedAlsoInConnectionWhere>>;
  node?: InputMaybe<TenderWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TenderWhere>;
};

export type TenderPublishedAlsoInNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderPublishedAlsoInNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderPublishedAlsoInNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderPublishedAlsoInNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  award_method_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  award_method_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  award_method_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  award_method_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  awarded_amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_activity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_activity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_activity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_activity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  buyer_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  buyer_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  buyer_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  buyer_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contract_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  contract_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contract_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  contract_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_code_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_code_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cpv_description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  cpv_description_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cpv_description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  cpv_description_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  currency_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  currency_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  direct_award_justification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  direct_award_justification_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  direct_award_justification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  direct_award_justification_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  disqualified_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duplicate_of_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  duplicate_of_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duplicate_of_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  duplicate_of_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimated_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  european_program_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  european_program_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  european_program_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  european_program_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  execution_nuts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  execution_nuts_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  execution_nuts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  execution_nuts_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_basis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_basis_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_basis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_basis_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_to_ojeu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  link_to_ojeu_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_to_ojeu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  link_to_ojeu_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lot_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procedure_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procedure_type_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procedure_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procedure_type_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuring_entity_uic_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  procuring_entity_uic_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuring_entity_uic_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  procuring_entity_uic_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  publication_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  publication_date_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  publication_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  publication_date_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sme_offers_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  subcontracting_percent_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontractor_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  subcontractor_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subcontractor_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  subcontractor_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submission_deadline_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  submission_deadline_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submission_deadline_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  submission_deadline_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  tender_id_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  title_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  title_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_bgn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_flag_reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_flag_reason_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_flag_reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  value_flag_reason_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_ratio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  winner_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenderPublishedAlsoInRelationship = {
  __typename?: 'TenderPublishedAlsoInRelationship';
  cursor: Scalars['String']['output'];
  node: Tender;
};

/** Fields to sort Tenders by. The order in which sorts are applied is not guaranteed when specifying many fields in one TenderSort object. */
export type TenderSort = {
  award_method?: InputMaybe<SortDirection>;
  awarded_amount?: InputMaybe<SortDirection>;
  awarded_total_bgn?: InputMaybe<SortDirection>;
  buyer_activity?: InputMaybe<SortDirection>;
  buyer_type?: InputMaybe<SortDirection>;
  contract_type?: InputMaybe<SortDirection>;
  cpv_code?: InputMaybe<SortDirection>;
  cpv_description?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  direct_award_justification?: InputMaybe<SortDirection>;
  disqualified_offers_count?: InputMaybe<SortDirection>;
  duplicate_of?: InputMaybe<SortDirection>;
  estimated_value?: InputMaybe<SortDirection>;
  european_program?: InputMaybe<SortDirection>;
  execution_nuts?: InputMaybe<SortDirection>;
  has_subcontractors?: InputMaybe<SortDirection>;
  is_accelerated?: InputMaybe<SortDirection>;
  is_cancelled?: InputMaybe<SortDirection>;
  is_eu_funded?: InputMaybe<SortDirection>;
  is_framework?: InputMaybe<SortDirection>;
  is_green?: InputMaybe<SortDirection>;
  legal_basis?: InputMaybe<SortDirection>;
  link_to_ojeu?: InputMaybe<SortDirection>;
  lot_count?: InputMaybe<SortDirection>;
  offers_count?: InputMaybe<SortDirection>;
  procedure_type?: InputMaybe<SortDirection>;
  procuring_entity?: InputMaybe<SortDirection>;
  procuring_entity_uic?: InputMaybe<SortDirection>;
  publication_date?: InputMaybe<SortDirection>;
  sme_offers_count?: InputMaybe<SortDirection>;
  subcontracting_percent?: InputMaybe<SortDirection>;
  subcontractor_name?: InputMaybe<SortDirection>;
  submission_deadline?: InputMaybe<SortDirection>;
  tender_id?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  value_bgn?: InputMaybe<SortDirection>;
  value_excluded?: InputMaybe<SortDirection>;
  value_flag?: InputMaybe<SortDirection>;
  value_flag_reason?: InputMaybe<SortDirection>;
  value_ratio?: InputMaybe<SortDirection>;
  winner_count?: InputMaybe<SortDirection>;
};

export type TenderTenderAlsoPublishedAsAggregationSelection = {
  __typename?: 'TenderTenderAlsoPublishedAsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenderTenderAlsoPublishedAsNodeAggregateSelection>;
};

export type TenderTenderAlsoPublishedAsNodeAggregateSelection = {
  __typename?: 'TenderTenderAlsoPublishedAsNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type TenderTenderPublishedAlsoInAggregationSelection = {
  __typename?: 'TenderTenderPublishedAlsoInAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenderTenderPublishedAlsoInNodeAggregateSelection>;
};

export type TenderTenderPublishedAlsoInNodeAggregateSelection = {
  __typename?: 'TenderTenderPublishedAlsoInNodeAggregateSelection';
  award_method: StringAggregateSelection;
  awarded_amount: FloatAggregateSelection;
  awarded_total_bgn: FloatAggregateSelection;
  buyer_activity: StringAggregateSelection;
  buyer_type: StringAggregateSelection;
  contract_type: StringAggregateSelection;
  cpv_code: StringAggregateSelection;
  cpv_description: StringAggregateSelection;
  currency: StringAggregateSelection;
  direct_award_justification: StringAggregateSelection;
  disqualified_offers_count: IntAggregateSelection;
  duplicate_of: StringAggregateSelection;
  estimated_value: FloatAggregateSelection;
  european_program: StringAggregateSelection;
  execution_nuts: StringAggregateSelection;
  legal_basis: StringAggregateSelection;
  link_to_ojeu: StringAggregateSelection;
  lot_count: IntAggregateSelection;
  offers_count: IntAggregateSelection;
  procedure_type: StringAggregateSelection;
  procuring_entity: StringAggregateSelection;
  procuring_entity_uic: StringAggregateSelection;
  publication_date: StringAggregateSelection;
  sme_offers_count: IntAggregateSelection;
  subcontracting_percent: FloatAggregateSelection;
  subcontractor_name: StringAggregateSelection;
  submission_deadline: StringAggregateSelection;
  tender_id: IdAggregateSelection;
  title: StringAggregateSelection;
  value_bgn: FloatAggregateSelection;
  value_flag: StringAggregateSelection;
  value_flag_reason: StringAggregateSelection;
  value_ratio: FloatAggregateSelection;
  winner_count: IntAggregateSelection;
};

export type TenderWhere = {
  AND?: InputMaybe<Array<TenderWhere>>;
  NOT?: InputMaybe<TenderWhere>;
  OR?: InputMaybe<Array<TenderWhere>>;
  /** @deprecated Use `alsoPublishedAs_SOME` instead. */
  alsoPublishedAs?: InputMaybe<TenderWhere>;
  alsoPublishedAsAggregate?: InputMaybe<TenderAlsoPublishedAsAggregateInput>;
  /** @deprecated Use `alsoPublishedAsConnection_SOME` instead. */
  alsoPublishedAsConnection?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** Return Tenders where all of the related TenderAlsoPublishedAsConnections match this filter */
  alsoPublishedAsConnection_ALL?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** Return Tenders where none of the related TenderAlsoPublishedAsConnections match this filter */
  alsoPublishedAsConnection_NONE?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** @deprecated Use `alsoPublishedAsConnection_NONE` instead. */
  alsoPublishedAsConnection_NOT?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** Return Tenders where one of the related TenderAlsoPublishedAsConnections match this filter */
  alsoPublishedAsConnection_SINGLE?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** Return Tenders where some of the related TenderAlsoPublishedAsConnections match this filter */
  alsoPublishedAsConnection_SOME?: InputMaybe<TenderAlsoPublishedAsConnectionWhere>;
  /** Return Tenders where all of the related Tenders match this filter */
  alsoPublishedAs_ALL?: InputMaybe<TenderWhere>;
  /** Return Tenders where none of the related Tenders match this filter */
  alsoPublishedAs_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `alsoPublishedAs_NONE` instead. */
  alsoPublishedAs_NOT?: InputMaybe<TenderWhere>;
  /** Return Tenders where one of the related Tenders match this filter */
  alsoPublishedAs_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Tenders where some of the related Tenders match this filter */
  alsoPublishedAs_SOME?: InputMaybe<TenderWhere>;
  award_method?: InputMaybe<Scalars['String']['input']>;
  award_method_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  award_method_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  award_method_GT?: InputMaybe<Scalars['String']['input']>;
  award_method_GTE?: InputMaybe<Scalars['String']['input']>;
  award_method_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  award_method_LT?: InputMaybe<Scalars['String']['input']>;
  award_method_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  award_method_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  award_method_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  award_method_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  award_method_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  award_method_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  award_method_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  awarded_amount?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awarded_amount_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awarded_total_bgn?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awarded_total_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  awarded_total_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_total_bgn_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awarded_total_bgn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  buyer_activity?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_GT?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_GTE?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyer_activity_LT?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_activity_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_activity_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_activity_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_activity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_activity_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_activity_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_type?: InputMaybe<Scalars['String']['input']>;
  buyer_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  buyer_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_type_GT?: InputMaybe<Scalars['String']['input']>;
  buyer_type_GTE?: InputMaybe<Scalars['String']['input']>;
  buyer_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyer_type_LT?: InputMaybe<Scalars['String']['input']>;
  buyer_type_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_type_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_type_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_type_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_type_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `commissionedBy_SOME` instead. */
  commissionedBy?: InputMaybe<MunicipalityWhere>;
  commissionedByAggregate?: InputMaybe<TenderCommissionedByAggregateInput>;
  /** @deprecated Use `commissionedByConnection_SOME` instead. */
  commissionedByConnection?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** Return Tenders where all of the related TenderCommissionedByConnections match this filter */
  commissionedByConnection_ALL?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** Return Tenders where none of the related TenderCommissionedByConnections match this filter */
  commissionedByConnection_NONE?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** @deprecated Use `commissionedByConnection_NONE` instead. */
  commissionedByConnection_NOT?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** Return Tenders where one of the related TenderCommissionedByConnections match this filter */
  commissionedByConnection_SINGLE?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** Return Tenders where some of the related TenderCommissionedByConnections match this filter */
  commissionedByConnection_SOME?: InputMaybe<TenderCommissionedByConnectionWhere>;
  /** Return Tenders where all of the related Municipalities match this filter */
  commissionedBy_ALL?: InputMaybe<MunicipalityWhere>;
  /** Return Tenders where none of the related Municipalities match this filter */
  commissionedBy_NONE?: InputMaybe<MunicipalityWhere>;
  /** @deprecated Use `commissionedBy_NONE` instead. */
  commissionedBy_NOT?: InputMaybe<MunicipalityWhere>;
  /** Return Tenders where one of the related Municipalities match this filter */
  commissionedBy_SINGLE?: InputMaybe<MunicipalityWhere>;
  /** Return Tenders where some of the related Municipalities match this filter */
  commissionedBy_SOME?: InputMaybe<MunicipalityWhere>;
  contract_type?: InputMaybe<Scalars['String']['input']>;
  contract_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contract_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contract_type_GT?: InputMaybe<Scalars['String']['input']>;
  contract_type_GTE?: InputMaybe<Scalars['String']['input']>;
  contract_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contract_type_LT?: InputMaybe<Scalars['String']['input']>;
  contract_type_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_type_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_type_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_type_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contract_type_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contract_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_code?: InputMaybe<Scalars['String']['input']>;
  cpv_code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cpv_code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_code_GT?: InputMaybe<Scalars['String']['input']>;
  cpv_code_GTE?: InputMaybe<Scalars['String']['input']>;
  cpv_code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cpv_code_LT?: InputMaybe<Scalars['String']['input']>;
  cpv_code_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_code_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_code_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_code_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_code_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_description?: InputMaybe<Scalars['String']['input']>;
  cpv_description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cpv_description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_description_GT?: InputMaybe<Scalars['String']['input']>;
  cpv_description_GTE?: InputMaybe<Scalars['String']['input']>;
  cpv_description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cpv_description_LT?: InputMaybe<Scalars['String']['input']>;
  cpv_description_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  cpv_description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpv_description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_GT?: InputMaybe<Scalars['String']['input']>;
  currency_GTE?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_LT?: InputMaybe<Scalars['String']['input']>;
  currency_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_GT?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_GTE?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direct_award_justification_LT?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  direct_award_justification_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  direct_award_justification_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  direct_award_justification_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  direct_award_justification_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  direct_award_justification_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  direct_award_justification_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  disqualified_offers_count?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disqualified_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  disqualified_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  disqualified_offers_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  disqualified_offers_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duplicate_of?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_GT?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_GTE?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  duplicate_of_LT?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duplicate_of_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duplicate_of_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duplicate_of_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duplicate_of_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duplicate_of_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  duplicate_of_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  estimated_value?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_GT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  estimated_value_LT?: InputMaybe<Scalars['Float']['input']>;
  estimated_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  estimated_value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  estimated_value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  european_program?: InputMaybe<Scalars['String']['input']>;
  european_program_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  european_program_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  european_program_GT?: InputMaybe<Scalars['String']['input']>;
  european_program_GTE?: InputMaybe<Scalars['String']['input']>;
  european_program_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  european_program_LT?: InputMaybe<Scalars['String']['input']>;
  european_program_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  european_program_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  european_program_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  european_program_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  european_program_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  european_program_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  european_program_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  execution_nuts?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_GT?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_GTE?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  execution_nuts_LT?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  execution_nuts_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  execution_nuts_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  execution_nuts_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  execution_nuts_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  execution_nuts_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  execution_nuts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  has_subcontractors?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  has_subcontractors_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  is_accelerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_accelerated_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_cancelled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  is_eu_funded?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_eu_funded_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  is_framework?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_framework_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  is_green?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  is_green_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  legal_basis?: InputMaybe<Scalars['String']['input']>;
  legal_basis_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legal_basis_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legal_basis_GT?: InputMaybe<Scalars['String']['input']>;
  legal_basis_GTE?: InputMaybe<Scalars['String']['input']>;
  legal_basis_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legal_basis_LT?: InputMaybe<Scalars['String']['input']>;
  legal_basis_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_basis_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_basis_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_basis_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_basis_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  legal_basis_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  legal_basis_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_GT?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_GTE?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_to_ojeu_LT?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  link_to_ojeu_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  link_to_ojeu_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  link_to_ojeu_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  link_to_ojeu_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  link_to_ojeu_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_to_ojeu_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lot_count?: InputMaybe<Scalars['Int']['input']>;
  lot_count_GT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  lot_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lot_count_LT?: InputMaybe<Scalars['Int']['input']>;
  lot_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lot_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `lots_SOME` instead. */
  lots?: InputMaybe<LotWhere>;
  lotsAggregate?: InputMaybe<TenderLotsAggregateInput>;
  /** @deprecated Use `lotsConnection_SOME` instead. */
  lotsConnection?: InputMaybe<TenderLotsConnectionWhere>;
  /** Return Tenders where all of the related TenderLotsConnections match this filter */
  lotsConnection_ALL?: InputMaybe<TenderLotsConnectionWhere>;
  /** Return Tenders where none of the related TenderLotsConnections match this filter */
  lotsConnection_NONE?: InputMaybe<TenderLotsConnectionWhere>;
  /** @deprecated Use `lotsConnection_NONE` instead. */
  lotsConnection_NOT?: InputMaybe<TenderLotsConnectionWhere>;
  /** Return Tenders where one of the related TenderLotsConnections match this filter */
  lotsConnection_SINGLE?: InputMaybe<TenderLotsConnectionWhere>;
  /** Return Tenders where some of the related TenderLotsConnections match this filter */
  lotsConnection_SOME?: InputMaybe<TenderLotsConnectionWhere>;
  /** Return Tenders where all of the related Lots match this filter */
  lots_ALL?: InputMaybe<LotWhere>;
  /** Return Tenders where none of the related Lots match this filter */
  lots_NONE?: InputMaybe<LotWhere>;
  /** @deprecated Use `lots_NONE` instead. */
  lots_NOT?: InputMaybe<LotWhere>;
  /** Return Tenders where one of the related Lots match this filter */
  lots_SINGLE?: InputMaybe<LotWhere>;
  /** Return Tenders where some of the related Lots match this filter */
  lots_SOME?: InputMaybe<LotWhere>;
  offers_count?: InputMaybe<Scalars['Int']['input']>;
  offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  offers_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  offers_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  offers_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  procedure_type?: InputMaybe<Scalars['String']['input']>;
  procedure_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  procedure_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  procedure_type_GT?: InputMaybe<Scalars['String']['input']>;
  procedure_type_GTE?: InputMaybe<Scalars['String']['input']>;
  procedure_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedure_type_LT?: InputMaybe<Scalars['String']['input']>;
  procedure_type_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procedure_type_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procedure_type_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procedure_type_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procedure_type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procedure_type_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procedure_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `procuredBy_SOME` instead. */
  procuredBy?: InputMaybe<CompanyWhere>;
  procuredByAggregate?: InputMaybe<TenderProcuredByAggregateInput>;
  /** @deprecated Use `procuredByConnection_SOME` instead. */
  procuredByConnection?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** Return Tenders where all of the related TenderProcuredByConnections match this filter */
  procuredByConnection_ALL?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** Return Tenders where none of the related TenderProcuredByConnections match this filter */
  procuredByConnection_NONE?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** @deprecated Use `procuredByConnection_NONE` instead. */
  procuredByConnection_NOT?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** Return Tenders where one of the related TenderProcuredByConnections match this filter */
  procuredByConnection_SINGLE?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** Return Tenders where some of the related TenderProcuredByConnections match this filter */
  procuredByConnection_SOME?: InputMaybe<TenderProcuredByConnectionWhere>;
  /** Return Tenders where all of the related Companies match this filter */
  procuredBy_ALL?: InputMaybe<CompanyWhere>;
  /** Return Tenders where none of the related Companies match this filter */
  procuredBy_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `procuredBy_NONE` instead. */
  procuredBy_NOT?: InputMaybe<CompanyWhere>;
  /** Return Tenders where one of the related Companies match this filter */
  procuredBy_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Tenders where some of the related Companies match this filter */
  procuredBy_SOME?: InputMaybe<CompanyWhere>;
  procuring_entity?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_GT?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_GTE?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procuring_entity_LT?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_GT?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_GTE?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procuring_entity_uic_LT?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_uic_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_uic_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_uic_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_uic_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuring_entity_uic_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuring_entity_uic_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publication_date?: InputMaybe<Scalars['String']['input']>;
  publication_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  publication_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  publication_date_GT?: InputMaybe<Scalars['String']['input']>;
  publication_date_GTE?: InputMaybe<Scalars['String']['input']>;
  publication_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publication_date_LT?: InputMaybe<Scalars['String']['input']>;
  publication_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publication_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publication_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `publishedAlsoIn_SOME` instead. */
  publishedAlsoIn?: InputMaybe<TenderWhere>;
  publishedAlsoInAggregate?: InputMaybe<TenderPublishedAlsoInAggregateInput>;
  /** @deprecated Use `publishedAlsoInConnection_SOME` instead. */
  publishedAlsoInConnection?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** Return Tenders where all of the related TenderPublishedAlsoInConnections match this filter */
  publishedAlsoInConnection_ALL?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** Return Tenders where none of the related TenderPublishedAlsoInConnections match this filter */
  publishedAlsoInConnection_NONE?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** @deprecated Use `publishedAlsoInConnection_NONE` instead. */
  publishedAlsoInConnection_NOT?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** Return Tenders where one of the related TenderPublishedAlsoInConnections match this filter */
  publishedAlsoInConnection_SINGLE?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** Return Tenders where some of the related TenderPublishedAlsoInConnections match this filter */
  publishedAlsoInConnection_SOME?: InputMaybe<TenderPublishedAlsoInConnectionWhere>;
  /** Return Tenders where all of the related Tenders match this filter */
  publishedAlsoIn_ALL?: InputMaybe<TenderWhere>;
  /** Return Tenders where none of the related Tenders match this filter */
  publishedAlsoIn_NONE?: InputMaybe<TenderWhere>;
  /** @deprecated Use `publishedAlsoIn_NONE` instead. */
  publishedAlsoIn_NOT?: InputMaybe<TenderWhere>;
  /** Return Tenders where one of the related Tenders match this filter */
  publishedAlsoIn_SINGLE?: InputMaybe<TenderWhere>;
  /** Return Tenders where some of the related Tenders match this filter */
  publishedAlsoIn_SOME?: InputMaybe<TenderWhere>;
  sme_offers_count?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_GT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sme_offers_count_LT?: InputMaybe<Scalars['Int']['input']>;
  sme_offers_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sme_offers_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sme_offers_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subcontracting_percent?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_GT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_GTE?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  subcontracting_percent_LT?: InputMaybe<Scalars['Float']['input']>;
  subcontracting_percent_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontracting_percent_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontracting_percent_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  subcontractor_name?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_GT?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_GTE?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcontractor_name_LT?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontractor_name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontractor_name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontractor_name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontractor_name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subcontractor_name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subcontractor_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  submission_deadline?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_GT?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_GTE?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submission_deadline_LT?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  submission_deadline_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  submission_deadline_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  submission_deadline_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  submission_deadline_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  submission_deadline_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  submission_deadline_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tender_id?: InputMaybe<Scalars['ID']['input']>;
  tender_id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tender_id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tender_id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_id_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_id_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_id_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_id_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tender_id_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tender_id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_GT?: InputMaybe<Scalars['String']['input']>;
  title_GTE?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_LT?: InputMaybe<Scalars['String']['input']>;
  title_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_bgn?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  value_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_bgn_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_bgn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_excluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_excluded_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  value_flag?: InputMaybe<Scalars['String']['input']>;
  value_flag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_flag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_flag_GT?: InputMaybe<Scalars['String']['input']>;
  value_flag_GTE?: InputMaybe<Scalars['String']['input']>;
  value_flag_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_flag_LT?: InputMaybe<Scalars['String']['input']>;
  value_flag_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_flag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_GT?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_GTE?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_flag_reason_LT?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_reason_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_reason_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_reason_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_reason_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_flag_reason_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_flag_reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_ratio?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  value_ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_ratio_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_ratio_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  winner_count?: InputMaybe<Scalars['Int']['input']>;
  winner_count_GT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  winner_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  winner_count_LT?: InputMaybe<Scalars['Int']['input']>;
  winner_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  winner_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  winner_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `winners_SOME` instead. */
  winners?: InputMaybe<CompanyWhere>;
  winnersAggregate?: InputMaybe<TenderWinnersAggregateInput>;
  /** @deprecated Use `winnersConnection_SOME` instead. */
  winnersConnection?: InputMaybe<TenderWinnersConnectionWhere>;
  /** Return Tenders where all of the related TenderWinnersConnections match this filter */
  winnersConnection_ALL?: InputMaybe<TenderWinnersConnectionWhere>;
  /** Return Tenders where none of the related TenderWinnersConnections match this filter */
  winnersConnection_NONE?: InputMaybe<TenderWinnersConnectionWhere>;
  /** @deprecated Use `winnersConnection_NONE` instead. */
  winnersConnection_NOT?: InputMaybe<TenderWinnersConnectionWhere>;
  /** Return Tenders where one of the related TenderWinnersConnections match this filter */
  winnersConnection_SINGLE?: InputMaybe<TenderWinnersConnectionWhere>;
  /** Return Tenders where some of the related TenderWinnersConnections match this filter */
  winnersConnection_SOME?: InputMaybe<TenderWinnersConnectionWhere>;
  /** Return Tenders where all of the related Companies match this filter */
  winners_ALL?: InputMaybe<CompanyWhere>;
  /** Return Tenders where none of the related Companies match this filter */
  winners_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `winners_NONE` instead. */
  winners_NOT?: InputMaybe<CompanyWhere>;
  /** Return Tenders where one of the related Companies match this filter */
  winners_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return Tenders where some of the related Companies match this filter */
  winners_SOME?: InputMaybe<CompanyWhere>;
};

export type TenderWinnersAggregateInput = {
  AND?: InputMaybe<Array<TenderWinnersAggregateInput>>;
  NOT?: InputMaybe<TenderWinnersAggregateInput>;
  OR?: InputMaybe<Array<TenderWinnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AwardAggregationWhereInput>;
  node?: InputMaybe<TenderWinnersNodeAggregationWhereInput>;
};

export type TenderWinnersConnection = {
  __typename?: 'TenderWinnersConnection';
  edges: Array<TenderWinnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenderWinnersConnectionSort = {
  edge?: InputMaybe<AwardSort>;
  node?: InputMaybe<CompanySort>;
};

export type TenderWinnersConnectionWhere = {
  AND?: InputMaybe<Array<TenderWinnersConnectionWhere>>;
  NOT?: InputMaybe<TenderWinnersConnectionWhere>;
  OR?: InputMaybe<Array<TenderWinnersConnectionWhere>>;
  edge?: InputMaybe<AwardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<AwardWhere>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type TenderWinnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenderWinnersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenderWinnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenderWinnersNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type TenderWinnersRelationship = {
  __typename?: 'TenderWinnersRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
  properties: Award;
};

export type TendersConnection = {
  __typename?: 'TendersConnection';
  edges: Array<TenderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreasuryPayment = {
  __typename?: 'TreasuryPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_bgn?: Maybe<Scalars['Float']['output']>;
  amount_eur?: Maybe<Scalars['Float']['output']>;
  as_of?: Maybe<Scalars['String']['output']>;
  breakdown_complete?: Maybe<Scalars['Boolean']['output']>;
  first_date?: Maybe<Scalars['String']['output']>;
  last_date?: Maybe<Scalars['String']['output']>;
  match_type?: Maybe<Scalars['String']['output']>;
  payer_amounts?: Maybe<Array<Scalars['Float']['output']>>;
  payer_codes?: Maybe<Array<Scalars['String']['output']>>;
  payer_counts?: Maybe<Array<Scalars['Int']['output']>>;
  payer_names?: Maybe<Array<Scalars['String']['output']>>;
  payment_count?: Maybe<Scalars['Int']['output']>;
  payment_id: Scalars['ID']['output'];
  recipients: Array<Company>;
  recipientsAggregate?: Maybe<TreasuryPaymentCompanyRecipientsAggregationSelection>;
  recipientsConnection: TreasuryPaymentRecipientsConnection;
  source?: Maybe<Scalars['String']['output']>;
};


export type TreasuryPaymentRecipientsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type TreasuryPaymentRecipientsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyWhere>;
};


export type TreasuryPaymentRecipientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreasuryPaymentRecipientsConnectionSort>>;
  where?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
};

export type TreasuryPaymentAggregateSelection = {
  __typename?: 'TreasuryPaymentAggregateSelection';
  amount: FloatAggregateSelection;
  amount_bgn: FloatAggregateSelection;
  amount_eur: FloatAggregateSelection;
  as_of: StringAggregateSelection;
  count: Scalars['Int']['output'];
  first_date: StringAggregateSelection;
  last_date: StringAggregateSelection;
  match_type: StringAggregateSelection;
  payment_count: IntAggregateSelection;
  payment_id: IdAggregateSelection;
  source: StringAggregateSelection;
};

export type TreasuryPaymentCompanyRecipientsAggregationSelection = {
  __typename?: 'TreasuryPaymentCompanyRecipientsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreasuryPaymentCompanyRecipientsNodeAggregateSelection>;
};

export type TreasuryPaymentCompanyRecipientsNodeAggregateSelection = {
  __typename?: 'TreasuryPaymentCompanyRecipientsNodeAggregateSelection';
  legal_form: StringAggregateSelection;
  name: StringAggregateSelection;
  portfolio: StringAggregateSelection;
  sig_award_value: FloatAggregateSelection;
  sig_awards: IntAggregateSelection;
  sig_buyers: IntAggregateSelection;
  sig_cobidder_buyers: IntAggregateSelection;
  sig_cobidders: IntAggregateSelection;
  sig_computed_at: StringAggregateSelection;
  sig_direct_award: IntAggregateSelection;
  sig_direct_award_value: FloatAggregateSelection;
  sig_flagged_awards: IntAggregateSelection;
  sig_flagged_value: FloatAggregateSelection;
  sig_holdings_undated: IntAggregateSelection;
  sig_mandate_awards: IntAggregateSelection;
  sig_mandate_officials: IntAggregateSelection;
  sig_mandate_value: FloatAggregateSelection;
  sig_party_value: FloatAggregateSelection;
  sig_restricted: IntAggregateSelection;
  sig_shared_awards: IntAggregateSelection;
  sig_single_bid: IntAggregateSelection;
  sig_single_bid_value: FloatAggregateSelection;
  sig_subcontracted: IntAggregateSelection;
  sig_top_buyer_key: IdAggregateSelection;
  sig_top_buyer_name: StringAggregateSelection;
  sig_top_buyer_share: FloatAggregateSelection;
  sig_top_buyer_total: FloatAggregateSelection;
  sig_top_buyer_value: FloatAggregateSelection;
  sig_top_party_awards: IntAggregateSelection;
  sig_top_party_key: IdAggregateSelection;
  sig_top_party_name: StringAggregateSelection;
  sig_top_party_share: FloatAggregateSelection;
  sig_top_party_value: FloatAggregateSelection;
  status: StringAggregateSelection;
  uic: IdAggregateSelection;
};

export type TreasuryPaymentEdge = {
  __typename?: 'TreasuryPaymentEdge';
  cursor: Scalars['String']['output'];
  node: TreasuryPayment;
};

export type TreasuryPaymentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreasuryPaymentSort objects to sort TreasuryPayments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreasuryPaymentSort>>;
};

export type TreasuryPaymentRecipientsAggregateInput = {
  AND?: InputMaybe<Array<TreasuryPaymentRecipientsAggregateInput>>;
  NOT?: InputMaybe<TreasuryPaymentRecipientsAggregateInput>;
  OR?: InputMaybe<Array<TreasuryPaymentRecipientsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreasuryPaymentRecipientsNodeAggregationWhereInput>;
};

export type TreasuryPaymentRecipientsConnection = {
  __typename?: 'TreasuryPaymentRecipientsConnection';
  edges: Array<TreasuryPaymentRecipientsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreasuryPaymentRecipientsConnectionSort = {
  node?: InputMaybe<CompanySort>;
};

export type TreasuryPaymentRecipientsConnectionWhere = {
  AND?: InputMaybe<Array<TreasuryPaymentRecipientsConnectionWhere>>;
  NOT?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  OR?: InputMaybe<Array<TreasuryPaymentRecipientsConnectionWhere>>;
  node?: InputMaybe<CompanyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CompanyWhere>;
};

export type TreasuryPaymentRecipientsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreasuryPaymentRecipientsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreasuryPaymentRecipientsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreasuryPaymentRecipientsNodeAggregationWhereInput>>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legal_form_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  legal_form_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legal_form_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  legal_form_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  portfolio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  portfolio_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  portfolio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  portfolio_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidder_buyers_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidder_buyers_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidder_buyers_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_cobidders_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_cobidders_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_cobidders_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_computed_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_computed_at_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_computed_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_computed_at_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_direct_award_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_direct_award_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_direct_award_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_flagged_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_flagged_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_flagged_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_holdings_undated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_holdings_undated_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_holdings_undated_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_officials_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_officials_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_officials_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_mandate_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_mandate_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_mandate_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_restricted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_restricted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_restricted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_shared_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_shared_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_shared_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_single_bid_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_single_bid_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_single_bid_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_subcontracted_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_subcontracted_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_subcontracted_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_buyer_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_buyer_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_total_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_total_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_buyer_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_buyer_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_awards_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_awards_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_awards_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_key_EQUAL?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_name_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  sig_top_party_name_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  sig_top_party_share_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_share_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_share_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_GTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  sig_top_party_value_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sig_top_party_value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_EQUAL?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_GTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_LONGEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  status_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Please use the explicit _LENGTH version for string aggregation. */
  status_SHORTEST_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Aggregation filters that are not relying on an aggregating function will be deprecated. */
  uic_EQUAL?: InputMaybe<Scalars['ID']['input']>;
};

export type TreasuryPaymentRecipientsRelationship = {
  __typename?: 'TreasuryPaymentRecipientsRelationship';
  cursor: Scalars['String']['output'];
  node: Company;
};

/** Fields to sort TreasuryPayments by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreasuryPaymentSort object. */
export type TreasuryPaymentSort = {
  amount?: InputMaybe<SortDirection>;
  amount_bgn?: InputMaybe<SortDirection>;
  amount_eur?: InputMaybe<SortDirection>;
  as_of?: InputMaybe<SortDirection>;
  breakdown_complete?: InputMaybe<SortDirection>;
  first_date?: InputMaybe<SortDirection>;
  last_date?: InputMaybe<SortDirection>;
  match_type?: InputMaybe<SortDirection>;
  payment_count?: InputMaybe<SortDirection>;
  payment_id?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
};

export type TreasuryPaymentWhere = {
  AND?: InputMaybe<Array<TreasuryPaymentWhere>>;
  NOT?: InputMaybe<TreasuryPaymentWhere>;
  OR?: InputMaybe<Array<TreasuryPaymentWhere>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_bgn?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_bgn_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_bgn_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_bgn_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_bgn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_eur?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_eur_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_eur_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_eur_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  amount_eur_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  as_of?: InputMaybe<Scalars['String']['input']>;
  as_of_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  as_of_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  as_of_GT?: InputMaybe<Scalars['String']['input']>;
  as_of_GTE?: InputMaybe<Scalars['String']['input']>;
  as_of_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  as_of_LT?: InputMaybe<Scalars['String']['input']>;
  as_of_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  as_of_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  as_of_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  breakdown_complete?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  breakdown_complete_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  first_date?: InputMaybe<Scalars['String']['input']>;
  first_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  first_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  first_date_GT?: InputMaybe<Scalars['String']['input']>;
  first_date_GTE?: InputMaybe<Scalars['String']['input']>;
  first_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first_date_LT?: InputMaybe<Scalars['String']['input']>;
  first_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  first_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  first_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  first_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  first_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  first_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  first_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_date?: InputMaybe<Scalars['String']['input']>;
  last_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  last_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_date_GT?: InputMaybe<Scalars['String']['input']>;
  last_date_GTE?: InputMaybe<Scalars['String']['input']>;
  last_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_date_LT?: InputMaybe<Scalars['String']['input']>;
  last_date_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  last_date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  last_date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  last_date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  last_date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  last_date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  match_type?: InputMaybe<Scalars['String']['input']>;
  match_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  match_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  match_type_GT?: InputMaybe<Scalars['String']['input']>;
  match_type_GTE?: InputMaybe<Scalars['String']['input']>;
  match_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  match_type_LT?: InputMaybe<Scalars['String']['input']>;
  match_type_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  match_type_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  match_type_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  match_type_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  match_type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  match_type_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  match_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  payer_amounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  payer_amounts_INCLUDES?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_amounts_NOT?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_amounts_NOT_INCLUDES?: InputMaybe<Scalars['Float']['input']>;
  payer_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  payer_codes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_codes_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_codes_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  payer_counts?: InputMaybe<Array<Scalars['Int']['input']>>;
  payer_counts_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_counts_NOT?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_counts_NOT_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  payer_names?: InputMaybe<Array<Scalars['String']['input']>>;
  payer_names_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_names_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payer_names_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  payment_count?: InputMaybe<Scalars['Int']['input']>;
  payment_count_GT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  payment_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payment_count_LT?: InputMaybe<Scalars['Int']['input']>;
  payment_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payment_id?: InputMaybe<Scalars['ID']['input']>;
  payment_id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  payment_id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  payment_id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_id_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_id_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_id_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_id_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  payment_id_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  payment_id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `recipients_SOME` instead. */
  recipients?: InputMaybe<CompanyWhere>;
  recipientsAggregate?: InputMaybe<TreasuryPaymentRecipientsAggregateInput>;
  /** @deprecated Use `recipientsConnection_SOME` instead. */
  recipientsConnection?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** Return TreasuryPayments where all of the related TreasuryPaymentRecipientsConnections match this filter */
  recipientsConnection_ALL?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** Return TreasuryPayments where none of the related TreasuryPaymentRecipientsConnections match this filter */
  recipientsConnection_NONE?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** @deprecated Use `recipientsConnection_NONE` instead. */
  recipientsConnection_NOT?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** Return TreasuryPayments where one of the related TreasuryPaymentRecipientsConnections match this filter */
  recipientsConnection_SINGLE?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** Return TreasuryPayments where some of the related TreasuryPaymentRecipientsConnections match this filter */
  recipientsConnection_SOME?: InputMaybe<TreasuryPaymentRecipientsConnectionWhere>;
  /** Return TreasuryPayments where all of the related Companies match this filter */
  recipients_ALL?: InputMaybe<CompanyWhere>;
  /** Return TreasuryPayments where none of the related Companies match this filter */
  recipients_NONE?: InputMaybe<CompanyWhere>;
  /** @deprecated Use `recipients_NONE` instead. */
  recipients_NOT?: InputMaybe<CompanyWhere>;
  /** Return TreasuryPayments where one of the related Companies match this filter */
  recipients_SINGLE?: InputMaybe<CompanyWhere>;
  /** Return TreasuryPayments where some of the related Companies match this filter */
  recipients_SOME?: InputMaybe<CompanyWhere>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_GT?: InputMaybe<Scalars['String']['input']>;
  source_GTE?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_LT?: InputMaybe<Scalars['String']['input']>;
  source_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  source_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TreasuryPaymentsConnection = {
  __typename?: 'TreasuryPaymentsConnection';
  edges: Array<TreasuryPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ValueObservation = {
  __typename?: 'ValueObservation';
  awardedAmount?: Maybe<Scalars['Float']['output']>;
  buyer?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  estimatedValue?: Maybe<Scalars['Float']['output']>;
  excluded: Scalars['Boolean']['output'];
  flag: Scalars['String']['output'];
  lotCount?: Maybe<Scalars['Int']['output']>;
  publicationDate?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  tenderId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  winnerCount?: Maybe<Scalars['Int']['output']>;
};

export type ValueObservationAggregateSelection = {
  __typename?: 'ValueObservationAggregateSelection';
  awardedAmount: FloatAggregateSelection;
  buyer: StringAggregateSelection;
  count: Scalars['Int']['output'];
  currency: StringAggregateSelection;
  estimatedValue: FloatAggregateSelection;
  flag: StringAggregateSelection;
  lotCount: IntAggregateSelection;
  publicationDate: StringAggregateSelection;
  ratio: FloatAggregateSelection;
  reason: StringAggregateSelection;
  tenderId: IdAggregateSelection;
  title: StringAggregateSelection;
  winnerCount: IntAggregateSelection;
};

export type ValueObservationEdge = {
  __typename?: 'ValueObservationEdge';
  cursor: Scalars['String']['output'];
  node: ValueObservation;
};

/** Fields to sort ValueObservations by. The order in which sorts are applied is not guaranteed when specifying many fields in one ValueObservationSort object. */
export type ValueObservationSort = {
  awardedAmount?: InputMaybe<SortDirection>;
  buyer?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  estimatedValue?: InputMaybe<SortDirection>;
  excluded?: InputMaybe<SortDirection>;
  flag?: InputMaybe<SortDirection>;
  lotCount?: InputMaybe<SortDirection>;
  publicationDate?: InputMaybe<SortDirection>;
  ratio?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  tenderId?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  winnerCount?: InputMaybe<SortDirection>;
};

export type ValueObservationWhere = {
  AND?: InputMaybe<Array<ValueObservationWhere>>;
  NOT?: InputMaybe<ValueObservationWhere>;
  OR?: InputMaybe<Array<ValueObservationWhere>>;
  awardedAmount?: InputMaybe<Scalars['Float']['input']>;
  awardedAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  awardedAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  awardedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  awardedAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  awardedAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awardedAmount_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  awardedAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  buyer?: InputMaybe<Scalars['String']['input']>;
  buyer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  buyer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_GT?: InputMaybe<Scalars['String']['input']>;
  buyer_GTE?: InputMaybe<Scalars['String']['input']>;
  buyer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyer_LT?: InputMaybe<Scalars['String']['input']>;
  buyer_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  buyer_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  buyer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_GT?: InputMaybe<Scalars['String']['input']>;
  currency_GTE?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_LT?: InputMaybe<Scalars['String']['input']>;
  currency_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currency_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  estimatedValue?: InputMaybe<Scalars['Float']['input']>;
  estimatedValue_GT?: InputMaybe<Scalars['Float']['input']>;
  estimatedValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  estimatedValue_LT?: InputMaybe<Scalars['Float']['input']>;
  estimatedValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  estimatedValue_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  estimatedValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  excluded_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  flag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flag_GT?: InputMaybe<Scalars['String']['input']>;
  flag_GTE?: InputMaybe<Scalars['String']['input']>;
  flag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flag_LT?: InputMaybe<Scalars['String']['input']>;
  flag_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flag_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flag_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flag_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flag_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  flag_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  flag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lotCount?: InputMaybe<Scalars['Int']['input']>;
  lotCount_GT?: InputMaybe<Scalars['Int']['input']>;
  lotCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  lotCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lotCount_LT?: InputMaybe<Scalars['Int']['input']>;
  lotCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lotCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lotCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  publicationDate_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  publicationDate_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicationDate_GT?: InputMaybe<Scalars['String']['input']>;
  publicationDate_GTE?: InputMaybe<Scalars['String']['input']>;
  publicationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publicationDate_LT?: InputMaybe<Scalars['String']['input']>;
  publicationDate_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicationDate_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicationDate_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicationDate_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicationDate_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicationDate_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  ratio_GT?: InputMaybe<Scalars['Float']['input']>;
  ratio_GTE?: InputMaybe<Scalars['Float']['input']>;
  ratio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ratio_LT?: InputMaybe<Scalars['Float']['input']>;
  ratio_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ratio_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  ratio_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_GT?: InputMaybe<Scalars['String']['input']>;
  reason_GTE?: InputMaybe<Scalars['String']['input']>;
  reason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_LT?: InputMaybe<Scalars['String']['input']>;
  reason_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenderId?: InputMaybe<Scalars['ID']['input']>;
  tenderId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenderId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenderId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderId_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderId_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderId_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderId_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tenderId_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenderId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_GT?: InputMaybe<Scalars['String']['input']>;
  title_GTE?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_LT?: InputMaybe<Scalars['String']['input']>;
  title_LTE?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  winnerCount?: InputMaybe<Scalars['Int']['input']>;
  winnerCount_GT?: InputMaybe<Scalars['Int']['input']>;
  winnerCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  winnerCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  winnerCount_LT?: InputMaybe<Scalars['Int']['input']>;
  winnerCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  winnerCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  winnerCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ValueObservationsConnection = {
  __typename?: 'ValueObservationsConnection';
  edges: Array<ValueObservationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityMapForQueryVariables = Exact<{
  municipality?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  minMunicipalities: Scalars['Int']['input'];
  minValue: Scalars['Float']['input'];
}>;


export type ActivityMapForQuery = { __typename?: 'Query', activityMap?: { __typename?: 'ActivityMap', companies: number, truncated: boolean, blocks: Array<{ __typename?: 'ActivityBlock', uic: string, name?: string | null, municipalityKey: string, municipalityName?: string | null, province?: string | null, awards: number, value: number, mayor?: string | null, mayorHash?: string | null, party?: string | null, partyKey?: string | null, partyFamily?: string | null }>, partners: Array<{ __typename?: 'ActivityPartner', uic: string, name?: string | null, otherUic: string, otherName?: string | null, shared: number, value: number }> } | null };

export type CompanyCouncillorMatchesQueryVariables = Exact<{
  uic: Scalars['ID']['input'];
}>;


export type CompanyCouncillorMatchesQuery = { __typename?: 'Query', companyCouncillorMatches: Array<{ __typename?: 'CompanyCouncillorMatch', kind: string, role: string, personHash: string, name?: string | null, roles: Array<string>, councillorHash: string, councillorName?: string | null, municipality?: string | null, municipalityKey: string, electedYear: number, sitting: boolean, namesakes: number, awards: number, value: number }>, companyFamilyTies: Array<{ __typename?: 'CompanyCouncillorMatch', kind: string, role: string, personHash: string, name?: string | null, roles: Array<string>, councillorHash: string, councillorName?: string | null, municipality?: string | null, municipalityKey: string, electedYear: number, sitting: boolean, namesakes: number, awards: number, value: number }> };

export type CompanyDossierQueryVariables = Exact<{
  uic: Scalars['ID']['input'];
}>;


export type CompanyDossierQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', uic: string, name?: string | null, legal_form?: string | null, status?: string | null, sig_computed_at?: string | null, sig_awards?: number | null, sig_single_bid?: number | null, sig_single_bid_value?: number | null, sig_direct_award?: number | null, sig_direct_award_value?: number | null, sig_subcontracted?: number | null, sig_shared_awards?: number | null, sig_buyers?: number | null, sig_top_buyer_key?: string | null, sig_top_buyer_name?: string | null, sig_top_buyer_share?: number | null, sig_top_buyer_total?: number | null, sig_mandate_awards?: number | null, sig_mandate_value?: number | null, sig_mandate_officials?: number | null, sig_cobidders?: number | null, sig_holdings_undated?: number | null, seatedIn: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null }>, administers: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null }>, partOf: Array<{ __typename?: 'Company', uic: string, name?: string | null }>, units: Array<{ __typename?: 'Company', uic: string, name?: string | null }>, ownersConnection: { __typename?: 'CompanyOwnersConnection', edges: Array<{ __typename?: 'CompanyOwnersRelationship', properties: { __typename?: 'Ownership', share_percent?: number | null, share_amount?: number | null, share_currency?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null } }> }, managersConnection: { __typename?: 'CompanyManagersConnection', edges: Array<{ __typename?: 'CompanyManagersRelationship', properties: { __typename?: 'Management', role?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null } }> }, corporateOwnersConnection: { __typename?: 'CompanyCorporateOwnersConnection', edges: Array<{ __typename?: 'CompanyCorporateOwnersRelationship', properties: { __typename?: 'Ownership', share_percent?: number | null, share_amount?: number | null, share_currency?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Company', uic: string, name?: string | null } }> }, subsidiariesConnection: { __typename?: 'CompanySubsidiariesConnection', edges: Array<{ __typename?: 'CompanySubsidiariesRelationship', properties: { __typename?: 'Ownership', share_percent?: number | null, share_amount?: number | null, share_currency?: string | null }, node: { __typename?: 'Company', uic: string, name?: string | null } }> }, membershipsConnection: { __typename?: 'CompanyMembershipsConnection', edges: Array<{ __typename?: 'CompanyMembershipsRelationship', properties: { __typename?: 'Partnership', share_percent?: number | null, is_lead?: boolean | null }, node: { __typename?: 'Consortium', uic: string, name?: string | null } }> }, taxDebts: Array<{ __typename?: 'TaxDebtRecord', record_id: string, amount?: number | null, debt_type?: string | null, date?: string | null, resolved?: boolean | null }>, treasuryPayments: Array<{ __typename?: 'TreasuryPayment', payment_id: string, amount?: number | null, amount_bgn?: number | null, amount_eur?: number | null, payment_count?: number | null, first_date?: string | null, last_date?: string | null, match_type?: string | null, as_of?: string | null, breakdown_complete?: boolean | null, payer_names?: Array<string> | null, payer_amounts?: Array<number> | null, payer_counts?: Array<number> | null }> }>, tendersAggregate: { __typename?: 'TenderAggregateSelection', count: number, value_bgn: { __typename?: 'FloatAggregateSelection', sum?: number | null } }, procuredAggregate: { __typename?: 'TenderAggregateSelection', count: number, value_bgn: { __typename?: 'FloatAggregateSelection', sum?: number | null } }, subsidiesAggregate: { __typename?: 'SubsidyAggregateSelection', count: number, amount: { __typename?: 'FloatAggregateSelection', sum?: number | null } } };

export type PersonDossierQueryVariables = Exact<{
  hash: Scalars['ID']['input'];
}>;


export type PersonDossierQuery = { __typename?: 'Query', people: Array<{ __typename?: 'Person', person_hash: string, name?: string | null, ownedCompaniesConnection: { __typename?: 'PersonOwnedCompaniesConnection', edges: Array<{ __typename?: 'PersonOwnedCompaniesRelationship', properties: { __typename?: 'Ownership', share_percent?: number | null, share_amount?: number | null, share_currency?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Company', uic: string, name?: string | null, tendersWonAggregate?: { __typename?: 'CompanyTenderTendersWonAggregationSelection', count: number } | null } }> }, managedCompaniesConnection: { __typename?: 'PersonManagedCompaniesConnection', edges: Array<{ __typename?: 'PersonManagedCompaniesRelationship', properties: { __typename?: 'Management', role?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Company', uic: string, name?: string | null } }> }, mayorOfConnection: { __typename?: 'PersonMayorOfConnection', edges: Array<{ __typename?: 'PersonMayorOfRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null, elected_round?: number | null }, node: { __typename?: 'Municipality', key: string, name?: string | null, province?: string | null } }> }, positionsConnection: { __typename?: 'PersonPositionsConnection', edges: Array<{ __typename?: 'PersonPositionsRelationship', properties: { __typename?: 'Position', role?: string | null, area?: string | null, elected_year?: number | null, term_end?: number | null, list_letter?: string | null, preferences?: number | null, replaces?: string | null }, node: { __typename?: 'Municipality', key: string, name?: string | null, province?: string | null } }> }, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } }> };

export type PartyDossierQueryVariables = Exact<{
  key: Scalars['ID']['input'];
  familyKey: Scalars['String']['input'];
}>;


export type PartyDossierQuery = { __typename?: 'Query', electionYears: Array<number>, parties: Array<{ __typename?: 'Party', key: string, name?: string | null, family_key?: string | null, family_name?: string | null }>, family: Array<{ __typename?: 'Party', family_key?: string | null, family_name?: string | null }> };

export type PartyStructureQueryVariables = Exact<{
  key: Scalars['ID']['input'];
  family: Scalars['String']['input'];
}>;


export type PartyStructureQuery = { __typename?: 'Query', parties: Array<{ __typename?: 'Party', key: string, name?: string | null, memberOfConnection: { __typename?: 'PartyMemberOfConnection', edges: Array<{ __typename?: 'PartyMemberOfRelationship', properties: { __typename?: 'Membership', from_year?: number | null, to_year?: number | null, note?: string | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> }, membersConnection: { __typename?: 'PartyMembersConnection', edges: Array<{ __typename?: 'PartyMembersRelationship', properties: { __typename?: 'Membership', from_year?: number | null, to_year?: number | null, note?: string | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> }, succeededByConnection: { __typename?: 'PartySucceededByConnection', edges: Array<{ __typename?: 'PartySucceededByRelationship', properties: { __typename?: 'Succession', year?: number | null, note?: string | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> }, succeedsConnection: { __typename?: 'PartySucceedsConnection', edges: Array<{ __typename?: 'PartySucceedsRelationship', properties: { __typename?: 'Succession', year?: number | null, note?: string | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } }> };

export type PartySuppliersForQueryVariables = Exact<{
  party?: InputMaybe<Scalars['ID']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PartySuppliersForQuery = { __typename?: 'Query', partyProcurement?: { __typename?: 'CompanyStat', name?: string | null, count?: number | null, total?: number | null, debt?: number | null } | null, partySuppliers: Array<{ __typename?: 'PartySupplier', uic: string, name?: string | null, awards: number, value: number, municipalities: number, shareOfParty: number, shareOfCompany?: number | null }> };

export type PartyCouncilsForQueryVariables = Exact<{
  party?: InputMaybe<Scalars['ID']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PartyCouncilsForQuery = { __typename?: 'Query', partyCouncils: Array<{ __typename?: 'PartyCouncil', municipality?: string | null, municipalityKey: string, province?: string | null, population: number, electedYear: number, party?: string | null, seats: number, councilSize: number, leads: boolean, majority: boolean, mayorIsOurs: boolean, mayorParty?: string | null, mayorIndependent: boolean }> };

export type PartyMayorsForQueryVariables = Exact<{
  party?: InputMaybe<Scalars['ID']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  withCoalitions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PartyMayorsForQuery = { __typename?: 'Query', partyMayors: Array<{ __typename?: 'PartyMayor', person_hash: string, name?: string | null, party?: string | null, municipality?: string | null, municipality_key: string, province?: string | null, population?: number | null, elected_year?: number | null, elected_round?: number | null, term_end?: number | null }> };

export type TenderDossierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TenderDossierQuery = { __typename?: 'Query', tenders: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null, procuring_entity?: string | null, cpv_code?: string | null, cpv_description?: string | null, publication_date?: string | null, awarded_amount?: number | null, currency?: string | null, winner_count?: number | null, lot_count?: number | null, awarded_total_bgn?: number | null, estimated_value?: number | null, value_bgn?: number | null, value_flag?: string | null, value_flag_reason?: string | null, value_ratio?: number | null, value_excluded?: boolean | null, duplicate_of?: string | null, procedure_type?: string | null, contract_type?: string | null, buyer_type?: string | null, buyer_activity?: string | null, award_method?: string | null, legal_basis?: string | null, is_eu_funded?: boolean | null, european_program?: string | null, is_framework?: boolean | null, is_accelerated?: boolean | null, is_green?: boolean | null, is_cancelled?: boolean | null, submission_deadline?: string | null, execution_nuts?: string | null, link_to_ojeu?: string | null, has_subcontractors?: boolean | null, subcontractor_name?: string | null, subcontracting_percent?: number | null, offers_count?: number | null, sme_offers_count?: number | null, disqualified_offers_count?: number | null, direct_award_justification?: string | null, alsoPublishedAs: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null }>, publishedAlsoIn: Array<{ __typename?: 'Tender', tender_id: string }>, lots: Array<{ __typename?: 'Lot', lot_key: string, lot_id?: string | null, contract_number?: string | null, awarded_amount?: number | null, currency?: string | null, winners: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }>, commissionedBy: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null, mayorsConnection: { __typename?: 'MunicipalityMayorsConnection', edges: Array<{ __typename?: 'MunicipalityMayorsRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null, elected_round?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> } }>, winnersConnection: { __typename?: 'TenderWinnersConnection', edges: Array<{ __typename?: 'TenderWinnersRelationship', properties: { __typename?: 'Award', awarded_amount?: number | null }, node: { __typename?: 'Company', uic: string, name?: string | null, taxDebtsAggregate?: { __typename?: 'CompanyTaxDebtRecordTaxDebtsAggregationSelection', count: number } | null, seatedIn: Array<{ __typename?: 'Municipality', key: string, name?: string | null }> } }> } }> };

export type GraphSeedQueryVariables = Exact<{
  uic?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<Scalars['ID']['input']>;
  municipality?: InputMaybe<Scalars['ID']['input']>;
  tender?: InputMaybe<Scalars['ID']['input']>;
  skipCompany: Scalars['Boolean']['input'];
  skipPerson: Scalars['Boolean']['input'];
  skipMunicipality: Scalars['Boolean']['input'];
  skipTender: Scalars['Boolean']['input'];
}>;


export type GraphSeedQuery = { __typename?: 'Query', companies?: Array<{ __typename?: 'Company', uic: string, name?: string | null, ownersConnection: { __typename?: 'CompanyOwnersConnection', edges: Array<{ __typename?: 'CompanyOwnersRelationship', properties: { __typename?: 'Ownership', share_percent?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null } }> }, managersConnection: { __typename?: 'CompanyManagersConnection', edges: Array<{ __typename?: 'CompanyManagersRelationship', properties: { __typename?: 'Management', role?: string | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null } }> }, memberships: Array<{ __typename?: 'Consortium', uic: string, name?: string | null }>, tendersWon: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null, awarded_amount?: number | null, currency?: string | null }>, subsidies: Array<{ __typename?: 'Subsidy', subsidy_id: string, measure?: string | null, amount?: number | null }>, taxDebts: Array<{ __typename?: 'TaxDebtRecord', record_id: string, amount?: number | null }>, seatedIn: Array<{ __typename?: 'Municipality', key: string, name?: string | null }> }>, people?: Array<{ __typename?: 'Person', person_hash: string, name?: string | null, ownedCompanies: Array<{ __typename?: 'Company', uic: string, name?: string | null }>, managedCompanies: Array<{ __typename?: 'Company', uic: string, name?: string | null }>, mayorOfConnection: { __typename?: 'PersonMayorOfConnection', edges: Array<{ __typename?: 'PersonMayorOfRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null }, node: { __typename?: 'Municipality', key: string, name?: string | null } }> }, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } }>, municipalities?: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null, officeHoldersConnection: { __typename?: 'MunicipalityOfficeHoldersConnection', edges: Array<{ __typename?: 'MunicipalityOfficeHoldersRelationship', properties: { __typename?: 'Position', elected_year?: number | null, term_end?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> }, mayorsConnection: { __typename?: 'MunicipalityMayorsConnection', edges: Array<{ __typename?: 'MunicipalityMayorsRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> }, administration: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }>, tenders?: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null, awarded_amount?: number | null, currency?: string | null, winners: Array<{ __typename?: 'Company', uic: string, name?: string | null }>, commissionedBy: Array<{ __typename?: 'Municipality', key: string, name?: string | null }> }> };

export type MinistriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MinistriesQuery = { __typename?: 'Query', ministries: Array<{ __typename?: 'Ministry', uic: string, name?: string | null, portfolio: string, tenders: number, value: number, units: number, unitTenders: number, unitValue: number, ministers: number, cabinets: number }> };

export type MinistryDossierQueryVariables = Exact<{
  uic: Scalars['ID']['input'];
}>;


export type MinistryDossierQuery = { __typename?: 'Query', ministries: Array<{ __typename?: 'Ministry', uic: string, name?: string | null, portfolio: string, tenders: number, value: number, units: number, unitTenders: number, unitValue: number, ministers: number, cabinets: number }>, ministerTerms: Array<{ __typename?: 'MinisterTerm', personHash: string, name?: string | null, portfolio: string, govId: string, validFrom?: string | null, validTo?: string | null, party?: string | null, verified: boolean }>, ministryUnits: Array<{ __typename?: 'MinistryUnit', uic: string, name?: string | null, tenders: number, value: number }> };

export type CouncilInterestQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type CouncilInterestQuery = { __typename?: 'Query', councilInterestLeads: Array<{ __typename?: 'CouncilInterestLead', councillorHash: string, councillorName?: string | null, electedYear?: number | null, sitting: boolean, uic: string, companyName?: string | null, legalForm?: string | null, roles: Array<string>, namesakes: number, awards: number, value: number }> };

export type MunicipalityDossierQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type MunicipalityDossierQuery = { __typename?: 'Query', municipalities: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null, ekatte?: string | null, population_permanent?: number | null, population_current?: number | null, population_as_of?: string | null, tendersAggregate?: { __typename?: 'MunicipalityTenderTendersAggregationSelection', count: number } | null, companiesAggregate?: { __typename?: 'MunicipalityCompanyCompaniesAggregationSelection', count: number } | null, mayorsConnection: { __typename?: 'MunicipalityMayorsConnection', edges: Array<{ __typename?: 'MunicipalityMayorsRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null, elected_round?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> }, villageMayors: { __typename?: 'MunicipalityOfficeHoldersConnection', edges: Array<{ __typename?: 'MunicipalityOfficeHoldersRelationship', properties: { __typename?: 'Position', role?: string | null, area?: string | null, elected_year?: number | null, term_end?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, company_links?: number | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> }, officeHoldersConnection: { __typename?: 'MunicipalityOfficeHoldersConnection', edges: Array<{ __typename?: 'MunicipalityOfficeHoldersRelationship', properties: { __typename?: 'Position', role?: string | null, area_code?: string | null, elected_year?: number | null, term_end?: number | null, list_letter?: string | null, preferences?: number | null, replaces?: string | null, replaces_office?: string | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, company_links?: number | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> }, administration: Array<{ __typename?: 'Company', uic: string, name?: string | null, legal_form?: string | null, status?: string | null, managersConnection: { __typename?: 'CompanyManagersConnection', edges: Array<{ __typename?: 'CompanyManagersRelationship', properties: { __typename?: 'Management', role?: string | null, valid_from?: string | null, valid_to?: string | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null } }> }, units: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }> }>, tendersAggregate: { __typename?: 'TenderAggregateSelection', count: number, value_bgn: { __typename?: 'FloatAggregateSelection', sum?: number | null } } };

export type PersonNetworkQueryVariables = Exact<{
  minFirms: Scalars['Int']['input'];
  minShared: Scalars['Int']['input'];
}>;


export type PersonNetworkQuery = { __typename?: 'Query', personNetwork?: { __typename?: 'PersonNetwork', minFirms: number, minShared: number, eligible: number, people: Array<{ __typename?: 'NetworkPerson', hash: string, name?: string | null, firms: number, tier: string, publicFirms: number }>, links: Array<{ __typename?: 'NetworkLink', source: string, target: string, shared: number, kind: string, companies: Array<string> }> } | null };

export type ObservationCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ObservationCountsQuery = { __typename?: 'Query', valueObservationCounts: Array<{ __typename?: 'FacetValue', value: string, count: number }>, dataIssueCounts: Array<{ __typename?: 'FacetValue', value: string, count: number }>, registerCoverage: { __typename?: 'RegisterCoverage', companies: number, known: number, pending: number, outsideRegister: number, beneficialOwners: number, encumbrances: number, maskedParties: number, checkedThrough?: string | null } };

export type ValueObservationsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  flag?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValueObservationsQuery = { __typename?: 'Query', valueObservations: Array<{ __typename?: 'ValueObservation', tenderId: string, title?: string | null, buyer?: string | null, publicationDate?: string | null, estimatedValue?: number | null, awardedAmount?: number | null, currency?: string | null, ratio?: number | null, flag: string, reason?: string | null, excluded: boolean, lotCount?: number | null, winnerCount?: number | null }> };

export type DataIssuesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type DataIssuesQuery = { __typename?: 'Query', dataIssues: Array<{ __typename?: 'DataIssue', source: string, recordId?: string | null, value?: string | null, reason: string, lastSeen?: string | null }> };

export type OverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewQuery = { __typename?: 'Query', companiesAggregate: { __typename?: 'CompanyAggregateSelection', count: number }, peopleAggregate: { __typename?: 'PersonAggregateSelection', count: number }, tendersAggregate: { __typename?: 'TenderAggregateSelection', count: number, value_bgn: { __typename?: 'FloatAggregateSelection', sum?: number | null } }, subsidiesAggregate: { __typename?: 'SubsidyAggregateSelection', count: number, amount: { __typename?: 'FloatAggregateSelection', sum?: number | null } }, municipalitiesAggregate: { __typename?: 'MunicipalityAggregateSelection', count: number }, partiesAggregate: { __typename?: 'PartyAggregateSelection', count: number }, taxDebtRecordsAggregate: { __typename?: 'TaxDebtRecordAggregateSelection', count: number }, riskOverlap: Array<{ __typename?: 'CompanyStat', uic: string, name?: string | null, total?: number | null, debt?: number | null }>, topTenderWinners: Array<{ __typename?: 'CompanyStat', uic: string, name?: string | null, count?: number | null, total?: number | null }>, topSubsidyRecipients: Array<{ __typename?: 'CompanyStat', uic: string, name?: string | null, count?: number | null, total?: number | null }>, municipalityProcurement: Array<{ __typename?: 'MunicipalityStat', key: string, name?: string | null, province?: string | null, population?: number | null, mayor?: string | null, party?: string | null, partyKey?: string | null, tenderCount?: number | null, tenderTotal?: number | null }> };

export type PartyStatsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  grouped: Scalars['Boolean']['input'];
  electionYear?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartyStatsQuery = { __typename?: 'Query', electionYears: Array<number>, partyStats: Array<{ __typename?: 'PartyStat', key: string, name: string, isFamily: boolean, banners: number, mayors: number, municipalities: number, councilSeats: number, councils: number, councilsLed: number, councilsWithMajority: number, currentMunicipalities: number, awards: number, value: number, ministries: number, governmentAwards: number, governmentValue: number }>, partyStatCounts: Array<{ __typename?: 'FacetValue', value: string, count: number }> };

export type GlobalSearchQueryVariables = Exact<{
  q: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type GlobalSearchQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', uic: string, name?: string | null, legal_form?: string | null }>, people: Array<{ __typename?: 'Person', person_hash: string, name?: string | null }>, municipalities: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null }>, tenders: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null, awarded_amount?: number | null, currency?: string | null }>, parties: Array<{ __typename?: 'Party', key: string, name?: string | null }> };

export type SignalSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalSummaryQuery = { __typename?: 'Query', signalsComputedAt?: string | null, signalSummary: Array<{ __typename?: 'FacetValue', value: string, count: number }> };

export type SignalYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalYearsQuery = { __typename?: 'Query', signalYears: Array<number> };

export type SignalLeadsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  flags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  minShare: Scalars['Float']['input'];
  minFlaggedValue: Scalars['Float']['input'];
  sort: Scalars['String']['input'];
  dir: Scalars['String']['input'];
}>;


export type SignalLeadsQuery = { __typename?: 'Query', signalLeadCount: number, signalLeads: Array<{ __typename?: 'SignalLead', uic: string, name?: string | null, awards: number, awardValue: number, singleBid: number, singleBidValue: number, directAward: number, directAwardValue: number, subcontracted: number, sharedAwards: number, buyers: number, topBuyerKey?: string | null, topBuyerName?: string | null, topBuyerShare?: number | null, topBuyerValue?: number | null, topBuyerTotal?: number | null, mandateAwards: number, mandateValue: number, mandateOfficials: number, cobidders: number, councilInterest: number, councilInterestValue: number, councilInterestNamesakes: number, holdingsUndated: number, topPartyKey?: string | null, topPartyName?: string | null, topPartyShare?: number | null, topPartyValue?: number | null, councilPartyKey?: string | null, councilPartyName?: string | null, councilPartyShare?: number | null, councilMajorityValue?: number | null, flaggedAwards: number, flaggedValue: number }> };

export type SubsidyDossierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubsidyDossierQuery = { __typename?: 'Query', subsidies: Array<{ __typename?: 'Subsidy', subsidy_id: string, measure?: string | null, project_title?: string | null, amount?: number | null, year?: number | null, source?: string | null, description?: string | null, status?: string | null, total_value?: number | null, paid_amount?: number | null, start_date?: string | null, end_date?: string | null, duration_months?: number | null, places?: Array<string> | null, beneficiaries: Array<{ __typename?: 'Company', uic: string, name?: string | null, legal_form?: string | null }> }> };

export type SubsidiesUnderMeasureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  measure: Scalars['String']['input'];
}>;


export type SubsidiesUnderMeasureQuery = { __typename?: 'Query', subsidies: Array<{ __typename?: 'Subsidy', subsidy_id: string, project_title?: string | null, amount?: number | null, year?: number | null, beneficiaries: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }>, subsidiesAggregate: { __typename?: 'SubsidyAggregateSelection', count: number, amount: { __typename?: 'FloatAggregateSelection', sum?: number | null } } };

export type TenderRowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<TenderWhere>;
  sort?: InputMaybe<Array<TenderSort> | TenderSort>;
}>;


export type TenderRowsQuery = { __typename?: 'Query', tenders: Array<{ __typename?: 'Tender', tender_id: string, title?: string | null, procuring_entity?: string | null, publication_date?: string | null, awarded_amount?: number | null, estimated_value?: number | null, value_bgn?: number | null, currency?: string | null, cpv_code?: string | null, cpv_description?: string | null, procedure_type?: string | null, winner_count?: number | null, lot_count?: number | null, offers_count?: number | null, is_eu_funded?: boolean | null, commissionedBy: Array<{ __typename?: 'Municipality', key: string, name?: string | null }>, procuredBy: Array<{ __typename?: 'Company', uic: string, name?: string | null, portfolio?: string | null }>, winners: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }>, tendersAggregate: { __typename?: 'TenderAggregateSelection', count: number } };

export type TenderFacetCountsQueryVariables = Exact<{
  filter?: InputMaybe<TenderFilter>;
}>;


export type TenderFacetCountsQuery = { __typename?: 'Query', tenderFacets: Array<{ __typename?: 'FacetGroup', key: string, values: Array<{ __typename?: 'FacetValue', value: string, count: number }> }> };

export type CompanyRowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<CompanyWhere>;
  sort?: InputMaybe<Array<CompanySort> | CompanySort>;
}>;


export type CompanyRowsQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', uic: string, name?: string | null, legal_form?: string | null, seatedIn: Array<{ __typename?: 'Municipality', key: string, name?: string | null }>, tendersWonAggregate?: { __typename?: 'CompanyTenderTendersWonAggregationSelection', count: number } | null, subsidiesAggregate?: { __typename?: 'CompanySubsidySubsidiesAggregationSelection', count: number } | null, taxDebtsAggregate?: { __typename?: 'CompanyTaxDebtRecordTaxDebtsAggregationSelection', count: number } | null, treasuryPayments: Array<{ __typename?: 'TreasuryPayment', amount?: number | null, payment_count?: number | null }> }>, companiesAggregate: { __typename?: 'CompanyAggregateSelection', count: number } };

export type CompanyFacetCountsQueryVariables = Exact<{
  filter?: InputMaybe<CompanyFilter>;
}>;


export type CompanyFacetCountsQuery = { __typename?: 'Query', companyFacets: Array<{ __typename?: 'FacetGroup', key: string, values: Array<{ __typename?: 'FacetValue', value: string, count: number }> }> };

export type PersonRowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<PersonWhere>;
  sort?: InputMaybe<Array<PersonSort> | PersonSort>;
}>;


export type PersonRowsQuery = { __typename?: 'Query', people: Array<{ __typename?: 'Person', person_hash: string, name?: string | null, company_links?: number | null, ownedCompaniesAggregate?: { __typename?: 'PersonCompanyOwnedCompaniesAggregationSelection', count: number } | null, managedCompaniesAggregate?: { __typename?: 'PersonCompanyManagedCompaniesAggregationSelection', count: number } | null, mayorOf: Array<{ __typename?: 'Municipality', key: string, name?: string | null }>, positionsConnection: { __typename?: 'PersonPositionsConnection', edges: Array<{ __typename?: 'PersonPositionsRelationship', properties: { __typename?: 'Position', role?: string | null, area?: string | null, elected_year?: number | null }, node: { __typename?: 'Municipality', key: string, name?: string | null } }> }, nominatedBy: Array<{ __typename?: 'Party', key: string, name?: string | null }> }>, peopleAggregate: { __typename?: 'PersonAggregateSelection', count: number } };

export type MunicipalityRowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<MunicipalityWhere>;
  sort?: InputMaybe<Array<MunicipalitySort> | MunicipalitySort>;
}>;


export type MunicipalityRowsQuery = { __typename?: 'Query', municipalities: Array<{ __typename?: 'Municipality', key: string, name?: string | null, province?: string | null, population_permanent?: number | null, tender_total_bgn?: number | null, spend_per_capita?: number | null, tendersAggregate?: { __typename?: 'MunicipalityTenderTendersAggregationSelection', count: number } | null, companiesAggregate?: { __typename?: 'MunicipalityCompanyCompaniesAggregationSelection', count: number } | null, mayorsConnection: { __typename?: 'MunicipalityMayorsConnection', edges: Array<{ __typename?: 'MunicipalityMayorsRelationship', properties: { __typename?: 'Mandate', elected_year?: number | null, term_end?: number | null, elected_round?: number | null }, node: { __typename?: 'Person', person_hash: string, name?: string | null, nominatedByConnection: { __typename?: 'PersonNominatedByConnection', edges: Array<{ __typename?: 'PersonNominatedByRelationship', properties: { __typename?: 'Nomination', election_year?: number | null }, node: { __typename?: 'Party', key: string, name?: string | null } }> } } }> } }>, municipalitiesAggregate: { __typename?: 'MunicipalityAggregateSelection', count: number } };

export type SubsidyRowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<SubsidyWhere>;
  sort?: InputMaybe<Array<SubsidySort> | SubsidySort>;
}>;


export type SubsidyRowsQuery = { __typename?: 'Query', subsidies: Array<{ __typename?: 'Subsidy', subsidy_id: string, measure?: string | null, project_title?: string | null, amount?: number | null, paid_amount?: number | null, status?: string | null, year?: number | null, source?: string | null, beneficiaries: Array<{ __typename?: 'Company', uic: string, name?: string | null }> }>, subsidiesAggregate: { __typename?: 'SubsidyAggregateSelection', count: number } };

export type PersonFacetCountsQueryVariables = Exact<{
  filter?: InputMaybe<PersonFilter>;
}>;


export type PersonFacetCountsQuery = { __typename?: 'Query', personFacets: Array<{ __typename?: 'FacetGroup', key: string, values: Array<{ __typename?: 'FacetValue', value: string, count: number }> }> };

export type MunicipalityFacetCountsQueryVariables = Exact<{
  filter?: InputMaybe<MunicipalityFilter>;
}>;


export type MunicipalityFacetCountsQuery = { __typename?: 'Query', municipalityFacets: Array<{ __typename?: 'FacetGroup', key: string, values: Array<{ __typename?: 'FacetValue', value: string, count: number }> }> };

export type SubsidyFacetCountsQueryVariables = Exact<{
  filter?: InputMaybe<SubsidyFilter>;
}>;


export type SubsidyFacetCountsQuery = { __typename?: 'Query', subsidyFacets: Array<{ __typename?: 'FacetGroup', key: string, values: Array<{ __typename?: 'FacetValue', value: string, count: number }> }> };


export const ActivityMapForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivityMapFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"municipality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"person"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minMunicipalities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"municipality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"municipality"}}},{"kind":"Argument","name":{"kind":"Name","value":"person"},"value":{"kind":"Variable","name":{"kind":"Name","value":"person"}}},{"kind":"Argument","name":{"kind":"Name","value":"company"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company"}}},{"kind":"Argument","name":{"kind":"Name","value":"minMunicipalities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minMunicipalities"}}},{"kind":"Argument","name":{"kind":"Name","value":"minValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"}},{"kind":"Field","name":{"kind":"Name","value":"truncated"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"municipalityKey"}},{"kind":"Field","name":{"kind":"Name","value":"municipalityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"mayor"}},{"kind":"Field","name":{"kind":"Name","value":"mayorHash"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"partyKey"}},{"kind":"Field","name":{"kind":"Name","value":"partyFamily"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherUic"}},{"kind":"Field","name":{"kind":"Name","value":"otherName"}},{"kind":"Field","name":{"kind":"Name","value":"shared"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityMapForQuery, ActivityMapForQueryVariables>;
export const CompanyCouncillorMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyCouncillorMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCouncillorMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"personHash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"councillorHash"}},{"kind":"Field","name":{"kind":"Name","value":"councillorName"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"municipalityKey"}},{"kind":"Field","name":{"kind":"Name","value":"electedYear"}},{"kind":"Field","name":{"kind":"Name","value":"sitting"}},{"kind":"Field","name":{"kind":"Name","value":"namesakes"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyFamilyTies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"personHash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"councillorHash"}},{"kind":"Field","name":{"kind":"Name","value":"councillorName"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"municipalityKey"}},{"kind":"Field","name":{"kind":"Name","value":"electedYear"}},{"kind":"Field","name":{"kind":"Name","value":"sitting"}},{"kind":"Field","name":{"kind":"Name","value":"namesakes"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CompanyCouncillorMatchesQuery, CompanyCouncillorMatchesQueryVariables>;
export const CompanyDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legal_form"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seatedIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}}]}},{"kind":"Field","name":{"kind":"Name","value":"administers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sig_computed_at"}},{"kind":"Field","name":{"kind":"Name","value":"sig_awards"}},{"kind":"Field","name":{"kind":"Name","value":"sig_single_bid"}},{"kind":"Field","name":{"kind":"Name","value":"sig_single_bid_value"}},{"kind":"Field","name":{"kind":"Name","value":"sig_direct_award"}},{"kind":"Field","name":{"kind":"Name","value":"sig_direct_award_value"}},{"kind":"Field","name":{"kind":"Name","value":"sig_subcontracted"}},{"kind":"Field","name":{"kind":"Name","value":"sig_shared_awards"}},{"kind":"Field","name":{"kind":"Name","value":"sig_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"sig_top_buyer_key"}},{"kind":"Field","name":{"kind":"Name","value":"sig_top_buyer_name"}},{"kind":"Field","name":{"kind":"Name","value":"sig_top_buyer_share"}},{"kind":"Field","name":{"kind":"Name","value":"sig_top_buyer_total"}},{"kind":"Field","name":{"kind":"Name","value":"sig_mandate_awards"}},{"kind":"Field","name":{"kind":"Name","value":"sig_mandate_value"}},{"kind":"Field","name":{"kind":"Name","value":"sig_mandate_officials"}},{"kind":"Field","name":{"kind":"Name","value":"sig_cobidders"}},{"kind":"Field","name":{"kind":"Name","value":"sig_holdings_undated"}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"share_amount"}},{"kind":"Field","name":{"kind":"Name","value":"share_currency"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"managersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporateOwnersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"share_amount"}},{"kind":"Field","name":{"kind":"Name","value":"share_currency"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiariesConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"share_amount"}},{"kind":"Field","name":{"kind":"Name","value":"share_currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"is_lead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDebts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"debt_type"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"resolved"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treasuryPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amount_bgn"}},{"kind":"Field","name":{"kind":"Name","value":"amount_eur"}},{"kind":"Field","name":{"kind":"Name","value":"payment_count"}},{"kind":"Field","name":{"kind":"Name","value":"first_date"}},{"kind":"Field","name":{"kind":"Name","value":"last_date"}},{"kind":"Field","name":{"kind":"Name","value":"match_type"}},{"kind":"Field","name":{"kind":"Name","value":"as_of"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown_complete"}},{"kind":"Field","name":{"kind":"Name","value":"payer_names"}},{"kind":"Field","name":{"kind":"Name","value":"payer_amounts"}},{"kind":"Field","name":{"kind":"Name","value":"payer_counts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"winners_SOME"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"procuredAggregate"},"name":{"kind":"Name","value":"tendersAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"procuredBy_SOME"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiaries_SOME"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyDossierQuery, CompanyDossierQueryVariables>;
export const PersonDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"person_hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownedCompaniesConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"share_amount"}},{"kind":"Field","name":{"kind":"Name","value":"share_currency"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tendersWonAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"managedCompaniesConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorOfConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"elected_round"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elected_year"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"list_letter"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"}},{"kind":"Field","name":{"kind":"Name","value":"replaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PersonDossierQuery, PersonDossierQueryVariables>;
export const PartyDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartyDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"familyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"family_key"}},{"kind":"Field","name":{"kind":"Name","value":"family_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"family"},"name":{"kind":"Name","value":"parties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"family_key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"familyKey"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family_key"}},{"kind":"Field","name":{"kind":"Name","value":"family_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"electionYears"}}]}}]} as unknown as DocumentNode<PartyDossierQuery, PartyDossierQueryVariables>;
export const PartyStructureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartyStructure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"family"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"family_key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"family"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberOfConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_year"}},{"kind":"Field","name":{"kind":"Name","value":"to_year"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_year"}},{"kind":"Field","name":{"kind":"Name","value":"to_year"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"succeededByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"succeedsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartyStructureQuery, PartyStructureQueryVariables>;
export const PartySuppliersForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartySuppliersFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"party"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"family"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partyProcurement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"party"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party"}}},{"kind":"Argument","name":{"kind":"Name","value":"family"},"value":{"kind":"Variable","name":{"kind":"Name","value":"family"}}},{"kind":"Argument","name":{"kind":"Name","value":"withCoalitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"debt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partySuppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"party"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party"}}},{"kind":"Argument","name":{"kind":"Name","value":"family"},"value":{"kind":"Variable","name":{"kind":"Name","value":"family"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"withCoalitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"municipalities"}},{"kind":"Field","name":{"kind":"Name","value":"shareOfParty"}},{"kind":"Field","name":{"kind":"Name","value":"shareOfCompany"}}]}}]}}]} as unknown as DocumentNode<PartySuppliersForQuery, PartySuppliersForQueryVariables>;
export const PartyCouncilsForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartyCouncilsFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"party"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"family"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partyCouncils"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"party"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party"}}},{"kind":"Argument","name":{"kind":"Name","value":"family"},"value":{"kind":"Variable","name":{"kind":"Name","value":"family"}}},{"kind":"Argument","name":{"kind":"Name","value":"electionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"withCoalitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"municipalityKey"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"electedYear"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"councilSize"}},{"kind":"Field","name":{"kind":"Name","value":"leads"}},{"kind":"Field","name":{"kind":"Name","value":"majority"}},{"kind":"Field","name":{"kind":"Name","value":"mayorIsOurs"}},{"kind":"Field","name":{"kind":"Name","value":"mayorParty"}},{"kind":"Field","name":{"kind":"Name","value":"mayorIndependent"}}]}}]}}]} as unknown as DocumentNode<PartyCouncilsForQuery, PartyCouncilsForQueryVariables>;
export const PartyMayorsForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartyMayorsFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"party"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"family"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partyMayors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"party"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party"}}},{"kind":"Argument","name":{"kind":"Name","value":"family"},"value":{"kind":"Variable","name":{"kind":"Name","value":"family"}}},{"kind":"Argument","name":{"kind":"Name","value":"electionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"withCoalitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withCoalitions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_key"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"elected_round"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}}]}}]}}]} as unknown as DocumentNode<PartyMayorsForQuery, PartyMayorsForQueryVariables>;
export const TenderDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenderDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tender_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"procuring_entity"}},{"kind":"Field","name":{"kind":"Name","value":"cpv_code"}},{"kind":"Field","name":{"kind":"Name","value":"cpv_description"}},{"kind":"Field","name":{"kind":"Name","value":"publication_date"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"winner_count"}},{"kind":"Field","name":{"kind":"Name","value":"lot_count"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_total_bgn"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"}},{"kind":"Field","name":{"kind":"Name","value":"value_flag"}},{"kind":"Field","name":{"kind":"Name","value":"value_flag_reason"}},{"kind":"Field","name":{"kind":"Name","value":"value_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"value_excluded"}},{"kind":"Field","name":{"kind":"Name","value":"duplicate_of"}},{"kind":"Field","name":{"kind":"Name","value":"alsoPublishedAs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAlsoIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"procedure_type"}},{"kind":"Field","name":{"kind":"Name","value":"contract_type"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_type"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_activity"}},{"kind":"Field","name":{"kind":"Name","value":"award_method"}},{"kind":"Field","name":{"kind":"Name","value":"legal_basis"}},{"kind":"Field","name":{"kind":"Name","value":"is_eu_funded"}},{"kind":"Field","name":{"kind":"Name","value":"european_program"}},{"kind":"Field","name":{"kind":"Name","value":"is_framework"}},{"kind":"Field","name":{"kind":"Name","value":"is_accelerated"}},{"kind":"Field","name":{"kind":"Name","value":"is_green"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"submission_deadline"}},{"kind":"Field","name":{"kind":"Name","value":"execution_nuts"}},{"kind":"Field","name":{"kind":"Name","value":"link_to_ojeu"}},{"kind":"Field","name":{"kind":"Name","value":"has_subcontractors"}},{"kind":"Field","name":{"kind":"Name","value":"subcontractor_name"}},{"kind":"Field","name":{"kind":"Name","value":"subcontracting_percent"}},{"kind":"Field","name":{"kind":"Name","value":"offers_count"}},{"kind":"Field","name":{"kind":"Name","value":"sme_offers_count"}},{"kind":"Field","name":{"kind":"Name","value":"disqualified_offers_count"}},{"kind":"Field","name":{"kind":"Name","value":"direct_award_justification"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_key"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_number"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"mayorsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"elected_round"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"winnersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxDebtsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatedIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenderDossierQuery, TenderDossierQueryVariables>;
export const GraphSeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GraphSeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"person"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"municipality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipCompany"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipPerson"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipMunicipality"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipTender"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipCompany"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share_percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"managersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersWon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidy_id"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDebts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatedIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"person_hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"person"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPerson"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownedCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managedCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorOfConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipalities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"municipality"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMunicipality"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"officeHoldersConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"StringValue","value":"общински съветник","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elected_year"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"administration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tender_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tender"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipTender"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GraphSeedQuery, GraphSeedQueryVariables>;
export const MinistriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Ministries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ministries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"}},{"kind":"Field","name":{"kind":"Name","value":"tenders"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"unitTenders"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"ministers"}},{"kind":"Field","name":{"kind":"Name","value":"cabinets"}}]}}]}}]} as unknown as DocumentNode<MinistriesQuery, MinistriesQueryVariables>;
export const MinistryDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MinistryDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ministries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"}},{"kind":"Field","name":{"kind":"Name","value":"tenders"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"unitTenders"}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"}},{"kind":"Field","name":{"kind":"Name","value":"ministers"}},{"kind":"Field","name":{"kind":"Name","value":"cabinets"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ministerTerms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personHash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"}},{"kind":"Field","name":{"kind":"Name","value":"govId"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ministryUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uic"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tenders"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<MinistryDossierQuery, MinistryDossierQueryVariables>;
export const CouncilInterestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CouncilInterest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"councilInterestLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"municipality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"councillorHash"}},{"kind":"Field","name":{"kind":"Name","value":"councillorName"}},{"kind":"Field","name":{"kind":"Name","value":"electedYear"}},{"kind":"Field","name":{"kind":"Name","value":"sitting"}},{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"namesakes"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CouncilInterestQuery, CouncilInterestQueryVariables>;
export const MunicipalityDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MunicipalityDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipalities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"ekatte"}},{"kind":"Field","name":{"kind":"Name","value":"population_permanent"}},{"kind":"Field","name":{"kind":"Name","value":"population_current"}},{"kind":"Field","name":{"kind":"Name","value":"population_as_of"}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"elected_round"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"villageMayors"},"name":{"kind":"Name","value":"officeHoldersConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"NOT"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"StringValue","value":"общински съветник","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elected_year"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company_links"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeHoldersConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"StringValue","value":"общински съветник","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elected_year"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"area_code"}},{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"list_letter"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"}},{"kind":"Field","name":{"kind":"Name","value":"replaces"}},{"kind":"Field","name":{"kind":"Name","value":"replaces_office"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company_links"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"administration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legal_form"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"managersConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"valid_to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"commissionedBy_SOME"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<MunicipalityDossierQuery, MunicipalityDossierQueryVariables>;
export const PersonNetworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonNetwork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minFirms"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minShared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personNetwork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minFirms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFirms"}}},{"kind":"Argument","name":{"kind":"Name","value":"minShared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minShared"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minFirms"}},{"kind":"Field","name":{"kind":"Name","value":"minShared"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"people"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firms"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"publicFirms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"shared"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"companies"}}]}}]}}]}}]} as unknown as DocumentNode<PersonNetworkQuery, PersonNetworkQueryVariables>;
export const ObservationCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ObservationCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueObservationCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataIssueCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registerCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"}},{"kind":"Field","name":{"kind":"Name","value":"known"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"outsideRegister"}},{"kind":"Field","name":{"kind":"Name","value":"beneficialOwners"}},{"kind":"Field","name":{"kind":"Name","value":"encumbrances"}},{"kind":"Field","name":{"kind":"Name","value":"maskedParties"}},{"kind":"Field","name":{"kind":"Name","value":"checkedThrough"}}]}}]}}]} as unknown as DocumentNode<ObservationCountsQuery, ObservationCountsQueryVariables>;
export const ValueObservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValueObservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueObservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flag"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenderId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"publicationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"awardedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"ratio"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"excluded"}},{"kind":"Field","name":{"kind":"Name","value":"lotCount"}},{"kind":"Field","name":{"kind":"Name","value":"winnerCount"}}]}}]}}]} as unknown as DocumentNode<ValueObservationsQuery, ValueObservationsQueryVariables>;
export const DataIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataIssues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]} as unknown as DocumentNode<DataIssuesQuery, DataIssuesQueryVariables>;
export const OverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public_funds"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peopleAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipalitiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDebtRecordsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskOverlap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"8"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"debt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topTenderWinners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topSubsidyRecipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipalityProcurement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"mayor"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"partyKey"}},{"kind":"Field","name":{"kind":"Name","value":"tenderCount"}},{"kind":"Field","name":{"kind":"Name","value":"tenderTotal"}}]}}]}}]} as unknown as DocumentNode<OverviewQuery, OverviewQueryVariables>;
export const PartyStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartyStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grouped"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"electionYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partyStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grouped"}}},{"kind":"Argument","name":{"kind":"Name","value":"electionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"electionYear"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isFamily"}},{"kind":"Field","name":{"kind":"Name","value":"banners"}},{"kind":"Field","name":{"kind":"Name","value":"mayors"}},{"kind":"Field","name":{"kind":"Name","value":"municipalities"}},{"kind":"Field","name":{"kind":"Name","value":"councilSeats"}},{"kind":"Field","name":{"kind":"Name","value":"councils"}},{"kind":"Field","name":{"kind":"Name","value":"councilsLed"}},{"kind":"Field","name":{"kind":"Name","value":"councilsWithMajority"}},{"kind":"Field","name":{"kind":"Name","value":"currentMunicipalities"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"ministries"}},{"kind":"Field","name":{"kind":"Name","value":"governmentAwards"}},{"kind":"Field","name":{"kind":"Name","value":"governmentValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partyStatCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"grouped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grouped"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"electionYears"}}]}}]} as unknown as DocumentNode<PartyStatsQuery, PartyStatsQueryVariables>;
export const GlobalSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uic_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legal_form"}}]}},{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipalities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tender_id_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name_CONTAINS"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"8"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const SignalSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignalSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signalSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signalsComputedAt"}}]}}]} as unknown as DocumentNode<SignalSummaryQuery, SignalSummaryQueryVariables>;
export const SignalYearsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignalYears"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signalYears"}}]}}]} as unknown as DocumentNode<SignalYearsQuery, SignalYearsQueryVariables>;
export const SignalLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignalLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minShare"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minFlaggedValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dir"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signalLeadCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"flags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flags"}}},{"kind":"Argument","name":{"kind":"Name","value":"minShare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minShare"}}},{"kind":"Argument","name":{"kind":"Name","value":"minFlaggedValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFlaggedValue"}}}]},{"kind":"Field","name":{"kind":"Name","value":"signalLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"flags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flags"}}},{"kind":"Argument","name":{"kind":"Name","value":"minShare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minShare"}}},{"kind":"Argument","name":{"kind":"Name","value":"minFlaggedValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFlaggedValue"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"dir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dir"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"awards"}},{"kind":"Field","name":{"kind":"Name","value":"awardValue"}},{"kind":"Field","name":{"kind":"Name","value":"singleBid"}},{"kind":"Field","name":{"kind":"Name","value":"singleBidValue"}},{"kind":"Field","name":{"kind":"Name","value":"directAward"}},{"kind":"Field","name":{"kind":"Name","value":"directAwardValue"}},{"kind":"Field","name":{"kind":"Name","value":"subcontracted"}},{"kind":"Field","name":{"kind":"Name","value":"sharedAwards"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"}},{"kind":"Field","name":{"kind":"Name","value":"topBuyerKey"}},{"kind":"Field","name":{"kind":"Name","value":"topBuyerName"}},{"kind":"Field","name":{"kind":"Name","value":"topBuyerShare"}},{"kind":"Field","name":{"kind":"Name","value":"topBuyerValue"}},{"kind":"Field","name":{"kind":"Name","value":"topBuyerTotal"}},{"kind":"Field","name":{"kind":"Name","value":"mandateAwards"}},{"kind":"Field","name":{"kind":"Name","value":"mandateValue"}},{"kind":"Field","name":{"kind":"Name","value":"mandateOfficials"}},{"kind":"Field","name":{"kind":"Name","value":"cobidders"}},{"kind":"Field","name":{"kind":"Name","value":"councilInterest"}},{"kind":"Field","name":{"kind":"Name","value":"councilInterestValue"}},{"kind":"Field","name":{"kind":"Name","value":"councilInterestNamesakes"}},{"kind":"Field","name":{"kind":"Name","value":"holdingsUndated"}},{"kind":"Field","name":{"kind":"Name","value":"topPartyKey"}},{"kind":"Field","name":{"kind":"Name","value":"topPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"topPartyShare"}},{"kind":"Field","name":{"kind":"Name","value":"topPartyValue"}},{"kind":"Field","name":{"kind":"Name","value":"councilPartyKey"}},{"kind":"Field","name":{"kind":"Name","value":"councilPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"councilPartyShare"}},{"kind":"Field","name":{"kind":"Name","value":"councilMajorityValue"}},{"kind":"Field","name":{"kind":"Name","value":"flaggedAwards"}},{"kind":"Field","name":{"kind":"Name","value":"flaggedValue"}}]}}]}}]} as unknown as DocumentNode<SignalLeadsQuery, SignalLeadsQueryVariables>;
export const SubsidyDossierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidyDossier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subsidy_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidy_id"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"project_title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_value"}},{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"duration_months"}},{"kind":"Field","name":{"kind":"Name","value":"places"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legal_form"}}]}}]}}]}}]} as unknown as DocumentNode<SubsidyDossierQuery, SubsidyDossierQueryVariables>;
export const SubsidiesUnderMeasureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidiesUnderMeasure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measure"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"NOT"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subsidy_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"amount"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidy_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<SubsidiesUnderMeasureQuery, SubsidiesUnderMeasureQueryVariables>;
export const TenderRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenderRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenderWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenderSort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tender_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"procuring_entity"}},{"kind":"Field","name":{"kind":"Name","value":"publication_date"}},{"kind":"Field","name":{"kind":"Name","value":"awarded_amount"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_bgn"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"cpv_code"}},{"kind":"Field","name":{"kind":"Name","value":"cpv_description"}},{"kind":"Field","name":{"kind":"Name","value":"procedure_type"}},{"kind":"Field","name":{"kind":"Name","value":"winner_count"}},{"kind":"Field","name":{"kind":"Name","value":"lot_count"}},{"kind":"Field","name":{"kind":"Name","value":"offers_count"}},{"kind":"Field","name":{"kind":"Name","value":"is_eu_funded"}},{"kind":"Field","name":{"kind":"Name","value":"commissionedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"procuredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<TenderRowsQuery, TenderRowsQueryVariables>;
export const TenderFacetCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenderFacetCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenderFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenderFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TenderFacetCountsQuery, TenderFacetCountsQueryVariables>;
export const CompanyRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legal_form"}},{"kind":"Field","name":{"kind":"Name","value":"seatedIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tendersWonAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDebtsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treasuryPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment_count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<CompanyRowsQuery, CompanyRowsQueryVariables>;
export const CompanyFacetCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyFacetCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyFacetCountsQuery, CompanyFacetCountsQueryVariables>;
export const PersonRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonSort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company_links"}},{"kind":"Field","name":{"kind":"Name","value":"ownedCompaniesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managedCompaniesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elected_year"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"elected_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nominatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"peopleAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<PersonRowsQuery, PersonRowsQueryVariables>;
export const MunicipalityRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MunicipalityRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MunicipalityWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MunicipalitySort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipalities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"population_permanent"}},{"kind":"Field","name":{"kind":"Name","value":"tender_total_bgn"}},{"kind":"Field","name":{"kind":"Name","value":"spend_per_capita"}},{"kind":"Field","name":{"kind":"Name","value":"tendersAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mayorsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elected_year"}},{"kind":"Field","name":{"kind":"Name","value":"term_end"}},{"kind":"Field","name":{"kind":"Name","value":"elected_round"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person_hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedByConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"election_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipalitiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<MunicipalityRowsQuery, MunicipalityRowsQueryVariables>;
export const SubsidyRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidyRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidyWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidySort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidy_id"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"project_title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<SubsidyRowsQuery, SubsidyRowsQueryVariables>;
export const PersonFacetCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonFacetCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<PersonFacetCountsQuery, PersonFacetCountsQueryVariables>;
export const MunicipalityFacetCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MunicipalityFacetCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MunicipalityFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipalityFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<MunicipalityFacetCountsQuery, MunicipalityFacetCountsQueryVariables>;
export const SubsidyFacetCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidyFacetCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidyFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidyFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SubsidyFacetCountsQuery, SubsidyFacetCountsQueryVariables>;